export default {
    "en": {
        "Concurrent logins error message": "You've already logged with user name {name}, you can't login until logout last session. Do you still wan't to login? (We will log out your last session)",
        "Inherited permission from role": "Inherited permission {permission} from role",
        "Unregistered session error message": "You signed out because of signing in as a same user account.",
        "auth.failed": "These credentials do not match our records.",
        "auth.throttle": "Too many login attempts. Please try again in {seconds} seconds.",
        "candidates.btn_merge": "Integrating Data",
        "candidates.created_at": "Registered Date",
        "candidates.email": "Email (Normal)",
        "candidates.id": "ID",
        "candidates.is_possible_bulk_mail": "Possible To Send Bulk Mail",
        "candidates.name": "Name",
        "candidates.portable_email": "Email (Portable)",
        "candidates.title_create": "Candidate Create",
        "candidates.title_edit": "Candidate Edit",
        "candidates.title_index": "Candidate Search Result",
        "candidates.title_search": "Candidate Search",
        "common.add": "Add",
        "common.add_search_condition": "Add this search condition to my favorites",
        "common.basic": "Basic",
        "common.cancel": "Cancel",
        "common.candidates": "Candidates",
        "common.clone": "Clone",
        "common.companies": "Companies",
        "common.create": "Create",
        "common.dash_board": "Dash Board",
        "common.delete": "Delete",
        "common.detail": "Detail",
        "common.display_item": "Display Item",
        "common.distribute": "Distribute",
        "common.edit": "Edit",
        "common.email": "Email",
        "common.import": "Import",
        "common.jobs": "Jobs",
        "common.logout": "Logout",
        "common.mailbox": "MailBox",
        "common.main_menu": "Main Menu",
        "common.manipulation": "Manipulation",
        "common.my_page": "Personal Page",
        "common.reflect": "Reflect",
        "common.register": "Register",
        "common.search": "Search",
        "common.search_delete": "Search deleted items",
        "common.see_more": "See More",
        "common.select_favorite_search": "Please select your favorite search condition.",
        "common.submit": "Submit",
        "common.update": "Update",
        "companies.staffs.deleted.name": "(Deleted)",
        "companies.title_create": "Company Create",
        "companies.title_edit": "Company Edit",
        "companies.title_index": "Company Search Result",
        "companies.title_search": "Company Search",
        "deny": "Deny",
        "error_message.transaction_failed_exception.default": "Failed {method} request.",
        "error_message.transaction_failed_exception.delete": "Failed to delete records.",
        "error_message.transaction_failed_exception.post": "Failed to create new records.",
        "error_message.transaction_failed_exception.put": "Failed to update records.",
        "error_message.user_resigned_exception.default": "User accounts of resigned employees are not authorized to login.",
        "grant": "Grant",
        "importData.import": "Import",
        "importData.import_succeeded": "Import succeeded",
        "importData.name": "Import Setting",
        "importData.select_file": "Please select file",
        "importSettings.column": "Column",
        "importSettings.csv_column": "CSV Column",
        "importSettings.file_category": "File categiry",
        "importSettings.file_category.csv": "CSV (Comma-separated) (*.csv)",
        "importSettings.file_category.tsv": "TSV (Tab-separated) (*.txt, *.tsv)",
        "importSettings.ignore_first_line": "Ignore first line",
        "importSettings.ignore_first_line.no": "No",
        "importSettings.ignore_first_line.yes": "Yes",
        "importSettings.name": "Name",
        "importSettings.property_column": "Property column",
        "importSettings.property_table": "Property table",
        "importSettings.replacement": "Replacement",
        "importSettings.replacement.mode": "Mode",
        "importSettings.replacement.new_string": "New string",
        "importSettings.replacement.old_string": "Old string",
        "importSettings.replacement.partial_matching": "Partial Matching",
        "importSettings.replacement.perfect_matching": "Perfect Matching",
        "importSettings.replacement.position": "Position",
        "importSettings.replacement.priority": "Priority",
        "jobs.department": "Department",
        "jobs.id": "Job ID",
        "jobs.industry_id": "Type of Industry",
        "jobs.occupation_id": "Type of a Job",
        "jobs.title_create": "Job Create",
        "jobs.title_edit": "Job Edit",
        "jobs.title_index": "Job Search Result",
        "jobs.title_search": "Job Search",
        "mailTemplates.category": "Category",
        "mailTemplates.is_shared": "Shareable",
        "mailTemplates.text": "Content",
        "mailTemplates.title": "Title",
        "mails.batching.append_to_bottom": "Append to bottom",
        "mails.batching.append_to_top": "Append to top",
        "mails.batching.attach": "Attach",
        "mails.batching.attach_user_property_1": "Attach user's",
        "mails.batching.attach_user_property_2": "to cursor's position",
        "mails.batching.attachments": "Attachments",
        "mails.batching.body": "Body",
        "mails.batching.case_name": "cases",
        "mails.batching.creat_email": "Create Mail",
        "mails.batching.duplicate_cases": "Duplicated Cases",
        "mails.batching.empty_cases": "Empty Cases",
        "mails.batching.error": "Invalid Emails",
        "mails.batching.from": "From",
        "mails.batching.id": "ID",
        "mails.batching.include_subject": "Include Subject",
        "mails.batching.invalid_cases": "Invalid Cases",
        "mails.batching.name": "Name",
        "mails.batching.nonduplicate_cases": "Nonduplicated Cases",
        "mails.batching.nonpossible_cases": "Nonpossible Cases",
        "mails.batching.recipients": "Recipients",
        "mails.batching.review": "View",
        "mails.batching.review_recipients": "View Recipients",
        "mails.batching.send": "Send",
        "mails.batching.send_all": "Sent Bulk Mail (Both Normal And Portable Emails)",
        "mails.batching.send_button": "Send Batch Mail",
        "mails.batching.send_indefinite": "Send Bulk Mail",
        "mails.batching.send_normals": "Send Bulk Mail (Normal Emails)",
        "mails.batching.send_portables": "Sent Bulk Mail (Portable Emails)",
        "mails.batching.sendable_cases": "Sendable Cases",
        "mails.batching.sent": "Sent",
        "mails.batching.signature": "Signature",
        "mails.batching.step1": "STEP1. Last Transmission",
        "mails.batching.step2": "STEP1. STEP2. Confirm Email Addresses",
        "mails.batching.step3": "STEP3. Create Email",
        "mails.batching.subject": "Subject",
        "mails.batching.template": "Template",
        "mails.batching.to": "To",
        "mails.batching.total": "Total",
        "mails.batching.unsent": "Unsent",
        "messages.delete": "Do you really want to delete this?",
        "messages.error": "An error occurred. Please reload.",
        "messages.no": "No",
        "messages.nodata": "Data is not registered",
        "messages.please_select": "Please Select",
        "messages.saved": "Saving is completed",
        "messages.saving": "You are saving...",
        "messages.yes": "Yes",
        "pagination.next": "Next &raquo;",
        "pagination.previous": "&laquo; Previous",
        "passwords.password": "Passwords must be at least six characters and match the confirmation.",
        "passwords.reset": "Your password has been reset!",
        "passwords.sent": "We have e-mailed your password reset link!",
        "passwords.token": "This password reset token is invalid.",
        "passwords.user": "We can't find a user with that e-mail address.",
        "permission": "Permission",
        "revisions.title": "Revision History",
        "revisions.title_basic": "Revision History(Basic Information)",
        "route": "Route",
        "search_criterion.date_format": "Y-n-j",
        "search_criterion.month_format": "Y-n",
        "staffs.company_name": "Company Name",
        "staffs.department": "Department",
        "staffs.email": "Email",
        "staffs.id": "ID",
        "staffs.is_possible_bulk_mail": "Possible To Send Bulk Mail",
        "staffs.name": "Name",
        "user_roles.administrative_privileges": "Administrative Privileges",
        "user_roles.general_privileges": "General Privileges",
        "users.display_name": "Name",
        "users.edit": "Staff Setting",
        "users.email": "Email",
        "users.enabled": "Enable",
        "users.locale_id": "Language",
        "users.name": "Login Name",
        "users.password": "Password",
        "users.password_confirm": "Password Confirmation",
        "users.timezone_id": "Timezone",
        "users.title": "Staffs",
        "users.title_all": "All Staffs",
        "users.user_role_id": "Authority",
        "validation.accepted": "The {attribute} must be accepted.",
        "validation.active_url": "The {attribute} is not a valid URL.",
        "validation.after": "The {attribute} must be a date after {date}.",
        "validation.alpha": "The {attribute} may only contain letters.",
        "validation.alpha_dash": "The {attribute} may only contain letters, numbers, and dashes.",
        "validation.alpha_num": "The {attribute} may only contain letters and numbers.",
        "validation.array": "The {attribute} must be an array.",
        "validation.before": "The {attribute} must be a date before {date}.",
        "validation.between.array": "The {attribute} must have between {min} and {max} items.",
        "validation.between.file": "The {attribute} must be between {min} and {max} kilobytes.",
        "validation.between.numeric": "The {attribute} must be between {min} and {max}.",
        "validation.between.string": "The {attribute} must be between {min} and {max} characters.",
        "validation.boolean": "The {attribute} field must be true or false.",
        "validation.confirmed": "The {attribute} confirmation does not match.",
        "validation.custom.attribute-name.rule-name": "custom-message",
        "validation.date": "The {attribute} is not a valid date.",
        "validation.date_format": "The {attribute} does not match the format {format}.",
        "validation.different": "The {attribute} and {other} must be different.",
        "validation.digits": "The {attribute} must be {digits} digits.",
        "validation.digits_between": "The {attribute} must be between {min} and {max} digits.",
        "validation.distinct": "The {attribute} field has a duplicate value.",
        "validation.email": "The {attribute} must be a valid email address.",
        "validation.exists": "The selected {attribute} is invalid.",
        "validation.filled": "The {attribute} field is required.",
        "validation.image": "The {attribute} must be an image.",
        "validation.in": "The selected {attribute} is invalid.",
        "validation.in_array": "The {attribute} field does not exist in {other}.",
        "validation.integer": "The {attribute} must be an integer.",
        "validation.ip": "The {attribute} must be a valid IP address.",
        "validation.json": "The {attribute} must be a valid JSON string.",
        "validation.max.array": "The {attribute} may not have more than {max} items.",
        "validation.max.file": "The {attribute} may not be greater than {max} kilobytes.",
        "validation.max.numeric": "The {attribute} may not be greater than {max}.",
        "validation.max.string": "The {attribute} may not be greater than {max} characters.",
        "validation.mimes": "The {attribute} must be a file of type: {values}.",
        "validation.min.array": "The {attribute} must have at least {min} items.",
        "validation.min.file": "The {attribute} must be at least {min} kilobytes.",
        "validation.min.numeric": "The {attribute} must be at least {min}.",
        "validation.min.string": "The {attribute} must be at least {min} characters.",
        "validation.not_in": "The selected {attribute} is invalid.",
        "validation.numeric": "The {attribute} must be a number.",
        "validation.present": "The {attribute} field must be present.",
        "validation.regex": "The {attribute} format is invalid.",
        "validation.required": "The {attribute} field is required.",
        "validation.required_if": "The {attribute} field is required when {other} is {value}.",
        "validation.required_unless": "The {attribute} field is required unless {other} is in {values}.",
        "validation.required_with": "The {attribute} field is required when {values} is present.",
        "validation.required_with_all": "The {attribute} field is required when {values} is present.",
        "validation.required_without": "The {attribute} field is required when {values} is not present.",
        "validation.required_without_all": "The {attribute} field is required when none of {values} are present.",
        "validation.same": "The {attribute} and {other} must match.",
        "validation.size.array": "The {attribute} must contain {size} items.",
        "validation.size.file": "The {attribute} must be {size} kilobytes.",
        "validation.size.numeric": "The {attribute} must be {size}.",
        "validation.size.string": "The {attribute} must be {size} characters.",
        "validation.string": "The {attribute} must be a string.",
        "validation.timezone": "The {attribute} must be a valid zone.",
        "validation.unique": "The {attribute} has already been taken.",
        "validation.url": "The {attribute} format is invalid."
    },
    "cht": {
        "common.email": "電子郵件",
        "common.logout": "註銷",
        "common.manipulation": "操作",
        "user_roles.administrative_privileges": "管理員權限",
        "user_roles.general_privileges": "一般授權",
        "users.display_name": "全名",
        "users.edit": "該負責人設置",
        "users.email": "電子郵件",
        "users.locale_id": "語言",
        "users.name": "登錄名",
        "users.password": "密碼",
        "users.password_confirm": "密碼確認",
        "users.timezone_id": "時區",
        "users.title": "該負責人",
        "users.user_role_id": "權威"
    },
    "ja": {
        "Concurrent logins error message": "既に{name}でログインしています。ログインを続けた場合、現在ログインしているユーザーは自動的にログアウトされます。ログインを続けますか？",
        "Inherited permission from role": "Inherited permission {permission} from role",
        "No query results for model": "対象のデータがございません。",
        "The interviewer and the job are not belong to a same company": "面接担当と求人案件は同じ会社に属しません",
        "The staff is not belong to the company": "担当者は会社に属しません。",
        "Unregistered session error message": "一定時間操作がないか同じアカウントでログインがありましたのでログアウトします。",
        "alert.after": "日後",
        "alert.all": "全社共通のアラート",
        "alert.before": "日前",
        "alert.dashboard": "ダッシュ\nボード",
        "alert.description": "アラート文",
        "alert.detail": "アラート内容",
        "alert.detail_menu.count_text": "アラートが{count}件あります",
        "alert.index.sub_title": "設定した条件に合致したアラートの確認が出来ます。",
        "alert.make_all_as_read": "すべてのアラートを既読にする",
        "alert.menu_about": "アラート設定でできること",
        "alert.menu_about_description": "共通ヘッダーやダッシュボード、各一覧・詳細画面へのアラートの通知や、その表示タイミングやアラート文の設定が可能です。",
        "alert.message_after": "{state}から{days}日が経過しました。",
        "alert.message_before": "{state}まで{days}日になります。",
        "alert.message_today": "{state}当日になります。",
        "alert.myself": "自分のみのアラート",
        "alert.not_alerts": "アラートはありません",
        "alert.open_alert.index": "アラート画面を開く",
        "alert.pass": "[[経過日数]]日が経過しています。",
        "alert.placeholder": "例) メールを送信してください。",
        "alert.popup_title": "アラート",
        "alert.select_tab_item.all": "すべて",
        "alert.select_tab_item.apply": "進捗",
        "alert.select_tab_item.billing-destinations": "請求先",
        "alert.select_tab_item.candidate-activities": "人材対応",
        "alert.select_tab_item.candidates": "人材",
        "alert.select_tab_item.companies": "会社",
        "alert.select_tab_item.company-activities": "会社対応",
        "alert.select_tab_item.contracts": "契約",
        "alert.select_tab_item.dispatch-destinations": "派遣先",
        "alert.select_tab_item.dispatch-jobs": "派遣求人",
        "alert.select_tab_item.dispatch-organization-units": "組織単位",
        "alert.select_tab_item.dispatch-source-staffs": "派遣元担当者",
        "alert.select_tab_item.dispatch-sources": "派遣元",
        "alert.select_tab_item.dispatch-staffs": "派遣先担当者",
        "alert.select_tab_item.dispatch-working-places": "就業現場",
        "alert.select_tab_item.jobs": "紹介求人",
        "alert.select_tab_item.sales": "売上",
        "alert.select_tab_item.staffs": "会社担当者",
        "alert.select_tab_item.summary": "サマリー",
        "alert.start": "表示開始",
        "alert.status.all_notifications": "過去の全ての通知",
        "alert.status.currently_valid_only": "現在有効なアラートのみ",
        "alert.target_company": "自社会社担当",
        "alert.target_staff": "自社人材担当",
        "alert.title": "アラート設定",
        "alert.title_description": "ダッシュボード・お知らせ・タスク画面に表示されるアラートの内容を設定できます",
        "alert.title_description_only_dashboard": "ダッシュボード画面に表示されるアラートの内容を設定できます",
        "alert_setting.accordion.condition_value": "条件",
        "alert_setting.accordion.conditions": "詳細条件",
        "alert_setting.accordion.memo": "メモ",
        "alert_setting.accordion.notification_users": "通知ユーザー",
        "alert_setting.accordion.search_mode.name": "条件指定",
        "alert_setting.button.create": "新規アラート追加",
        "alert_setting.check.enable": "有効にする",
        "alert_setting.column.auto_state": "ステータス変更",
        "alert_setting.column.condition_value": "条件",
        "alert_setting.column.display_name": "アラート名称",
        "alert_setting.column.is_enabled": "有効／無効",
        "alert_setting.column.message": "アラート文",
        "alert_setting.column.operations": "操作",
        "alert_setting.column.resource": "対象データ",
        "alert_setting.condition.pass_days.after": "日後",
        "alert_setting.condition.pass_days.before": "日前",
        "alert_setting.condition.pass_hours.after": "時間後",
        "alert_setting.condition.pass_hours.before": "時間前",
        "alert_setting.error.saving": "反映できませんでした: {name}",
        "alert_setting.label.auto_state": "アラート時ステータス変更",
        "alert_setting.label.condition_value": "条件",
        "alert_setting.label.conditions": "詳細条件",
        "alert_setting.label.display_name": "アラート名称",
        "alert_setting.label.memo": "メモ",
        "alert_setting.label.message": "アラート文",
        "alert_setting.label.notification_users": "通知ユーザー",
        "alert_setting.label.resource": "アラート対象",
        "alert_setting.label.search_mode.name": "条件指定",
        "alert_setting.modal.button.add_condition": "＋対象データに詳細条件を追加する",
        "alert_setting.modal.button.cancel": "キャンセル",
        "alert_setting.modal.button.open.replace_editor": "置き換え文字入力",
        "alert_setting.modal.button.reflect": "反映する",
        "alert_setting.modal.title.create": "新規アラートの追加",
        "alert_setting.modal.title.edit": "アラート設定の編集",
        "alert_setting.replace_editor.placeholder.category": "置き換え文字カテゴリー",
        "alert_setting.replace_editor.placeholder.column": "置き換え文字を選択",
        "alert_setting.replace_editor.title": "置き換え文字の入力",
        "alert_setting.row.deleted_auto_state": "削除済み項目",
        "alert_setting.row.deleted_condition_model": "削除済み項目",
        "alert_setting.row.deleted_condition_model.cannot_enabled": "削除済み項目がアラート対象になっているため有効にできません",
        "alert_setting.row.search_mode.name": "条件指定",
        "alert_setting.row.search_mode.name.null": "指定なし",
        "amount_over_short.delete_confirm.message": "この過不足金設定を削除してよろしいですか？",
        "amount_over_short.delete_confirm.message1": "この過不足金設定のみ削除してよろしいですか？",
        "amount_over_short.delete_confirm.message2": "（この設定のみ削除され、他の繰り返し設定は残ります。）",
        "amount_over_short.empty_name": "過不足金名なし",
        "amount_over_short.no_registration": "過不足金の登録がありません",
        "api.resource.account": "自社情報",
        "api.resource.alert-notifications": "アラート通知",
        "api.resource.alerts": "アラート",
        "api.resource.amount-over-shorts": "過不足金",
        "api.resource.apply": "進捗",
        "api.resource.attendances": "勤怠",
        "api.resource.billing-destinations": "請求先",
        "api.resource.candidate-activities": "対応（人材）",
        "api.resource.candidates": "人材",
        "api.resource.closed-attendance-invoices": "請求（勤怠締め）",
        "api.resource.closed-attendance-payments": "支払（勤怠締め）",
        "api.resource.companies": "会社",
        "api.resource.company-activities": "対応（会社）",
        "api.resource.conflict-date-managements": "抵触日",
        "api.resource.contract-attendance-invoices": "請求（勤怠）",
        "api.resource.contract-attendance-payments": "支払（勤怠）",
        "api.resource.contracts": "契約",
        "api.resource.dispatch-destinations": "派遣先",
        "api.resource.dispatch-jobs": "派遣求人",
        "api.resource.dispatch-organization-units": "組織単位",
        "api.resource.dispatch-source-staffs": "派遣元担当者",
        "api.resource.dispatch-sources": "派遣元",
        "api.resource.dispatch-staffs": "派遣先担当者",
        "api.resource.dispatch-working-places": "就業現場",
        "api.resource.files": "ファイル",
        "api.resource.invoice-amount-over-shorts": "過不足金（請求）",
        "api.resource.invoice-attendances": "勤怠（請求）",
        "api.resource.invoices": "請求",
        "api.resource.jobs": "紹介求人",
        "api.resource.line-options": "LINEお知らせ",
        "api.resource.mails": "メール",
        "api.resource.masters": "マスタ",
        "api.resource.notifications": "お知らせ",
        "api.resource.payment-amount-over-shorts": "過不足金（支払）",
        "api.resource.payment-attendances": "勤怠（支払）",
        "api.resource.payments": "支払",
        "api.resource.sales": "売上\/返金",
        "api.resource.schedules": "スケジュール",
        "api.resource.staffs": "会社担当者",
        "api.resource.tasks": "タスク",
        "api.resource.users": "自社担当者",
        "api.scope.destroy": "削除",
        "api.scope.search": "検索",
        "api.scope.show": "取得",
        "api.scope.store": "登録",
        "api.scope.update": "更新",
        "api_setting.button.check_all_scopes": "全てに付与",
        "api_setting.button.create": "APIのクライアントを追加する",
        "api_setting.button.reset_scopes": "元に戻す",
        "api_setting.client.access_count": "当月アクセス数",
        "api_setting.client.allow_ip_addresses": "許容IP",
        "api_setting.client.allow_redirect_uri": "許容リダイレクト先",
        "api_setting.client.id": "client_id",
        "api_setting.client.name": "クライアント名",
        "api_setting.client.scope": "付与されている権限",
        "api_setting.client.secret": "client_secret",
        "api_setting.client.total_access_count": "合計アクセス数",
        "api_setting.create.sub_title": "APIクライアントを登録できます。",
        "api_setting.edit.client.allow_ip_addresses": "許容IP",
        "api_setting.edit.client.grant_type": "認可方式",
        "api_setting.edit.client.is_enabled": "無効\/有効",
        "api_setting.edit.client.is_enabled.off": "無効",
        "api_setting.edit.client.is_enabled.on": "有効",
        "api_setting.edit.client.is_enforce_token_owner_restriction": "同一接続元制限",
        "api_setting.edit.client.is_enforce_token_owner_restriction.description": "有効にすると、発行元のIPアドレスからのみアクセストークンを使用できます",
        "api_setting.edit.client.is_enforce_token_owner_restriction.off": "無効",
        "api_setting.edit.client.is_enforce_token_owner_restriction.on": "有効",
        "api_setting.edit.client.name": "クライアント名",
        "api_setting.edit.client.redirect_uri": "許容リダイレクト先",
        "api_setting.edit.client.scope": "付与する権限",
        "api_setting.edit.client.user": "紐つけるユーザー",
        "api_setting.edit.client.user.select": "紐つけるユーザー ▼",
        "api_setting.edit.sub_title": "APIクライアントを編集できます。",
        "api_setting.index.client.allow_ip_addresses.placeholder": "172.20.100.52\/26\n192.168.0.1\/32",
        "api_setting.index.client.name.placeholder": "MyApiClient",
        "api_setting.index.client_secret.show": "表示する",
        "api_setting.index.sub_title": "APIに紐づけられたクライアントの一覧です。",
        "api_setting.index.title": "API設定",
        "api_setting.oauth.authorization_code": "Authorization code",
        "api_setting.oauth.client_credentials": "Client credentials",
        "apply.download_file": "データ入りファイルをダウンロード",
        "apply.make_apply_mail": "推薦メールを作成",
        "apply.select_staff": "担当者を選択する",
        "apply.step.make_apply_mail.title": "推薦メールを作成",
        "apply.step.select_attached_file.description": "企業に送る書類にチェックを入れて、ファイル名を入力して下さい。",
        "apply.step.select_attached_file.title": "添付する書類を選ぶ",
        "apply.step.select_staff.description": "推薦メールを送る会社担当者にチェックをいれて下さい。",
        "apply.step.select_staff.title": "担当者を選択",
        "apply.title": "企業に推薦する",
        "apply.to_company": "推薦先",
        "auth.automatic_login": "次回から自動ログインする",
        "auth.login": "ログイン",
        "auth.password_forgotten": "パスワードをお忘れの方はこちら",
        "billing_destinations.billing_destination_list": "請求先一覧",
        "billing_destinations.import.title": "インポート(請求先)",
        "billing_destinations.list_back": "請求先一覧に戻る",
        "billing_destinations.no_assign_user": "自社請求先担当者未設定の請求先",
        "billing_destinations.no_billing_destination": "請求先が登録されていません",
        "billing_destinations.select_company": "請求先の会社名を検索 ▼",
        "billing_destinations.show.billing_destinations": "請求先詳細",
        "billing_destinations.user": "自社請求先担当者",
        "billing_destinations.user_change": "自社請求先担当者を変更",
        "billing_destinations.user_department": "自社請求先担当者\/部署",
        "breadcrumbs.alerts.index": "アラート",
        "breadcrumbs.api_setting.create": "APIクライアント登録",
        "breadcrumbs.api_setting.edit": "APIクライアント編集",
        "breadcrumbs.api_setting.index": "API設定",
        "breadcrumbs.billing_destinations.create": "請求先追加",
        "breadcrumbs.billing_destinations.edit": "請求先編集",
        "breadcrumbs.billing_destinations.import": "請求先インポート",
        "breadcrumbs.billing_destinations.index": "請求先一覧",
        "breadcrumbs.billing_destinations.indexTrashed": "請求先一覧(ゴミ箱)",
        "breadcrumbs.billing_destinations.show": "請求先詳細",
        "breadcrumbs.billing_destinations.showTrashed": "請求先詳細(ゴミ箱)",
        "breadcrumbs.candidate_career_counsellings.create": "キャリア相談登録",
        "breadcrumbs.candidate_career_counsellings.edit": "キャリア相談編集",
        "breadcrumbs.candidate_career_counsellings.import": "キャリア相談インポート",
        "breadcrumbs.candidate_career_counsellings.index": "キャリア相談一覧",
        "breadcrumbs.candidate_career_counsellings.indexTrashed": "キャリア相談一覧(ゴミ箱)",
        "breadcrumbs.candidate_career_counsellings.show": "キャリア相談詳細",
        "breadcrumbs.candidate_career_counsellings.showTrashed": "キャリア相談詳細(ゴミ箱)",
        "breadcrumbs.candidate_education_and_trainings.create": "教育訓練登録",
        "breadcrumbs.candidate_education_and_trainings.edit": "教育訓練編集",
        "breadcrumbs.candidate_education_and_trainings.import": "教育訓練インポート",
        "breadcrumbs.candidate_education_and_trainings.index": "教育訓練一覧",
        "breadcrumbs.candidate_education_and_trainings.indexTrashed": "教育訓練一覧(ゴミ箱)",
        "breadcrumbs.candidate_education_and_trainings.show": "教育訓練詳細",
        "breadcrumbs.candidate_education_and_trainings.showTrashed": "教育訓練詳細(ゴミ箱)",
        "breadcrumbs.candidate_employment_placement_dispatches.create": "紹介予定派遣登録",
        "breadcrumbs.candidate_employment_placement_dispatches.edit": "紹介予定派遣編集",
        "breadcrumbs.candidate_employment_placement_dispatches.import": "紹介予定派遣インポート",
        "breadcrumbs.candidate_employment_placement_dispatches.index": "紹介予定派遣一覧",
        "breadcrumbs.candidate_employment_placement_dispatches.indexTrashed": "紹介予定派遣一覧(ゴミ箱)",
        "breadcrumbs.candidate_employment_placement_dispatches.show": "紹介予定派遣詳細",
        "breadcrumbs.candidate_employment_placement_dispatches.showTrashed": "紹介予定派遣詳細(ゴミ箱)",
        "breadcrumbs.candidate_employment_stability_measures.create": "雇用安定措置登録",
        "breadcrumbs.candidate_employment_stability_measures.edit": "雇用安定措置編集",
        "breadcrumbs.candidate_employment_stability_measures.import": "雇用安定措置インポート",
        "breadcrumbs.candidate_employment_stability_measures.index": "雇用安定措置一覧",
        "breadcrumbs.candidate_employment_stability_measures.indexTrashed": "雇用安定措置一覧(ゴミ箱)",
        "breadcrumbs.candidate_employment_stability_measures.show": "雇用安定措置詳細",
        "breadcrumbs.candidate_employment_stability_measures.showTrashed": "雇用安定措置詳細(ゴミ箱)",
        "breadcrumbs.candidate_job_step_resources.index": "進捗一覧",
        "breadcrumbs.candidate_job_steps.import": "進捗インポート",
        "breadcrumbs.candidate_job_steps.index": "マスター設定(進捗項目)",
        "breadcrumbs.candidate_steps.import": "人材対応インポート",
        "breadcrumbs.candidate_steps.index": "人材対応一覧",
        "breadcrumbs.candidates.create": "人材登録",
        "breadcrumbs.candidates.duplicate": "重複人材",
        "breadcrumbs.candidates.edit": "人材編集",
        "breadcrumbs.candidates.import": "人材インポート",
        "breadcrumbs.candidates.index": "人材一覧",
        "breadcrumbs.candidates.indexTrashed": "人材一覧(ゴミ箱)",
        "breadcrumbs.candidates.index_no_users": "人材一覧(自社担当者未設定)",
        "breadcrumbs.candidates.matching": "人材マッチング",
        "breadcrumbs.candidates.show": "人材詳細",
        "breadcrumbs.candidates.showMerge": "人材データ統合",
        "breadcrumbs.candidates.showTrashed": "人材詳細(ゴミ箱)",
        "breadcrumbs.companies.create": "会社登録",
        "breadcrumbs.companies.edit": "会社編集",
        "breadcrumbs.companies.import": "会社インポート",
        "breadcrumbs.companies.index": "会社一覧",
        "breadcrumbs.companies.indexTrashed": "会社一覧(ゴミ箱)",
        "breadcrumbs.companies.show": "会社詳細",
        "breadcrumbs.companies.showTrashed": "会社詳細(ゴミ箱)",
        "breadcrumbs.companies.staffs.create": "会社担当者登録",
        "breadcrumbs.companies.staffs.edit": "会社担当者編集",
        "breadcrumbs.companies.staffs.show": "会社担当者詳細",
        "breadcrumbs.companies.staffs.showTrashed": "会社担当詳細(ゴミ箱)",
        "breadcrumbs.company_steps.import": "会社対応インポート",
        "breadcrumbs.company_steps.index": "会社対応一覧",
        "breadcrumbs.conflict_date_defaults.create": "契約時の人材毎の抵触日(登録)",
        "breadcrumbs.conflict_date_defaults.edit": "契約時の人材毎の抵触日(編集)",
        "breadcrumbs.conflict_date_managements.index": "抵触日一覧",
        "breadcrumbs.contract_memos.create": "契約メモ登録",
        "breadcrumbs.contract_memos.edit": "契約メモ編集",
        "breadcrumbs.contract_memos.show": "契約メモ詳細",
        "breadcrumbs.contract_memos.showTrashed": "契約メモ詳細(ゴミ箱)",
        "breadcrumbs.contracts.clone": "契約登録(複製)",
        "breadcrumbs.contracts.create": "契約登録",
        "breadcrumbs.contracts.edit": "契約編集",
        "breadcrumbs.contracts.import": "契約インポート",
        "breadcrumbs.contracts.index": "契約一覧",
        "breadcrumbs.contracts.indexTrashed": "契約一覧(ゴミ箱)",
        "breadcrumbs.contracts.show": "契約詳細",
        "breadcrumbs.contracts.showTrashed": "契約詳細(ゴミ箱)",
        "breadcrumbs.dashboard_candidates": "ダッシュボード(人材)",
        "breadcrumbs.dashboard_item_setting": "表示項目設定(ダッシュボード項目)",
        "breadcrumbs.dashboard_jobs": "ダッシュボード(求人)",
        "breadcrumbs.data": "集計",
        "breadcrumbs.data.reports": "法定帳票出力",
        "breadcrumbs.department_item_setting": "マスター設定(部署項目)",
        "breadcrumbs.dispatch_destinations.create": "派遣先登録",
        "breadcrumbs.dispatch_destinations.edit": "派遣先編集",
        "breadcrumbs.dispatch_destinations.import": "派遣先インポート",
        "breadcrumbs.dispatch_destinations.index": "派遣先一覧",
        "breadcrumbs.dispatch_destinations.indexTrashed": "派遣先一覧(ゴミ箱)",
        "breadcrumbs.dispatch_destinations.show": "派遣先詳細",
        "breadcrumbs.dispatch_destinations.showTrashed": "派遣先詳細(ゴミ箱)",
        "breadcrumbs.dispatch_item_setting": "派遣業務設定({modelName}マスター)",
        "breadcrumbs.dispatch_jobs.clone": "派遣求人の登録(複製)",
        "breadcrumbs.dispatch_jobs.create": "派遣求人の登録",
        "breadcrumbs.dispatch_jobs.edit": "派遣求人の編集",
        "breadcrumbs.dispatch_jobs.import": "派遣求人インポート",
        "breadcrumbs.dispatch_jobs.index": "派遣求人一覧",
        "breadcrumbs.dispatch_jobs.indexTrashed": "派遣求人一覧(ゴミ箱)",
        "breadcrumbs.dispatch_jobs.matching": "派遣求人マッチング",
        "breadcrumbs.dispatch_jobs.show": "派遣求人詳細",
        "breadcrumbs.dispatch_jobs.showTrashed": "派遣求人詳細(ゴミ箱)",
        "breadcrumbs.dispatch_organization_units.create": "組織単位登録",
        "breadcrumbs.dispatch_organization_units.edit": "組織単位編集",
        "breadcrumbs.dispatch_organization_units.import": "組織単位インポート",
        "breadcrumbs.dispatch_organization_units.index": "組織単位一覧",
        "breadcrumbs.dispatch_organization_units.indexTrashed": "組織単位一覧(ゴミ箱)",
        "breadcrumbs.dispatch_organization_units.show": "組織単位詳細",
        "breadcrumbs.dispatch_organization_units.showTrashed": "組織単位詳細(ゴミ箱)",
        "breadcrumbs.dispatch_source_career_staffs.create": "キャリア相談担当者登録",
        "breadcrumbs.dispatch_source_career_staffs.edit": "キャリア相談担当者編集",
        "breadcrumbs.dispatch_source_career_staffs.import": "キャリア相談担当者インポート",
        "breadcrumbs.dispatch_source_career_staffs.index": "キャリア相談担当者一覧",
        "breadcrumbs.dispatch_source_career_staffs.show": "キャリア相談担当者詳細",
        "breadcrumbs.dispatch_source_career_staffs.showTrashed": "キャリア相談担当者詳細(ゴミ箱)",
        "breadcrumbs.dispatch_source_education_training_careers.create": "教育訓練マスター登録：キャリアアップ",
        "breadcrumbs.dispatch_source_education_training_careers.edit": "教育訓練マスター編集：キャリアアップ",
        "breadcrumbs.dispatch_source_education_training_careers.import": "教育訓練マスターインポート：キャリアアップ",
        "breadcrumbs.dispatch_source_education_training_careers.index": "教育訓練マスター一覧：キャリアアップ",
        "breadcrumbs.dispatch_source_education_training_careers.show": "教育訓練マスター詳細：キャリアアップ",
        "breadcrumbs.dispatch_source_education_training_careers.showTrashed": "教育訓練マスター詳細(ゴミ箱)：キャリアアップ",
        "breadcrumbs.dispatch_source_education_training_others.create": "教育訓練マスター登録：その他",
        "breadcrumbs.dispatch_source_education_training_others.edit": "教育訓練マスター編集：その他",
        "breadcrumbs.dispatch_source_education_training_others.import": "教育訓練マスターインポート：その他",
        "breadcrumbs.dispatch_source_education_training_others.index": "教育訓練マスター一覧：その他",
        "breadcrumbs.dispatch_source_education_training_others.show": "教育訓練マスター詳細：その他",
        "breadcrumbs.dispatch_source_education_training_others.showTrashed": "教育訓練マスター詳細(ゴミ箱)：その他",
        "breadcrumbs.dispatch_source_education_training_safeties.create": "教育訓練マスター登録：安全衛生教育",
        "breadcrumbs.dispatch_source_education_training_safeties.edit": "教育訓練マスター編集：安全衛生教育",
        "breadcrumbs.dispatch_source_education_training_safeties.import": "教育訓練マスターインポート：安全衛生教育",
        "breadcrumbs.dispatch_source_education_training_safeties.index": "教育訓練マスター一覧：安全衛生教育",
        "breadcrumbs.dispatch_source_education_training_safeties.show": "教育訓練マスター詳細：安全衛生教育",
        "breadcrumbs.dispatch_source_education_training_safeties.showTrashed": "教育訓練マスター詳細(ゴミ箱)：安全衛生教育",
        "breadcrumbs.dispatch_source_staffs.create": "派遣元担当者登録",
        "breadcrumbs.dispatch_source_staffs.edit": "派遣元担当者編集",
        "breadcrumbs.dispatch_source_staffs.import": "派遣元担当者インポート",
        "breadcrumbs.dispatch_source_staffs.index": "派遣元担当者一覧",
        "breadcrumbs.dispatch_source_staffs.show": "派遣元担当者詳細",
        "breadcrumbs.dispatch_source_staffs.showTrashed": "派遣元担当者詳細(ゴミ箱)",
        "breadcrumbs.dispatch_sources.create": "派遣元登録",
        "breadcrumbs.dispatch_sources.edit": "派遣元編集",
        "breadcrumbs.dispatch_sources.import": "派遣元インポート",
        "breadcrumbs.dispatch_sources.index": "派遣元設定",
        "breadcrumbs.dispatch_sources.indexTrashed": "派遣元設定(ゴミ箱)",
        "breadcrumbs.dispatch_sources.show": "派遣元詳細",
        "breadcrumbs.dispatch_sources.showTrashed": "派遣元詳細(ゴミ箱)",
        "breadcrumbs.dispatch_staffs.create": "派遣先担当者登録",
        "breadcrumbs.dispatch_staffs.edit": "派遣先担当者編集",
        "breadcrumbs.dispatch_staffs.import": "派遣先担当者インポート",
        "breadcrumbs.dispatch_staffs.index": "派遣先担当者一覧",
        "breadcrumbs.dispatch_staffs.indexTrashed": "派遣先担当者一覧(ゴミ箱)",
        "breadcrumbs.dispatch_staffs.show": "派遣先担当者詳細",
        "breadcrumbs.dispatch_staffs.showTrashed": "派遣先担当者詳細(ゴミ箱)",
        "breadcrumbs.dispatch_working_places.create": "就業現場登録",
        "breadcrumbs.dispatch_working_places.edit": "就業現場編集",
        "breadcrumbs.dispatch_working_places.import": "就業現場インポート",
        "breadcrumbs.dispatch_working_places.index": "就業現場一覧",
        "breadcrumbs.dispatch_working_places.indexTrashed": "就業現場一覧(ゴミ箱)",
        "breadcrumbs.dispatch_working_places.show": "就業現場詳細",
        "breadcrumbs.dispatch_working_places.showTrashed": "就業現場詳細(ゴミ箱)",
        "breadcrumbs.export_setting.create": "エクスポート設定追加",
        "breadcrumbs.export_setting.edit": "エクスポート設定編集",
        "breadcrumbs.export_setting.index": "エクスポート設定",
        "breadcrumbs.free_items_group_item_setting": "マスター設定(選択肢項目)",
        "breadcrumbs.import_setting.create": "インポート設定追加",
        "breadcrumbs.import_setting.edit": "インポート設定編集",
        "breadcrumbs.import_setting.index": "インポート設定",
        "breadcrumbs.jobs.clone": "紹介求人登録(複製)",
        "breadcrumbs.jobs.create": "紹介求人登録",
        "breadcrumbs.jobs.edit": "紹介求人編集",
        "breadcrumbs.jobs.import": "紹介求人インポート",
        "breadcrumbs.jobs.index": "紹介求人一覧",
        "breadcrumbs.jobs.indexTrashed": "紹介求人一覧(ゴミ箱)",
        "breadcrumbs.jobs.index_no_users": "紹介求人一覧(自社担当者未設定)",
        "breadcrumbs.jobs.matching": "紹介求人マッチング",
        "breadcrumbs.jobs.share.index": "共有求人一覧",
        "breadcrumbs.jobs.share.show": "共有求人詳細",
        "breadcrumbs.jobs.show": "紹介求人詳細",
        "breadcrumbs.jobs.showTrashed": "紹介求人詳細(ゴミ箱)",
        "breadcrumbs.mailTemplates.create": "メールテンプレート追加",
        "breadcrumbs.mailTemplates.edit": "メールテンプレート編集",
        "breadcrumbs.mailTemplates.index": "メールテンプレート一覧",
        "breadcrumbs.mails.index": "メール",
        "breadcrumbs.mails.index.trash": "メール(ゴミ箱)",
        "breadcrumbs.mails.rootName.billing_destinations": "メール(請求先)",
        "breadcrumbs.mails.rootName.candidates": "メール(人材)",
        "breadcrumbs.mails.rootName.companies": "メール(会社)",
        "breadcrumbs.mails.rootName.dispatch_destinations": "メール(派遣先)",
        "breadcrumbs.mails.rootName.dispatch_organization_units": "メール(組織単位)",
        "breadcrumbs.mails.rootName.dispatch_staffs": "メール(派遣先担当者)",
        "breadcrumbs.mails.rootName.dispatch_working_places": "メール(就業現場)",
        "breadcrumbs.mails.rootName.staffs": "メール(会社担当者)",
        "breadcrumbs.notifications.index": "お知らせ",
        "breadcrumbs.release_notes.index": "新機能",
        "breadcrumbs.reports.create": "帳票設定追加",
        "breadcrumbs.reports.edit": "帳票設定編集",
        "breadcrumbs.reports.index": "帳票設定",
        "breadcrumbs.sales.create": "売上\/返金登録",
        "breadcrumbs.sales.edit": "売上\/返金編集",
        "breadcrumbs.sales.import": "売上インポート",
        "breadcrumbs.sales.index": "売上\/返金一覧",
        "breadcrumbs.sales.unregistered": "未登録売上一覧",
        "breadcrumbs.sales_refunds.create": "返金入力",
        "breadcrumbs.sales_refunds.edit": "返金入力",
        "breadcrumbs.schedule_adjustment": "面接日程調整",
        "breadcrumbs.schedule_item_setting": "マスター設定(スケジュール項目)",
        "breadcrumbs.setting.index": "各種設定",
        "breadcrumbs.settings.alerts.index": "アラート設定",
        "breadcrumbs.settings.item_setting_property_categories": "表示項目設定({primaryModelName}項目)",
        "breadcrumbs.settings.roles.index": "権限マスター設定",
        "breadcrumbs.settings.setting.index": "自社情報設定",
        "breadcrumbs.staffs.create": "会社担当者登録",
        "breadcrumbs.staffs.edit": "会社担当者編集",
        "breadcrumbs.staffs.import": "会社担当者インポート",
        "breadcrumbs.staffs.index": "会社担当者一覧",
        "breadcrumbs.staffs.indexTrashed": "会社担当者一覧(ゴミ箱)",
        "breadcrumbs.staffs.show": "会社担当者詳細",
        "breadcrumbs.staffs.showTrashed": "会社担当者詳細(ゴミ箱)",
        "breadcrumbs.step_state_item_setting": "マスター設定(対応項目)",
        "breadcrumbs.todo.progress": "未対応進捗",
        "breadcrumbs.users.create": "アカウント追加",
        "breadcrumbs.users.edit": "アカウント編集",
        "breadcrumbs.users.index": "アカウント情報",
        "calculation.error": "計算できませんでした。 計算式 {formula} と入力値を確認してください。",
        "calculation.error.setting": "計算式が設定されていません。",
        "calendar_moment_format": "Y年M月",
        "candidate.update_user_placeholder": "自社人材担当者 ▼",
        "candidate_career_counselling.list_name": "キャリア相談番号",
        "candidate_career_counsellings.candidate_career_counselling_list": "キャリア相談一覧",
        "candidate_career_counsellings.import.title": "インポート(キャリア相談)",
        "candidate_career_counsellings.list_back": "キャリア相談一覧に戻る",
        "candidate_career_counsellings.no_candidate_career_counselling": "キャリア相談は登録されていません。",
        "candidate_education_and_trainings.applicable_contract": "該当する契約",
        "candidate_education_and_trainings.applicable_contract.destination_select": "「実施日時」を入力してください。",
        "candidate_education_and_trainings.applicable_contract.help_message": "※実施日時が派遣期間に含まれている契約を選択肢として表示します。",
        "candidate_education_and_trainings.applicable_contract.initial": "実施者が「派遣先」の場合に契約を選択します。",
        "candidate_education_and_trainings.applicable_contract.not_exist": "「実施日時」が含まれている契約が存在しません。",
        "candidate_education_and_trainings.applicable_contract.not_exist_help_message": "※実施日時の入力を間違えていないか、または実施日時が派遣期間に含まれている契約が存在しているかを確認して下さい。",
        "candidate_education_and_trainings.candidate_education_and_training_list": "教育訓練一覧",
        "candidate_education_and_trainings.import.title": "インポート(教育訓練)",
        "candidate_education_and_trainings.list_back": "人材詳細に戻る",
        "candidate_education_and_trainings.list_name": "教育訓練番号",
        "candidate_education_and_trainings.no_candidate_education_and_training": "教育訓練は登録されていません。",
        "candidate_employment_placement_dispatches.candidate_employment_placement_dispatch_list": "紹介予定派遣一覧",
        "candidate_employment_placement_dispatches.no_candidate_employment_placement_dispatch": "紹介予定派遣は登録されていません。",
        "candidate_employment_stability_measures.applicable_contract.help_message": "※実施日時が派遣期間に含まれている契約を選択肢として表示します。",
        "candidate_employment_stability_measures.applicable_contract.initial": "実施した分類が「第１号」「第２号」の場合に契約を選択します。",
        "candidate_employment_stability_measures.applicable_contract.not_exist": "「実施日時」が含まれている契約が存在しません。",
        "candidate_employment_stability_measures.applicable_contract.not_exist_help_message": "※実施日時の入力を間違えていないか、または実施日時が派遣期間に含まれている契約が存在しているかを確認して下さい。",
        "candidate_employment_stability_measures.candidate_employment_stability_measure_list": "雇用安定措置一覧",
        "candidate_employment_stability_measures.import.title": "インポート(雇用安定措置)",
        "candidate_employment_stability_measures.list_name": "雇用安定措置番号",
        "candidate_employment_stability_measures.no_candidate_employment_stability_measure": "雇用安定措置は登録されていません。",
        "candidate_job_steps": "人材求人の進捗",
        "candidate_job_steps.bulk_store_step.notification_failed": "進捗一括更新処理が失敗しました。",
        "candidate_job_steps.bulk_store_step.notification_finished": "進捗一括更新処理が成功しました。",
        "candidate_job_steps.bulk_store_step.notification_start": "進捗一括更新処理を開始します。",
        "candidate_job_steps.cancel": "キャンセル",
        "candidate_job_steps.candidate_correspondence_user_id": "自社人材対応者",
        "candidate_job_steps.candidate_id": "人材",
        "candidate_job_steps.candidate_job_step_state_id": "進捗",
        "candidate_job_steps.company_id": "会社",
        "candidate_job_steps.create": "新しい進捗を作成",
        "candidate_job_steps.create_and_add": "進捗を新規作成\/追加",
        "candidate_job_steps.create_success": "進捗を作成しました",
        "candidate_job_steps.create_user_id": "登録者",
        "candidate_job_steps.current_step": "現在のステップ",
        "candidate_job_steps.current_step_edit": "現在の進捗を修正する",
        "candidate_job_steps.date": "進捗日時",
        "candidate_job_steps.detail": "進捗詳細",
        "candidate_job_steps.empty_date": "日時を指定しない",
        "candidate_job_steps.empty_date_not_adjusted": "日時を指定しない(日程未調整)",
        "candidate_job_steps.end_at": "終了時刻",
        "candidate_job_steps.find_candidate": "この求人に合う人材を探す",
        "candidate_job_steps.find_job": "この人材に合う求人を探す",
        "candidate_job_steps.id": "進捗番号",
        "candidate_job_steps.import.title": "インポート(進捗)",
        "candidate_job_steps.job_correspondence_user_id": "自社求人対応者",
        "candidate_job_steps.job_id": "求人",
        "candidate_job_steps.mail_id": "メールID",
        "candidate_job_steps.memo": "メモ",
        "candidate_job_steps.next_step": "次回のステップ",
        "candidate_job_steps.no_staff": "未定",
        "candidate_job_steps.not_valid": "未選択の必須項目があります",
        "candidate_job_steps.proceed": "進捗を進める",
        "candidate_job_steps.proceed_or_refusal": "進捗を進める\/辞退",
        "candidate_job_steps.select_all_steps": "すべてのステップを選択可能にする",
        "candidate_job_steps.select_date": "日にちを選択",
        "candidate_job_steps.selected": "このページ内の進捗{count}件が選択されています",
        "candidate_job_steps.staff_id": "面接担当",
        "candidate_job_steps.start_at": "開始時刻",
        "candidate_job_steps.store_free_items": "自由項目を保存しました",
        "candidate_job_steps.update": "進捗を作成する",
        "candidate_job_steps.update_edit_mode": "進捗を変更する",
        "candidate_step_resources.candidate_step_resource_list": "対応一覧",
        "candidate_step_resources.no_candidate_step_resource": "対応は登録されていません",
        "candidate_steps": "人材の進捗",
        "candidate_steps.candidate_id": "人材ID",
        "candidate_steps.candidate_step_state_id": "人材ステータス",
        "candidate_steps.category": "区分",
        "candidate_steps.end_at": "終了時刻",
        "candidate_steps.export": "対応状況出力",
        "candidate_steps.id": "対応番号",
        "candidate_steps.import.title": "インポート(人材対応)",
        "candidate_steps.index.title": "人材対応一覧",
        "candidate_steps.index.title_explain": "人材対応の件数や詳細を検索できます",
        "candidate_steps.mail_id": "メールID（人材ステータスがメールの場合）",
        "candidate_steps.memo": "メモ",
        "candidate_steps.start_at": "開始時刻",
        "candidate_steps.support_at": "対応日時",
        "candidate_steps.user": "対応者",
        "candidates.address": "住所",
        "candidates.age": "年齢",
        "candidates.age_comment": "※生年月日を入力すると自動計算されます。",
        "candidates.age_unit": "歳",
        "candidates.applied": "応募済み企業",
        "candidates.birth_date": "生年月日",
        "candidates.can_edit_step_after_acceptance": "合否連絡後に進捗の変更が可能です",
        "candidates.candidate_state_id": "ステータス",
        "candidates.candidate_step_resource_list": "対応一覧",
        "candidates.caution": "ご連絡時の注意",
        "candidates.circumstance_id": "登録時の状況",
        "candidates.code": "コード",
        "candidates.conflict_date": "抵触日",
        "candidates.contract": "契約",
        "candidates.created_at": "登録日時",
        "candidates.deleted.name": "(削除済み人材)",
        "candidates.distributed_at": "担当振分け日時",
        "candidates.download_candidate_posting": "履歴書・帳票を出力",
        "candidates.download_job_posting": "求人票・帳票を出力",
        "candidates.email": "E-mail（自宅）",
        "candidates.english_skill": "英語のその他の資格",
        "candidates.feed_number": "扶養人数",
        "candidates.figure": "人物像",
        "candidates.file": "履歴書など",
        "candidates.hope_company": "希望会社名",
        "candidates.hope_employment_category_id": "希望雇用形態",
        "candidates.hope_fee": "希望年収",
        "candidates.hope_job_change_season": "希望転職時期",
        "candidates.hope_place": "希望勤務地",
        "candidates.id": "番号",
        "candidates.image_change": "人材画像の変更",
        "candidates.image_ratio": "画像の比率 = 縦4 : 横3\n(参考 188px × 141px)",
        "candidates.import.duplicated": "重複があるデータを処理する",
        "candidates.import.duplicated_notice": "まとめたいデータにチェックをいれてください。重複したデータを1つにまとめられます。",
        "candidates.import.list": "データを確認する",
        "candidates.import.title": "インポート(人材)",
        "candidates.index": "人材一覧",
        "candidates.index_no_users": "人材一覧(自社担当者未設定)",
        "candidates.is_married": "配偶者有無",
        "candidates.is_possible_bulk_mail": "一括メール送信可否",
        "candidates.job_change_number": "転職回数",
        "candidates.kana": "フリガナ",
        "candidates.list_back": "人材一覧に戻る",
        "candidates.mail_unregister": "人材のメールアドレスが未登録です",
        "candidates.matching": "マッチング",
        "candidates.matching.dispatch_jobs.link": "派遣求人を探す",
        "candidates.matching.dispatch_jobs.title": "希望条件に合う派遣求人を探す",
        "candidates.matching.dispatch_jobs.title_explain": "求人票のダウンロード・自社派遣求人担当者変更なども行えます",
        "candidates.matching.explain": "求人を探して、紹介や推薦ができます",
        "candidates.matching.jobs.link": "紹介求人を探す",
        "candidates.matching.jobs.title": "希望条件に合う紹介求人を探す",
        "candidates.matching.jobs.title_explain": "求人票のダウンロード・自社紹介求人担当者変更なども行えます",
        "candidates.matching.map.explain": "地図から求人を探してマッチングができます。",
        "candidates.matching.map.link": "地図から求人を探す",
        "candidates.matching_add": "{state}に追加",
        "candidates.matching_delete": "{state}から外す",
        "candidates.matching_updating": "更新中",
        "candidates.medium_detail": "データ入力媒体詳細",
        "candidates.medium_id": "応募求人媒体",
        "candidates.memo": "メモ",
        "candidates.menu.apply": "進捗",
        "candidates.menu.apply_title": "進捗を見る",
        "candidates.menu.file": "履歴書",
        "candidates.menu.file_title": "添付された履歴書・職務経歴書などを見る",
        "candidates.menu.profile": "プロフィール",
        "candidates.menu.profile_title": "プロフィールを見る",
        "candidates.menu.step": "対応履歴",
        "candidates.menu.step_title": "対応履歴を見る",
        "candidates.merge.duplicate_id": "人材番号",
        "candidates.name": "氏名",
        "candidates.name_empty": "氏名未登録",
        "candidates.name_empty_with_id": "氏名未登録（番号：{id}）",
        "candidates.no_assign_user": "自社人材担当者未設定の人材",
        "candidates.no_candidates_step_resource": "対応は登録されていません",
        "candidates.no_data": "人材の情報はありません",
        "candidates.none": "人材の登録がまだありません。",
        "candidates.office_email": "E-mail（会社）",
        "candidates.photo_alternative_text": "人材の写真",
        "candidates.photo_file_path": "写真ファイルパス",
        "candidates.portable_email": "E-mail（携帯）",
        "candidates.portable_tel": "電話番号（携帯）",
        "candidates.prefecture_id": "都道府県",
        "candidates.present_fee": "登録時の年収",
        "candidates.progress_list": "進捗リスト",
        "candidates.qualification": "資格",
        "candidates.rank_id": "ランク",
        "candidates.reason": "転職理由",
        "candidates.request": "要望",
        "candidates.roudoukyoku_category_id": "労働局分類",
        "candidates.search_matching": "希望条件に合う求人を探す",
        "candidates.search_result_select": "検索結果の{total}名を全て選択",
        "candidates.search_result_selected": "検索結果の{total}名が全て選択されています",
        "candidates.sex.name": "性別",
        "candidates.show.candidate_career_counselling": "キャリア相談",
        "candidates.show.candidate_education_and_training": "教育訓練",
        "candidates.show.candidate_employment_placement_dispatch": "紹介予定派遣",
        "candidates.show.candidate_employment_stability_measure": "雇用安定措置",
        "candidates.show.step": "対応",
        "candidates.show_back": "人材詳細に戻る",
        "candidates.start_matching_candidate_with_job": "希望条件に合う求人を探す",
        "candidates.start_matching_job_with_candidate": "希望条件に合う人材を探す",
        "candidates.station": "最寄駅",
        "candidates.steps.no_steps_description": "対応履歴がございません。電話対応等を行ったときには右上のボタンよりメモを残して社内共有しましょう。",
        "candidates.tel": "電話番号（自宅）",
        "candidates.title_create": "人材新規登録",
        "candidates.title_edit": "人材編集",
        "candidates.title_index": "人材検索結果",
        "candidates.title_search": "人材検索",
        "candidates.toeic": "TOEIC",
        "candidates.update_success": "人材情報を更新しました",
        "candidates.update_user_placeholder": "自社人材担当者 ▼",
        "candidates.user": "自社人材担当者",
        "candidates.user_change": "自社人材担当者を変更",
        "candidates.user_department": "自社人材担当者\/部署",
        "candidates.zip": "郵便番号",
        "careers.company_name": "会社名",
        "careers.entrance_date": "入社年月",
        "careers.retirement_date": "退社年月",
        "check.uncheck_all": "選択を全解除",
        "common.actual_amount_over_shorts": "過不足金",
        "common.add": "追加",
        "common.add_after": "後に追加",
        "common.add_before": "前に追加",
        "common.add_matching.success": "マッチングに追加しました",
        "common.add_matching_list": "マッチングに追加",
        "common.add_search_condition": "この検索条件をお気に入りに追加",
        "common.adding": "追加する",
        "common.after": "後",
        "common.age": "歳",
        "common.agent": "人材会社名",
        "common.ajax_autosuggest_placeholder": "入力後に選択肢から選択 ▼",
        "common.alert": "アラート",
        "common.alert.date": "アラート日時",
        "common.alert.name": "アラート名称",
        "common.alert.notification_destination": "担当",
        "common.alert.status": "アラートの状態",
        "common.all": "すべて",
        "common.all_column": "全カラム",
        "common.all_status": "全てのステータス",
        "common.amount_over_short": "過不足金",
        "common.application": "適用する",
        "common.apply": "適用",
        "common.apply_count": "応募数",
        "common.apply_date": "進捗日",
        "common.apply_to_company": "企業に推薦する",
        "common.attachment": "添付する",
        "common.autosuggest_placeholder": "選択してください ▼",
        "common.back": "戻る",
        "common.basic": "基本",
        "common.basic_info": "基本情報",
        "common.basic_time": "基本（時間）",
        "common.basic_time_no_brackets": "基本時間",
        "common.billed_list": "請求一覧",
        "common.billing": "請求",
        "common.billing_bulk_operation_select_item": "選択した請求への一括操作",
        "common.billing_calculate_date": "請求計算日",
        "common.billing_closing": "請求締め",
        "common.billing_closing_day_date_only_type_id": "請求締め日",
        "common.billing_days": "請求日",
        "common.billing_destinations": "請求先",
        "common.billing_destinations_name": "請求先名",
        "common.billing_fee": "請求金額",
        "common.billing_id": "請求先ID",
        "common.billing_information": "請求情報",
        "common.billing_number": "請求番号",
        "common.billing_payment": "請求\/支払",
        "common.billing_payment_days": "入金予定日",
        "common.billing_price": "請求金額",
        "common.billing_registration_sales_billing_payment_days": "売上日・請求日・入金予定日の登録",
        "common.billing_sales_days": "売上日",
        "common.breakdown": "内訳",
        "common.btn_delete": "データを削除",
        "common.btn_force_delete": "データを完全削除",
        "common.btn_merge": "データをまとめる",
        "common.bulk_action": "一括アクション",
        "common.bulk_input": "一括入力",
        "common.bulk_mail": "一括メールを送る",
        "common.call": "呼び出す",
        "common.call_condition": "条件を呼び出す",
        "common.cancel": "キャンセル",
        "common.candidate_career_counsellings": "キャリア相談",
        "common.candidate_education_and_trainings": "教育訓練",
        "common.candidate_employment_stability_measures": "雇用安定措置",
        "common.candidate_honorific": "様",
        "common.candidate_job_step_resources": "進捗",
        "common.candidate_job_steps": "進捗",
        "common.candidate_steps": "人材対応",
        "common.candidate_user": "人材担当者",
        "common.candidates": "人材",
        "common.candidates_name": "人材名",
        "common.cannot": "不可",
        "common.category": "カテゴリー",
        "common.change": "変更する",
        "common.change_company_public_status": "会社名公開を変更",
        "common.change_hp_relation_status": "ホームページ掲載を変更",
        "common.check_mail": "メール履歴を確認する",
        "common.clear": "クリア",
        "common.clear_search": "条件をクリア",
        "common.clone": "複製する",
        "common.close": "閉じる",
        "common.closing": "締め",
        "common.combine_character_input": "項目の結合文字を入力してください（未入力の場合は改行になります）",
        "common.communication": "通信キャリア",
        "common.companies": "会社情報",
        "common.company": "会社",
        "common.company_steps": "会社対応",
        "common.company_user": "会社担当者",
        "common.confirm": "確定",
        "common.confirm.delete": "削除してもよろしいでしょうか？",
        "common.contents": "内容",
        "common.continue_import": "続けてインポートする",
        "common.contract": "契約",
        "common.contract_agreement_labor_check": "協定労働者であるか否かの別",
        "common.contract_bonus": "賞与（有無・時期・金額等）",
        "common.contract_closed_end_due_day": "休業終了予定日",
        "common.contract_closed_start_day": "休業開始日",
        "common.contract_closed_worker_business": "休業者業務",
        "common.contract_closed_worker_name": "休業者氏名",
        "common.contract_conflict_prevention_measures": "紛争防止措置",
        "common.contract_conflict_prevention_measures_direct_employment": "派遣労働者の直接雇用における紛争防止措置",
        "common.contract_date": "個別契約締結日",
        "common.contract_degree_of_responsibility": "派遣労働者が従事する業務に伴う責任の程度",
        "common.contract_dispatch_individual_contract": "派遣個別契約書",
        "common.contract_fixed_term_project": "有期プロジェクト業務",
        "common.contract_full_time_work": "フルタイム勤務",
        "common.contract_holiday_week": "休日曜日",
        "common.contract_limited_day_project": "日数限定業務",
        "common.contract_matters_concerning_contract_renewal": "契約更新に関する事項",
        "common.contract_matters_concerning_retirement": "退職に関する事項",
        "common.contract_matters_staffing": "紹介予定派遣に関する事項",
        "common.contract_memo_number": "契約メモ番号",
        "common.contract_memos": "契約メモ",
        "common.contract_midnight_rest_time": "深夜休憩時間(分)",
        "common.contract_month_project_days": "１か月間該当業務日数",
        "common.contract_month_working_days": "通常労働者１か月所定労働日数",
        "common.contract_not_applicable_time_limit": "期間制限の対象外",
        "common.contract_not_repeat": "繰り返さない",
        "common.contract_notification_of_working_conditions": "労働条件通知書兼就業条件明示書",
        "common.contract_number": "契約番号",
        "common.contract_overtime_work": "時間外（休日）労働",
        "common.contract_overtime_work_hours": "時間外労働時間",
        "common.contract_paid_holidays_adjustment_working_hours": "有給休暇時間単位消化時の所定労働時間調整",
        "common.contract_payment_term": "支払サイト",
        "common.contract_related_over_short_cash_add": "契約に紐づく過不足金の追加",
        "common.contract_repeat": "繰り返す",
        "common.contract_repeat_end_day": "繰り返し終了日",
        "common.contract_repeat_label": "繰り返し",
        "common.contract_repeat_start_day": "繰り返し開始日",
        "common.contract_repeat_term": "繰り返す間隔",
        "common.contract_repetition": "繰り返しの有無",
        "common.contract_repetition_property": "繰り返しプロパティ",
        "common.contract_repetition_property_closing_day": "毎月締め日",
        "common.contract_repetition_property_first_day": "毎月初日(1日)",
        "common.contract_repetition_property_last_day": "毎月最終日",
        "common.contract_repetition_property_same_day": "初回設定時と同じ日付",
        "common.contract_repetition_property_same_week": "初回設定時と同じ週、曜日",
        "common.contract_repetition_week": "繰り返す曜日",
        "common.contract_rest_time": "休憩時間(分)",
        "common.contract_salary_increase_timing": "昇給（時期等）",
        "common.contract_setting_text_payment_term_closing_day": "契約を作成しようとしている人材に締め日の設定がありません。<br>支払サイト・締め日を設定してください。",
        "common.contract_setting_title_payment_term_closing_day": "支払サイト・締め日・支払の登録",
        "common.contract_substitute_childcare_leave": "育児休業等取得者の代替",
        "common.contract_substitute_nursing_care_leave": "介護休業取得者の代替",
        "common.contract_target_sixty_age_up": "60歳以上を対象",
        "common.contract_use_of_welfare_facilities": "福利厚生施設の利用等",
        "common.contract_working_days_in_month": "勤務日数\/月",
        "common.contract_working_end_time": "勤務終了時間",
        "common.contract_working_hours": "就業時間",
        "common.contract_working_start_time": "勤務開始時間",
        "common.contract_working_week": "勤務曜日",
        "common.contracts": "契約",
        "common.copied": "コピーしました。",
        "common.copied_toast": "コピーしました",
        "common.copy": "{name} - コピー",
        "common.create": "新規登録",
        "common.created_at": "登録日時",
        "common.created_success": "作成しました。",
        "common.created_user_title": "登録者",
        "common.csv": "CSV",
        "common.csv.chunk_size": "分割",
        "common.csv.create_new_setting": "+新しくCSVの設定を追加する",
        "common.csv.download": "CSVをダウンロード",
        "common.csv.edit": "編集する",
        "common.csv.export": "CSVを出力",
        "common.csv.import": "CSV取り込みを実行",
        "common.csv.output": "CSV出力",
        "common.csv.select_setting": "エクスポート設定を選択してください ▼",
        "common.csv.sort": "CSVの出力順",
        "common.csv.sort_sub": "出力順を設定できます。",
        "common.csv.title_main": "出力内容",
        "common.daily": "日付",
        "common.daily_payment": "日払い",
        "common.daily_salary": "日給",
        "common.dash_board": "ダッシュボード",
        "common.data.all_duration": "総合(全期間)",
        "common.data.duration": "期間",
        "common.data.total": "全人数",
        "common.date.delimiter": "～",
        "common.date.format": "yyyy\/MM\/dd",
        "common.date.format.dayjs": "YYYY\/MM\/DD",
        "common.date.format.dayjs.compact": "YYYYMMDD",
        "common.date.format.dayjs.compact.short": "YYYYMD",
        "common.date.format.dayjs.short": "YYYY\/M\/D",
        "common.date.format.dayjs.yearMonth.compact.short": "YYYYM",
        "common.date.format.jp": "YYYY年M月D日",
        "common.date.format.moment": "YYYY\/MM\/DD",
        "common.date.format.moment.dateTime": "YYYY\/MM\/DD HH-mm-ss",
        "common.date.format.moment.request": "YYYY-MM-DD",
        "common.date.format.moment.short": "YYYY\/M\/D",
        "common.date.format.moment.time": "HH{mm}",
        "common.date.format.moment.yearMonth": "YYYY\/MM",
        "common.date.format.php": "Y\/n\/j",
        "common.date.format.php.dateTime.without_second": "Y\/n\/j H{i}",
        "common.date.format.php.yearMonth": "Y\/n",
        "common.date.format.without_day": "yyyy\/MM",
        "common.date.percent_display": "％の表示：",
        "common.date.time": "日時",
        "common.date.value.endDayTime": "23-59-59",
        "common.datetime.days.passed": "{time}日 経過",
        "common.datetime.hours.passed": "{time}時間 経過",
        "common.datetime.minutes.passed": "{time}分 経過",
        "common.datetime.months.passed": "{time}ヵ月 経過",
        "common.datetime.seconds.passed": "{time}秒 経過",
        "common.datetime.weeks.passed": "{time}週間 経過",
        "common.datetime.years.passed": "{time}年 経過",
        "common.day": "日",
        "common.day_of_week": "曜日",
        "common.default": "デフォルト",
        "common.default_search_condition": "デフォルト検索設定：",
        "common.delete": "削除する",
        "common.delete.cannot": "削除不可",
        "common.delete.word": "削除",
        "common.deleted.word": "削除された",
        "common.deleted_data": "このデータは削除されています。",
        "common.depth1": "大分類",
        "common.depth2": "中分類",
        "common.depth3": "小分類",
        "common.detail": "詳細",
        "common.detail_display": "詳細を見る",
        "common.detail_here": "詳しくはこちら",
        "common.detail_screen": "詳細画面",
        "common.dispatch_date": "派遣日",
        "common.dispatch_date_apply": "勤務日付に適用",
        "common.dispatch_destinations": "派遣先",
        "common.dispatch_destinations_name": "派遣先名",
        "common.dispatch_id": "派遣先ID",
        "common.dispatch_job_related_over_short_cash_add": "求人に紐づく過不足金の追加",
        "common.dispatch_jobs": "派遣求人",
        "common.dispatch_organization_units": "組織単位",
        "common.dispatch_organization_units_name": "組織単位名",
        "common.dispatch_source_setting": "派遣元設定",
        "common.dispatch_source_staffs": "派遣元担当者",
        "common.dispatch_sources": "派遣元",
        "common.dispatch_staffs": "派遣先担当者",
        "common.dispatch_working_places": "就業現場",
        "common.display": "表示",
        "common.display_item": "表示項目",
        "common.distribute": "振分け",
        "common.do": "する",
        "common.do.create": "作成する",
        "common.do.create.new": "新規作成する",
        "common.dont": "しない",
        "common.download": "ダウンロード",
        "common.download_candidate_report": "履歴書・帳票を出力",
        "common.download_job_report": "求人票・帳票を出力",
        "common.download_limit_confirm": "このページ内の帳票50件のみをダウンロードしますが、よろしいでしょうか。",
        "common.drag_and_drop": "ドラッグ&ドロップ",
        "common.drag_and_drop_possible": "ドラッグ&ドロップも可能",
        "common.drag_and_drop_sort": "ドラッグ&ドロップで並び替え可能",
        "common.duplicate_button": "重複している人材データがあります！",
        "common.duplicate_error": "統合のチェックは少なくとも 2つ チェックするようにしてください。",
        "common.each_days": "日ごと",
        "common.each_months": "ヶ月ごと",
        "common.each_weeks": "週ごと",
        "common.each_years": "年ごと",
        "common.edit": "編集する",
        "common.edit.cannot": "編集不可",
        "common.edit.word": "編集",
        "common.elapsed_days": "経過日数",
        "common.email": "メール",
        "common.employment": "勤務先",
        "common.employment_agencies": "人材会社",
        "common.employment_insurance": "雇用保険",
        "common.enter_criterion_name": "条件名を入力して下さい",
        "common.example": "※参考例",
        "common.excel": "Excel",
        "common.failed": "失敗しました",
        "common.failed.number": "{id}番が失敗しました",
        "common.failure": "不合格",
        "common.file.download": "帳票を出力",
        "common.file.download_masking": "ダウンロード時に【個人を特定できる項目の情報】を隠す",
        "common.file.download_placeholder": "帳票を選択してください ▼",
        "common.file.open_and_preview": "別タブで開く",
        "common.file.upload": "アップロードするファイルを選択",
        "common.file.upload.limit_size": "(1ファイル最大100MBまで)",
        "common.file.upload.this_area": "または このエリアに",
        "common.filename": "ファイル名",
        "common.filtering": "絞り込み",
        "common.fiscal_year": "年度",
        "common.fixed": "締め済み",
        "common.fixed_day": "締め日",
        "common.fixed_value": "固定値",
        "common.fixed_value_input": "こちらに入力してください。",
        "common.fixed_value_select": "自由入力",
        "common.force_delete": "完全に削除する",
        "common.form_related_items": "帳票関連項目",
        "common.forty_five_hours_in_month": "45h\/月",
        "common.gender_unset": "性別未設定",
        "common.general": "全般",
        "common.goingood": "ゴーイングッド",
        "common.group_name": "グループ名",
        "common.header": "ヘッダー",
        "common.health_insurance": "健康保険",
        "common.home": "自宅",
        "common.hour": "時間",
        "common.hourly_wage": "時給",
        "common.image": "画像",
        "common.image.add": "画像を追加",
        "common.image.nodata": "画像が登録されておりません",
        "common.image.ratio": "画像の比率 縦{verticalRatio}:横{sideRatio} (※参考サイズ 縦 {verticalPixel} px × 横 {sidePixel} px)",
        "common.import": "インポート",
        "common.import.title_explain": "CSVファイルをインポートすることができます",
        "common.initial_friday": "金",
        "common.initial_monday": "月",
        "common.initial_saturday": "土",
        "common.initial_sunday": "日",
        "common.initial_thursday": "木",
        "common.initial_tuesday": "火",
        "common.initial_wednesday": "水",
        "common.input": "入力済",
        "common.insert": "挿入する",
        "common.insert_in_cursor": "カーソルの位置に挿入されます",
        "common.instance": "例",
        "common.insufficient_permission": "権限がありません",
        "common.insufficient_permission.merge": "人材の編集と削除の権限がありません",
        "common.invoice_report_output_histories": "請求書出力履歴",
        "common.item_setting_cascader_placeholder": "項目を選択してください",
        "common.jinzai_jiro": "人材 次郎",
        "common.job": "求人",
        "common.job_steps_id": "求人ID",
        "common.job_title": "求人見出し",
        "common.job_user": "求人担当者",
        "common.jobs": "紹介求人",
        "common.kind": "種類",
        "common.last_edit_user": "最終記載者",
        "common.last_step": "最新進捗",
        "common.last_step_date": "最新進捗日時",
        "common.leave_times_type_1": "1回目",
        "common.leave_times_type_2": "2回目",
        "common.leave_times_type_3": "3回目",
        "common.leave_times_type_4": "4回目",
        "common.leave_times_type_5": "5回目",
        "common.leave_times_type_6": "6回目",
        "common.leave_times_type_7": "7回目以降",
        "common.legal_overtime": "法定内残業",
        "common.line": "行",
        "common.line_add": "+ 行を追加",
        "common.line_break_interface": "[[改行]]",
        "common.list_data_delete": "削除済データを見る",
        "common.list_data_delete_back": "通常表示に戻る",
        "common.logo_alt": "Matchingoodロゴ",
        "common.logout": "ログアウト",
        "common.lower": "降順",
        "common.mailbox": "メールボックス",
        "common.main_menu": "メインメニュー",
        "common.manage": "管理する",
        "common.manipulation": "操作",
        "common.map_matching_conversion_geo_error_message": "情報が取得できませんでした。住所に誤りが無いかご確認いただくか、建物名を削除していただくなどお試しください。",
        "common.map_matching_transportation_bus": "バス",
        "common.map_matching_transportation_train": "鉄道",
        "common.map_matching_traveling_time_about": "で約",
        "common.map_matching_traveling_time_within_range": "圏内",
        "common.matching_setting": "マッチング設定",
        "common.matching_setting_call": "マッチング設定を呼び出す",
        "common.matching_view": "マッチングビュー",
        "common.matching_view.title.candidates": "人材詳細",
        "common.matching_view.title.dispatch_jobs": "派遣求人詳細",
        "common.matching_view.title.jobs": "紹介求人詳細",
        "common.matchingood": "マッチングッド",
        "common.matchingood_all": "マッチングッド(株)",
        "common.matchingood_english": "Matchingood株式会社",
        "common.matchingood_english_lower_case": "matchingood株式会社",
        "common.matchingood_english_only": "matchingood",
        "common.matchingood_english_short": "Matchingood(株)",
        "common.matchingood_japanese": "マッチングッド株式会社 ",
        "common.matchingood_ng_example": "マッチン・グッド",
        "common.memo": "メモ",
        "common.mensetsu_taro": "面接 太郎",
        "common.merge": "統合",
        "common.min": "分",
        "common.mismatch": "不一致",
        "common.mobile": "携帯",
        "common.month_last_day": "末日",
        "common.month_last_day_short": "末",
        "common.monthly_payment": "月払い",
        "common.monthly_salary_actual": "月給(実績給)",
        "common.monthly_salary_fixed": "月給(固定)",
        "common.my_page": "マイページ",
        "common.name": "氏名",
        "common.name_label": "名称",
        "common.necessary": "必要",
        "common.next": "次",
        "common.next_month": "翌月",
        "common.no_data": "--",
        "common.no_input": "未入力",
        "common.no_input.age": "年齢未入力",
        "common.no_input.company.name": "会社名未入力",
        "common.no_input.is": "{input}が未入力です",
        "common.no_input.job.title": "無題 (求人番号: {job_id})",
        "common.no_input.name": "氏名未入力",
        "common.no_input.sex": "性別未入力",
        "common.no_input.staff": "会社担当者未登録",
        "common.no_input.step": "進捗の登録がまだありません。",
        "common.no_input.tel": "電話番号未登録",
        "common.no_input.user": "担当者未設定",
        "common.no_registration": "登録なし",
        "common.no_setting": "未設定",
        "common.no_settings": "設定なし",
        "common.no_step": "進捗なし",
        "common.no_time": "--:--",
        "common.no_title": "タイトル未設定",
        "common.non_statutory": "法定外",
        "common.none": "なし",
        "common.notification": "お知らせ",
        "common.now_creating_file": "ただいまファイルの作成中です",
        "common.off": "OFF",
        "common.ok": "OK",
        "common.old": "旧",
        "common.on": "ON",
        "common.operate": "操作する",
        "common.optional": "任意",
        "common.organization_id": "組織体ID",
        "common.organization_name": "組織体名",
        "common.other": "他",
        "common.otherwise": "その他",
        "common.out_trash": "元に戻す",
        "common.out_trash_data": "データを元に戻す",
        "common.particle": "を",
        "common.pass_rate": "通過率",
        "common.passed": "合格",
        "common.password": "パスワード",
        "common.payment": "支払",
        "common.payment_amount": "支給額",
        "common.payment_amount_after_employment_income_deduction": "社保控除後の給与金額",
        "common.payment_amount_over_short_tax_exempt": "過不足金（非課税）",
        "common.payment_amount_over_short_taxation": "過不足金（課税）",
        "common.payment_basic_amount": "本給（基本給）",
        "common.payment_bulk_operation_select_item": "選択した支払への一括操作",
        "common.payment_cancel": "支払取消",
        "common.payment_closed_payment_history_tab_name": "第%d版",
        "common.payment_closed_payment_setting": "支払\/支払締め設定",
        "common.payment_closed_payment_target_ym_format": "Y年m月",
        "common.payment_closing": "支払締め",
        "common.payment_date": "支払日",
        "common.payment_deducted_item": "支払から控除される項目：",
        "common.payment_employment_insurance": "雇用保険",
        "common.payment_fee": "支払金額",
        "common.payment_health_insurance": "健康保険",
        "common.payment_long_term_care_insurance": "介護保険",
        "common.payment_non_legal_overtime_price_forty_five": "残業45H超え",
        "common.payment_non_legal_overtime_price_sixty": "残業60H超え",
        "common.payment_pay": "支払い",
        "common.payment_prepaid_amount": "前払い額",
        "common.payment_price": "支払金額",
        "common.payment_price_amount": "支払金額",
        "common.payment_registration_sales_billing_payment_days": "売上日・支払日・支払予定日の登録",
        "common.payment_resident_tax": "住民税",
        "common.payment_schedule_date": "支払予定日",
        "common.payment_welfare_pension": "厚生年金",
        "common.payment_withholding_income_tax": "源泉所得税",
        "common.performance": "実績",
        "common.plan": "予定",
        "common.prefix_sub": "文言の前後に文字を追加できます。",
        "common.prescribed_working_hours": "所定労働時間",
        "common.presence_interval": "在籍期間",
        "common.previous": "前",
        "common.progress": "進捗",
        "common.progress_add": "対応を新規登録",
        "common.progress_bulk_extension": "進捗を一括更新",
        "common.progress_bulk_extension_completed": "進捗の一括更新処理を開始しました。",
        "common.progress_bulk_extension_confirm": "この内容で進捗を一括更新しますか？",
        "common.progress_bulk_extension_limit_msg1": "対象データが51件以上選択されているため、進捗登録できません。",
        "common.progress_bulk_extension_limit_msg2": "50件以下にしてください。",
        "common.progress_bulk_extension_limit_msg3": "選択件数: ",
        "common.progress_bulk_extension_no_progress_msg1": "求人案件が紐づいていないため、進捗登録ができないデータがあります。",
        "common.progress_bulk_extension_no_progress_msg2": "対象データを確認してください。",
        "common.progress_bulk_extension_no_progress_msg3": "対象データを除いて進捗を登録する場合は、進捗を更新するをクリックしてください。",
        "common.progress_confirm": "対応を確認\/追加",
        "common.progress_edit": "対応を編集",
        "common.progress_list": "進捗リスト",
        "common.progress_none": "対応がまだ登録されていません。",
        "common.progress_update": "進捗を更新する",
        "common.read_more": "続きを読む",
        "common.recalculation": "再計算する",
        "common.recommend_to_candidate": "求人を紹介する",
        "common.refer": "参照する",
        "common.reflect": "反映",
        "common.reflection": "反映しました",
        "common.register": "登録する",
        "common.register_error": "登録できませんでした。エラーを確認ください。",
        "common.registering": "登録中",
        "common.registration": "登録",
        "common.remainder": "余り",
        "common.required": "必須",
        "common.required.not_valid": "未入力の必須項目があります",
        "common.reservation": "予約する",
        "common.reset": "リセット",
        "common.restore": "復元する",
        "common.return": "戻す",
        "common.return_to_top_page": "トップページに戻る",
        "common.round_down": "切り捨て",
        "common.round_up": "切り上げ",
        "common.rounding": "四捨五入",
        "common.run": "実行する",
        "common.saiyo_hanako": "採用 花子",
        "common.salary_classification": "給与分類",
        "common.sales": "営業",
        "common.sales_japanese": "セールス",
        "common.save_criterion": "この条件を保存する",
        "common.schedule": "スケジュール",
        "common.scheduled_holiday": "所定休日",
        "common.scheduled_holiday_work": "所定休日出勤",
        "common.search": "検索",
        "common.search_area": "表示したいエリアを入力してください",
        "common.search_arrow": "▼",
        "common.search_comment": "二文字以上の単語が対象",
        "common.search_company_step_comment": "自由項目として追加された項目内の二文字以上の単語が対象",
        "common.search_condition": "検索条件",
        "common.search_condition_add": "+詳しい条件を指定する",
        "common.search_condition_setting": "条件を設定する",
        "common.search_condition_setting_title": "詳しい条件を指定して検索",
        "common.search_delete": "削除検索",
        "common.search_none": "検索条件に合致する結果が⾒つかりませんでした。",
        "common.search_not_condition": "指定なし",
        "common.search_target": "検索対象：",
        "common.see_more": "もっと見る",
        "common.select": "選択",
        "common.select_candidate": "人材を選択 ▼",
        "common.select_company": "会社名を検索 ▼",
        "common.select_date": "日にちを選択",
        "common.select_favorite_search": "お気に入り検索条件を選んでください",
        "common.select_staffing": "派遣先を選択 ▼",
        "common.select_user": "担当者を選択",
        "common.selected": "が選択されています",
        "common.selected_all_result_link": "検索結果の{total}件を全て選択",
        "common.selected_all_result_message": "検索結果の{total}件が全て選択されています",
        "common.selected_page_result_message": "このページ内の{total}件が選択されています",
        "common.send": "送信する",
        "common.setting": "設定",
        "common.setting_add_item": "+項目を追加する",
        "common.setting_basic": "基本設定",
        "common.setting_colum": "列",
        "common.setting_detail": "詳細設定",
        "common.setting_name": "設定名",
        "common.setting_new": "設定を新規追加",
        "common.setting_none": "設定が登録されていません。",
        "common.setting_type": "設定種別",
        "common.setting_type_change": "設定種別を選び直す",
        "common.share": "共有する",
        "common.show_matching_list": "紹介候補一覧を見る",
        "common.show_results": "結果を表示する",
        "common.sixty_hours_in_month": "60h\/月",
        "common.sort_setting": "並び替え設定",
        "common.space": "スペース",
        "common.staff": "スタッフ",
        "common.staff_select": "スタッフを選択 ▼",
        "common.staffing_claim_manager": "派遣先苦情責任者",
        "common.staffing_commander": "派遣先指揮命令者",
        "common.staffing_end_date": "派遣終了日",
        "common.staffing_manager": "派遣先責任者",
        "common.staffing_organizational_unit": "派遣先組織単位",
        "common.staffing_organizational_unit_select": "派遣先組織単位を選択 ▼",
        "common.staffing_start_date": "派遣開始日",
        "common.staffs": "会社担当者",
        "common.start_to_create_file": "ファイルの作成を開始しました",
        "common.status": "ステータス",
        "common.step_progress": "進捗を追加する",
        "common.steps.elapse": "%1$s 経過",
        "common.steps.selected": "このページ内の対応{count}件が選択されています",
        "common.steps.state": "対応状況",
        "common.submit": "登録する",
        "common.submitting": "登録しています",
        "common.success": "登録しました。",
        "common.sum": "総和",
        "common.task": "タスク",
        "common.tel_none": "電話番号なし",
        "common.this_month": "当月",
        "common.this_page": "このページ内の",
        "common.three_months_later": "3か月後",
        "common.times": "回",
        "common.tommorow": "翌日",
        "common.total": "合計",
        "common.training_entity": "実施者",
        "common.travel_expense": "交通費",
        "common.two_months_later": "翌々月",
        "common.type": "種別",
        "common.unemployed": "不就労",
        "common.unit.candidate_job_step": "件",
        "common.unit.company": "社",
        "common.unit.days": "日間",
        "common.unit.item": "件",
        "common.unit.month": "ヵ月",
        "common.unit.person": "名",
        "common.unit.single_month": "月",
        "common.unit.year": "年",
        "common.unnecessary": "不要",
        "common.unselected": "未選択 ▼",
        "common.unselected_only": "未選択",
        "common.update": "保存する",
        "common.update_data": "更新",
        "common.update_status.placefolder": "ステータスを選択 ▼",
        "common.update_user.placeholder": "自社担当者 ▼",
        "common.updated_at": "更新日時",
        "common.updated_error": "失敗しました。",
        "common.updated_success": "変更しました。",
        "common.updated_user_title": "更新者",
        "common.updating": "保存中",
        "common.uploaded_date": "アップロード日時",
        "common.upper": "昇順",
        "common.user": "自社担当者",
        "common.user_change_description": "チェックボックスにチェックを入れて、担当者を設定しましょう",
        "common.user_title": "担当",
        "common.weekly_payment": "週払い",
        "common.welfare_pension": "厚生年金",
        "common.withholding_income_tax": "源泉所得税",
        "common.within_the_statutory": "法定内",
        "common.word": "文字",
        "common.working_conditions": "就業条件",
        "common.working_days": "勤務日数",
        "common.workingood": "ワーキングッド",
        "common.workingood_all": "(株)ワーキングッド",
        "common.years_old": "年齢",
        "common.yen": "円",
        "common.yes": "あり",
        "common_change_after": "置換後",
        "common_change_before": "置換前",
        "common_change_bulk": "置換の一括設定",
        "common_change_bulk_conditions": "置換時の条件",
        "common_change_bulk_example_title": "例) マッチングッド →　matchingood で置換する場合",
        "common_change_bulk_explain": "\/ CSVを取り込むことで、まとめて反映させることもできます。",
        "common_change_bulk_explain_title": "部分一致・完全一致とは？",
        "common_change_parfect_match": "完全一致",
        "common_change_parfect_match_after": "置換後【完全一致】",
        "common_change_parfect_match_explain": "文字列がすべて一致していないと、置換されません。",
        "common_change_partial_match": "部分一致",
        "common_change_partial_match_after": "置換後【部分一致】",
        "common_change_partial_match_explain": "文字列の一部でも一致する箇所があれば置換されます。",
        "common_select_person_in_charge": "担当者を指定してください。",
        "companies": "会社の進捗",
        "companies.address": "連絡先住所",
        "companies.advantage": "会社の売り",
        "companies.affiliate": "関連会社",
        "companies.average_age": "平均年齢",
        "companies.bank": "取引銀行",
        "companies.business_owner ": "事業主ページに飛ぶ",
        "companies.capital": "資本金",
        "companies.code": "コード",
        "companies.company_state_id": "ステータス",
        "companies.company_step_resource_list": "対応一覧",
        "companies.competitor": "競合",
        "companies.create_billing_destination": "請求先を新規作成\/追加",
        "companies.create_contract_memo": "契約メモを新規作成\/追加",
        "companies.create_dispatch_destination": "派遣先を新規作成\/追加",
        "companies.create_dispatch_job": "派遣求人を新規作成\/追加",
        "companies.create_dispatch_organization_unit": "組織単位を新規作成\/追加",
        "companies.create_dispatch_source_career_staff": "キャリア相談担当者を新規作成\/追加",
        "companies.create_dispatch_source_education_training_career": "キャリアアップを新規作成\/追加",
        "companies.create_dispatch_source_education_training_other": "その他を新規作成\/追加",
        "companies.create_dispatch_source_education_training_safety": "安全衛生教育を新規作成\/追加",
        "companies.create_dispatch_source_staff": "派遣元担当者を新規作成\/追加",
        "companies.create_dispatch_working_place": "就業現場を新規作成\/追加",
        "companies.create_job": "紹介求人を新規作成\/追加",
        "companies.create_staff": "会社担当者を新規作成\/追加",
        "companies.deleted.name": "(削除済み企業)",
        "companies.employee_number": "従業員数",
        "companies.environment": "職場の環境",
        "companies.establishment_date": "設立",
        "companies.foreign_capital_rate": "外資比率",
        "companies.future": "今後の展開・将来性",
        "companies.id": "番号",
        "companies.import.title": "インポート(会社)",
        "companies.job_list": "求人一覧",
        "companies.kana": "フリガナ",
        "companies.list_back": "会社一覧に戻る",
        "companies.memo": "メモ",
        "companies.name": "会社名",
        "companies.name_empty": "会社名未登録",
        "companies.name_empty_with_id": "会社名未登録（番号：{id}）",
        "companies.no_assign_user": "自社会社担当者未設定の会社",
        "companies.no_company_step_resource": "対応は登録されていません",
        "companies.no_job": "求人情報は登録されていません",
        "companies.no_staff": "会社担当者は登録されていません",
        "companies.none": "会社の登録がまだありません。",
        "companies.other_office": "本社以外の事業所",
        "companies.public": "株式公開",
        "companies.representative": "代表者",
        "companies.sales": "売上高",
        "companies.show.company": "会社詳細",
        "companies.show.data": "集計",
        "companies.show.dispatch_job_offer": "派遣求人情報",
        "companies.show.file": "契約書・資料",
        "companies.show.image": "画像",
        "companies.show.job_offer": "紹介求人情報",
        "companies.show.progress": "進捗",
        "companies.show.staff": "会社担当者",
        "companies.show.step": "対応",
        "companies.show_back": "会社詳細に戻る",
        "companies.staff_list": "会社担当者一覧",
        "companies.staff_mail_unregister": "会社担当者のメールアドレスが未登録です",
        "companies.staffs.call_mobile": "携帯電話にかける",
        "companies.staffs.call_phone": "電話にかける",
        "companies.staffs.create": "会社担当者を新規作成\/追加",
        "companies.staffs.deleted.name": "(削除済み)",
        "companies.start_matching_candidate_with_job": "希望条件に合う人材を探す",
        "companies.steps.no_steps_description": "履歴はございません。電話対応等を行ったときには右上のボタンよりメモを残して社内共有しましょう。",
        "companies.stockholder": "株主",
        "companies.structure": "組織構成",
        "companies.summary": "事業概要",
        "companies.tel": "代表電話",
        "companies.title_create": "会社情報新規登録",
        "companies.title_edit": "会社情報編集",
        "companies.title_index": "会社情報検索結果",
        "companies.title_search": "会社情報検索",
        "companies.update_user_placeholder": "自社会社担当者 ▼",
        "companies.url": "URL",
        "companies.user": "自社会社担当者",
        "companies.user_change": "自社会社担当者を変更",
        "companies.user_department": "自社会社担当者\/部署",
        "companies.zip": "郵便番号",
        "company.update_user_placeholder": "自社会社担当者 ▼",
        "company_step_resources.company_step_resource_list": "対応一覧",
        "company_step_resources.no_company_step_resource": "対応は登録されていません",
        "company_steps.company_id": "会社",
        "company_steps.company_id_name": "会社ID",
        "company_steps.company_step_state_id": "ステータス",
        "company_steps.end_at": "終了時刻",
        "company_steps.id": "対応番号",
        "company_steps.import.title": "会社対応インポート",
        "company_steps.index.title": "会社対応一覧",
        "company_steps.index.title_explain": "会社対応の件数や詳細を検索できます",
        "company_steps.mail_id": "メールID（会社担当者対応カテゴリーがメールの場合）",
        "company_steps.memo": "メモ",
        "company_steps.staff_id": "会社担当者",
        "company_steps.start_at": "開始時刻",
        "config.account_holder": "口座名",
        "config.account_number": "口座番号",
        "config.agency_license_number": "紹介事業許可番号",
        "config.basic_information_title": "基本情報",
        "config.checking_account": "当座",
        "config.chief_name": "代表者名",
        "config.chief_name_kana": "代表者名（かな）",
        "config.chief_post": "代表者肩書（役名）",
        "config.company_address": "住所",
        "config.company_name": "会社名",
        "config.company_name_kana": "会社名（かな）",
        "config.default_rounding": "端数処理の初期設定",
        "config.example_invoice_text": "例)下記の通り請求致します。",
        "config.fax": "FAX",
        "config.financial_institution": "振込先銀行",
        "config.financial_institution_information": "金融機関情報",
        "config.index.sub_title": "自社情報、請求書情報を設定できます",
        "config.invoice_format_setting": "請求書フォーマット設定",
        "config.invoice_registration_number": "適格請求書発行事業者登録番号",
        "config.invoice_text": "請求書記載文面",
        "config.mail": "E-mail",
        "config.mail_oauth2_client_id": "クライアントID",
        "config.mail_oauth2_client_secret": "クライアントシークレット",
        "config.mail_oauth2_gmail_setting": "Gmail OAuth2設定管理",
        "config.mail_oauth2_office365_setting": "Office365 OAuth2設定管理",
        "config.mail_oauth2_tenant_id": "テナントID",
        "config.other_settings": "その他システム設定",
        "config.round_down": "切り捨て",
        "config.round_down_ones_place": "一の位を切り捨て",
        "config.round_down_tens_place": "十の位を切り捨て",
        "config.round_off": "四捨五入",
        "config.round_up": "切り上げ",
        "config.savings_account": "普通",
        "config.session_life_time": "セッション保持時間 (h)",
        "config.tel": "電話番号",
        "config.zip": "郵便番号",
        "conflict_date_defaults.conflict_date_default_list": "抵触日一覧",
        "conflict_date_defaults.no_conflict_date_default": "抵触日は登録されていません。",
        "contract.update_user_placeholder": "自社契約担当者 ▼",
        "contract_memos.contract_memo_list": "契約メモ",
        "contract_memos.list_back": "契約一覧に戻る",
        "contract_memos.no_contract_memo": "契約メモがありません。",
        "contract_memos.show.contract_memos": "契約メモの詳細",
        "contracts.add_contracts": "新規契約追加",
        "contracts.bulk_extension": "契約を一括延長",
        "contracts.bulk_extension.confirm_limit_msg1": "対象データが51件以上選択されているため、契約延長できません。",
        "contracts.bulk_extension.confirm_limit_msg2": "50件以下にしてください。",
        "contracts.bulk_extension.confirm_limit_msg3": "選択件数: ",
        "contracts.bulk_extension.confirm_msg": "この内容で契約を一括延長しますか？",
        "contracts.bulk_extension.conflict_date": "派遣終了日が契約時の人材毎の抵触日と同日または超えています。",
        "contracts.bulk_extension.conflict_destination_date": "派遣終了日が契約時の派遣先毎の抵触日と同日または超えています。",
        "contracts.bulk_extension.notification_failed": "契約一括延長処理が失敗しました。",
        "contracts.bulk_extension.notification_finished": "契約一括延長処理が成功しました。",
        "contracts.bulk_extension.notification_no_contract": "対象データが存在しないため処理を実行しませんでした。",
        "contracts.bulk_extension.notification_start": "契約一括延長処理を開始します。",
        "contracts.bulk_extension.toast_msg": "契約の一括延長処理を開始しました。",
        "contracts.contract_list": "契約リスト",
        "contracts.id": "契約番号",
        "contracts.import.title": "インポート(契約)",
        "contracts.list_back": "契約一覧に戻る",
        "contracts.menu.file": "派遣契約\/管理",
        "contracts.menu.file_title": "添付された契約書類などを見る",
        "contracts.menu.memo": "契約メモ",
        "contracts.name_empty": "契約名未登録",
        "contracts.no_contract": "契約は登録されていません",
        "contracts.show.candidate_education_and_training": "教育訓練",
        "contracts.show.candidate_employment_stability_measure": "雇用安定措置",
        "contracts.show.contracts": "契約の詳細",
        "criterion.call": "保存済の条件を呼び出す",
        "criterion.call_title": "条件を呼び出す",
        "csvSettings.insert_line_break": "カーソル位置に\r\n改行を挿入",
        "csvSettings.upload_replace_batch": "一括置換を反映しました。",
        "dashboard.all_users": "全ての担当者",
        "dashboard.candidate_user": "自社人材担当者",
        "dashboard.case": "件",
        "dashboard.check_all": "全て選択する",
        "dashboard.company_manager": "会社担当",
        "dashboard.company_name": "応募会社",
        "dashboard.company_staff": "会社担当",
        "dashboard.csv_export.button_information": "現在の検索条件でダッシュボードに表示されているデータ全てをCSV出力します",
        "dashboard.delete_criterion.success": "検索条件を削除しました",
        "dashboard.first_calendar_placeholder": "開始日",
        "dashboard.incumbent": "前職もしくは現職",
        "dashboard.job_id": "求人番号",
        "dashboard.job_user": "自社求人担当者",
        "dashboard.last_calendar_placeholder": "終了日",
        "dashboard.last_interview": "面談",
        "dashboard.last_step": "最新進捗",
        "dashboard.memo_history_category": "対応履歴（カテゴリー）",
        "dashboard.memo_history_detail": "対応履歴（詳細）",
        "dashboard.no_assign_user": "担当者未設定",
        "dashboard.no_date": "日時指定なし",
        "dashboard.no_staff": "未定",
        "dashboard.no_step": "進捗なし",
        "dashboard.none.add": "を新規追加",
        "dashboard.none.add_candidate": "人材を新規追加",
        "dashboard.none.add_company": "会社を新規追加",
        "dashboard.none.add_job": "求人を新規追加",
        "dashboard.none.candidate_step": "人材の登録がまだありません。",
        "dashboard.none.company_step": "会社の登録がまだありません。",
        "dashboard.none.job_step": "求人の登録がまだありません。",
        "dashboard.popup.alert_only": "警告ありのみで絞り込む",
        "dashboard.popup.apply_lower_sort": "選考（段階）の降順で並び替える",
        "dashboard.popup.apply_upper_sort": "選考（段階）の昇順で並び替える",
        "dashboard.popup.cancel": "キャンセル",
        "dashboard.popup.candidate_name": "人材",
        "dashboard.popup.caution_sort": "警告ありを優先で並び替える",
        "dashboard.popup.company_name": "求人会社",
        "dashboard.popup.create_progress": "新しい進捗を作成",
        "dashboard.popup.current_step": "現在のステップ",
        "dashboard.popup.empty_date": "日時を指定しない",
        "dashboard.popup.find_job": "この人材に合う求人を探す",
        "dashboard.popup.hidder_title": "非表示の進捗",
        "dashboard.popup.interviewer": "面接担当者氏名",
        "dashboard.popup.next_step": "次回のステップ",
        "dashboard.popup.not_caution_sort": "警告なしを優先で並び替える",
        "dashboard.popup.ok": "OK",
        "dashboard.popup.progress_date": "進捗日時",
        "dashboard.popup.progress_detail": "進捗詳細",
        "dashboard.popup.select_all_steps": "すべてのステップを選択可能にする",
        "dashboard.popup.select_date": "日にちを選択",
        "dashboard.popup.sort_placeholder": "項目内検索",
        "dashboard.popup.sort_title": "並び替え",
        "dashboard.popup.text_lower_sort": "降順で並び替える",
        "dashboard.popup.text_upper_sort": "昇順で並び替える",
        "dashboard.popup.time_lower_sort": "日時の古い順で並び替える",
        "dashboard.popup.time_upper_sort": "日時の新しい順で並び替える",
        "dashboard.popup.update_progress": "進捗を作成する",
        "dashboard.popup.update_progress_edit": "進捗を変更する",
        "dashboard.refine_title": "表示する最新進捗",
        "dashboard.save_criterion.success": "検索条件を保存しました",
        "dashboard.search_placeholder": "人材名、会社名、求人番号など",
        "dashboard.states_filter_text": "表示設定",
        "dashboard.title.candidates": "人材進捗",
        "dashboard.title.companies": "営業進捗",
        "dashboard.title.jobs": "求人進捗",
        "dashboard.warning": "警告",
        "dashboard.warning_explain": "警告は対応進捗に応じて表示されます。",
        "dashboard.warning_message": "{stepName}から{diffDays}日が経過しました。",
        "data.condition.cancel": "キャンセル",
        "data.condition.create": "条件を保存",
        "data.condition.create_success": "集計条件を保存しました。",
        "data.condition.delete": "削除する",
        "data.condition.delete_confirm": "選択した集計条件を削除します。よろしいですか？",
        "data.condition.delete_success": "集計条件を削除しました。",
        "data.condition.duplicate_confirm": "すでに同じ条件での登録がありますが、登録しますか？",
        "data.condition.end_date": "終了日",
        "data.condition.error.name": "条件名を入力してください",
        "data.condition.error.target": "集計対象を選択してください",
        "data.condition.error.xaxis": "横軸を選択してください",
        "data.condition.error.yaxis": "縦軸を選択してください",
        "data.condition.input.name": "条件名",
        "data.condition.input.nullable": "任意",
        "data.condition.input.required": "必須",
        "data.condition.input.target": "集計対象",
        "data.condition.input.xaxis": "横軸",
        "data.condition.input.yaxis": "縦軸",
        "data.condition.label": "設定済みの条件",
        "data.condition.load": "保存済の条件を呼び出す",
        "data.condition.placeholder.name": "条件名を入力してください",
        "data.condition.placeholder.target": "集計対象を選択 ▼",
        "data.condition.placeholder.xaxis": "横軸を選択 ▼",
        "data.condition.placeholder.xaxis.category": "カテゴリー",
        "data.condition.placeholder.xaxis.step": "ステップ",
        "data.condition.placeholder.yaxis": "縦軸を選択 ▼",
        "data.condition.save": "保存する",
        "data.condition.select_category": "使用するカテゴリーを選ぶ",
        "data.condition.select_period": "期間を選択",
        "data.condition.select_status": "使用する進捗ステータスを選ぶ",
        "data.condition.start_date": "開始日",
        "data.condition.summary": "集計する",
        "data.condition.update": "編集する",
        "data.condition.update_success": "集計条件を更新しました。",
        "data.table.label.null": "指定なし",
        "data.table.label.reference": "基準",
        "data.table.messages.over_limit": "縦横いずれかの項目が表示最大件数{limit}件を超えました。\r\n全件ご覧頂きたい場合はCSV出力をしてください。",
        "data.table.output_csv": "結果をCSV出力",
        "data.table.period_1month": "直近1ヶ月を表示",
        "data.table.period_3months": "直近3ヶ月を表示",
        "data.table.period_6months": "直近6ヶ月を表示",
        "data.table.unit.item": "件",
        "data.table.unit.person": "名",
        "data.table.value.null": "NULL",
        "data.title": "集計",
        "data.title.explain": "マッチングッドに登録済の情報を集計します",
        "datetime.datetime_md": "n\/j",
        "datetime.datetime_md_hm": "n\/j G{i}",
        "datetime.datetime_ymd": "Y\/n\/j",
        "datetime.datetime_ymd_hm": "Y\/n\/j G{i}",
        "datetime.last_month": "先月",
        "datetime.moment.amount_over_short_tr.format": "YYYY年M月D日 (ddd)",
        "datetime.moment.datetime_md_hm": "YYYY-MM-DD HH&#58;mm",
        "datetime.next_month": "来月",
        "datetime.next_week": "一週間後",
        "datetime.today": "今日",
        "datetime.tomorrow": "明日",
        "datetime.yesterday": "昨日",
        "deleted": "削除済み",
        "deny": "Deny",
        "departments.confirm.delete": "部署項目を削除します。よろしいですか",
        "departments.create_success": "部署項目を作成いたしました",
        "departments.delete_success": "部署項目を削除いたしました",
        "departments.title_all": "全ての部署",
        "departments.update_success": "部署項目を更新いたしました",
        "description.billing_destinations.index": "請求先一覧の説明",
        "description.candidate_career_counsellings.index": "キャリア相談の件数や詳細を検索できます",
        "description.candidate_education_and_trainings.index": "教育訓練の件数や詳細を検索できます",
        "description.candidate_employment_stability_measures.index": "雇用安定措置の件数や詳細を検索できます",
        "description.candidate_job_step_resources.index": "進捗の件数や詳細を検索できます",
        "description.candidate_step_resources.index": "人材対応の件数や詳細を検索できます",
        "description.candidate_steps.index": "人材対応の件数や詳細を検索できます",
        "description.candidates.index": "一括メール送信・自社人材担当者変更なども行えます",
        "description.companies.index": "一括メール送信・自社会社担当者変更なども行えます",
        "description.company_step_resources.index": "会社対応の件数や詳細を検索できます",
        "description.company_steps.index": "会社対応の件数や詳細を検索できます",
        "description.conflict_date_managements.index": "抵触日や、抵触日に付随する内容が確認できます",
        "description.contracts.index": "契約一覧の説明",
        "description.dispatch_destinations.index": "派遣先一覧の説明",
        "description.dispatch_jobs.index": "一括メール送信・自社派遣求人担当変更なども行えます",
        "description.dispatch_organization_units.index": "組織単位一覧の説明",
        "description.dispatch_source_staffs.index": "派遣元担当者一覧の説明",
        "description.dispatch_sources.index": "派遣元や派遣元担当者の設定や、追加が行えます。",
        "description.dispatch_staffs.index": "派遣先担当者一覧の説明",
        "description.dispatch_working_places.index": "就業現場一覧の説明",
        "description.jobs.index": "求人票のダウンロード・自社紹介求人担当者変更なども行えます",
        "description.sales.index": "売上\/返金の編集ができます",
        "description.staffs.index": "一括メール送信・自社人材担当者変更なども行えます",
        "dispatch_destination.update_user_placeholder": "自社派遣先担当者 ▼",
        "dispatch_destination_conflict_date_managements.conflict_date_managements_list": "抵触日一覧",
        "dispatch_destination_conflict_date_managements.no_conflict_date_managements": "抵触日は登録されていません。",
        "dispatch_destinations.conflict_date": "抵触日",
        "dispatch_destinations.conflict_date_candidate": "人材ごとの抵触日",
        "dispatch_destinations.conflict_date_dispatch_destination": "派遣先ごとの抵触日",
        "dispatch_destinations.contract": "契約",
        "dispatch_destinations.create_dispatch_staffs": "派遣先担当者を新規作成\/追加",
        "dispatch_destinations.dispatch_destination_list": "派遣先一覧",
        "dispatch_destinations.import.title": "インポート(派遣先)",
        "dispatch_destinations.list_back": "派遣先一覧に戻る",
        "dispatch_destinations.menu.apply": "進捗",
        "dispatch_destinations.menu.apply_title": "進捗を見る",
        "dispatch_destinations.name": "派遣先名",
        "dispatch_destinations.name_empty": "派遣先名未登録",
        "dispatch_destinations.no_assign_user": "自社派遣先担当者未設定の派遣先",
        "dispatch_destinations.no_dispatch_destination": "派遣先が登録されていません",
        "dispatch_destinations.select_company": "派遣先情報の会社を選択 ▼",
        "dispatch_destinations.show.dispatch_destinations": "派遣先詳細",
        "dispatch_destinations.show.dispatch_jobs": "派遣求人情報",
        "dispatch_destinations.show.dispatch_organization_units": "組織単位",
        "dispatch_destinations.show.dispatch_staffs": "派遣先担当者",
        "dispatch_destinations.show.dispatch_working_places": "就業現場",
        "dispatch_destinations.update_user_placeholder": "自社派遣先担当者 ▼",
        "dispatch_destinations.user": "自社派遣先担当者",
        "dispatch_destinations.user_change": "自社派遣先担当者を変更",
        "dispatch_destinations.user_department": "自社派遣先担当者\/部署",
        "dispatch_job.update_user_placeholder": "自社派遣求人担当者 ▼",
        "dispatch_jobs.dispatch_job_list": "派遣求人一覧",
        "dispatch_jobs.import.title": "インポート(派遣求人)",
        "dispatch_jobs.list_back": "派遣求人一覧に戻る",
        "dispatch_jobs.matching.candidates.link": "希望条件に合う人材を探す",
        "dispatch_jobs.matching.candidates.title": "希望条件に合う人材を探す",
        "dispatch_jobs.matching.candidates.title_explain": "人材を探して、紹介や推薦ができます",
        "dispatch_jobs.menu.file": "派遣求人票",
        "dispatch_jobs.menu.file_title": "添付された派遣求人票などを見る",
        "dispatch_jobs.no_assign_user": "自社派遣求人担当者未設定の派遣求人",
        "dispatch_jobs.no_data": "派遣求人の情報はありません",
        "dispatch_jobs.no_dispatch_job": "派遣求人情報は登録されていません",
        "dispatch_jobs.none": "派遣求人の登録がまだありません。",
        "dispatch_jobs.show.dispatch_jobs": "派遣求人の詳細",
        "dispatch_jobs.update_user_placeholder": "自社派遣求人担当者 ▼",
        "dispatch_jobs.user": "自社派遣求人担当者",
        "dispatch_jobs.user_change": "自社派遣求人担当者を変更",
        "dispatch_jobs.user_department": "自社派遣求人担当者\/部署",
        "dispatch_organization_units.deleted.name": "削除済み組織単位",
        "dispatch_organization_units.dispatch_organization_unit_list": "組織単位リスト",
        "dispatch_organization_units.import.title": "インポート(組織単位)",
        "dispatch_organization_units.list_back": "組織単位一覧に戻る",
        "dispatch_organization_units.name_empty": "組織単位名未登録",
        "dispatch_organization_units.no_dispatch_organization_unit": "組織単位は登録されていません",
        "dispatch_organization_units.show.dispatch_organization_units": "組織単位詳細",
        "dispatch_source_career_staffs.dispatch_source_career_staff_list": "キャリア相談担当者",
        "dispatch_source_career_staffs.no_dispatch_source_career_staff": "キャリア相談担当者は登録されていません",
        "dispatch_source_career_staffs.show.dispatch_source_career_staffs": "キャリア相談担当者詳細",
        "dispatch_source_education_training_careers.dispatch_source_education_training_career_list": "キャリアアップ",
        "dispatch_source_education_training_careers.list_back": "派遣元設定に戻る",
        "dispatch_source_education_training_careers.no_dispatch_source_education_training_career": "キャリアアップは登録されていません",
        "dispatch_source_education_training_careers.show.dispatch_source_education_training_careers": "教育訓練マスター",
        "dispatch_source_education_training_others.dispatch_source_education_training_other_list": "その他",
        "dispatch_source_education_training_others.list_back": "派遣元設定に戻る",
        "dispatch_source_education_training_others.no_dispatch_source_education_training_other": "その他は登録されていません",
        "dispatch_source_education_training_others.show.dispatch_source_education_training_others": "教育訓練マスター",
        "dispatch_source_education_training_safeties.dispatch_source_education_training_safety_list": "安全衛生教育",
        "dispatch_source_education_training_safeties.list_back": "派遣元設定に戻る",
        "dispatch_source_education_training_safeties.no_dispatch_source_education_training_safety": "安全衛生教育は登録されていません",
        "dispatch_source_education_training_safeties.show.dispatch_source_education_training_safeties": "教育訓練マスター",
        "dispatch_source_staffs.dispatch_source_staff_list": "派遣元担当者",
        "dispatch_source_staffs.import.title": "インポート(派遣元担当者)",
        "dispatch_source_staffs.no_dispatch_source_staff": "派遣元担当者は登録されていません",
        "dispatch_source_staffs.select_dispatch_sources": "担当の派遣元を選択 ▼",
        "dispatch_source_staffs.show.dispatch_source_staffs": "派遣元担当者詳細",
        "dispatch_sources.import.title": "インポート(派遣元)",
        "dispatch_sources.index.create": "派遣元の新規追加",
        "dispatch_sources.list_back": "派遣元設定に戻る",
        "dispatch_sources.name": "派遣元事業所名",
        "dispatch_sources.name_empty": "派遣元事業所名未登録",
        "dispatch_sources.show.dispatch_source_career_staff": "キャリア相談担当者",
        "dispatch_sources.show.dispatch_source_education_training": "教育訓練マスター",
        "dispatch_sources.show.dispatch_source_staff": "派遣元担当者",
        "dispatch_sources.show.dispatch_sources": "派遣元詳細",
        "dispatch_staffs.dispatch_staff_list": "派遣先担当者一覧",
        "dispatch_staffs.import.title": "インポート(派遣先担当者)",
        "dispatch_staffs.list_back": "派遣先担当一覧に戻る",
        "dispatch_staffs.name_empty": "派遣先担当者名未登録",
        "dispatch_staffs.no_dispatch_staff": "派遣先担当者は登録されていません",
        "dispatch_staffs.show.dispatch_staffs": "派遣先担当者詳細",
        "dispatch_working_places.dispatch_working_place_list": "就業現場リスト",
        "dispatch_working_places.import.title": "インポート(就業現場)",
        "dispatch_working_places.list_back": "就業現場一覧に戻る",
        "dispatch_working_places.name_empty": "就業現場名未登録",
        "dispatch_working_places.no_dispatch_working_place": "就業現場は登録されていません",
        "dispatch_working_places.show.dispatch_working_places": "就業現場の情報",
        "display_setting.alert_saving": "変更内容を保存してください。",
        "display_setting.all_item_setting": "全体",
        "display_setting.amount_over_short_item_master_calling": "過不足金マスタ呼び出し",
        "display_setting.amount_over_short_item_master_name": "過不足金マスタ名称",
        "display_setting.amount_over_short_item_setting": "過不足金マスター設定",
        "display_setting.amount_over_short_item_setting_add": "過不足金の新規追加",
        "display_setting.amount_over_short_item_setting_edit": "過不足金の編集",
        "display_setting.amount_over_short_item_setting_label_allowance_id": "手当",
        "display_setting.amount_over_short_item_setting_label_amount_over_short_type_id": "種別",
        "display_setting.amount_over_short_item_setting_label_invoice_amount": "請求過不足金額",
        "display_setting.amount_over_short_item_setting_label_invoice_taxation_type_id": "請求過不足金課税\/非課税",
        "display_setting.amount_over_short_item_setting_label_is_base_employment_insurance": "雇用保険算定の基礎とする",
        "display_setting.amount_over_short_item_setting_label_is_base_employment_insurance.on": "雇用保険算定とする",
        "display_setting.amount_over_short_item_setting_label_is_not_year_end_adjustment": "年末調整還付\/追加徴収しない",
        "display_setting.amount_over_short_item_setting_label_is_year_end_adjustment": "年末調整還付\/追加徴収する",
        "display_setting.amount_over_short_item_setting_label_name": "過不足金名称",
        "display_setting.amount_over_short_item_setting_label_payment_amount": "支払過不足金額",
        "display_setting.amount_over_short_item_setting_label_payment_taxation_type_id": "支払過不足金課税\/非課税",
        "display_setting.amount_over_short_item_setting_label_tax_rate_id": "消費税",
        "display_setting.amount_over_short_item_setting_label_year_end_add_adjustment": "年末調整還付\/追加徴収する",
        "display_setting.amount_over_short_item_setting_label_year_end_adjustment": "年末調整還付\/追加徴収",
        "display_setting.amount_over_short_item_setting_label_year_end_no_adjustment": "年末調整還付\/追加徴収しない",
        "display_setting.billing_destinations": "請求先",
        "display_setting.candidate_career_counsellings": "キャリア相談",
        "display_setting.candidate_education_and_trainings": "教育訓練",
        "display_setting.candidate_employment_stability_measures": "雇用安定措置",
        "display_setting.candidate_item_setting": "人材項目設定",
        "display_setting.candidate_job_step_resources": "進捗",
        "display_setting.candidate_job_step_resources_setting": "進捗表示項目設定",
        "display_setting.candidate_step_resources": "人材対応",
        "display_setting.candidate_step_resources_setting": "人材表示項目設定",
        "display_setting.candidates": "人材項目設定",
        "display_setting.caution": "変更内容が保存されていません。移動をすると変更内容が破棄されます。",
        "display_setting.company_item_setting": "会社項目設定",
        "display_setting.company_step_resources": "会社対応",
        "display_setting.company_step_resources_setting": "会社表示項目設定",
        "display_setting.company_sublists_progress": "進捗",
        "display_setting.company_sublists_setting": "サブリスト項目設定",
        "display_setting.company_sublists_staff": "会社担当者",
        "display_setting.contract_item_setting": "契約項目設定",
        "display_setting.contracts": "契約",
        "display_setting.contracts_related_over_short_cash_add": "契約に紐づく過不足金の新規追加",
        "display_setting.dashboard_item_content": "表示する内容",
        "display_setting.dashboard_item_display": "表示項目",
        "display_setting.dashboard_item_display_name": "表示名",
        "display_setting.dashboard_item_movement": "移動",
        "display_setting.dashboard_item_no_scroll_description": "ここより上の項目は横スクロールしないエリアとなります。",
        "display_setting.dashboard_item_setting": "ダッシュボード項目設定",
        "display_setting.dashboard_item_setting_sub_title": "ダッシュボードに表示する項目の変更や並び替えができます",
        "display_setting.dashboard_item_show": "表示",
        "display_setting.dashboard_progress_column_title": "進捗\/対応",
        "display_setting.dashboard_progress_display_dashboard": "ダッシュボード\n項目に表示",
        "display_setting.dashboard_progress_display_setting": "進捗\/対応 表示設定",
        "display_setting.dashboard_progress_display_sort": "※進捗の並び替えは進捗項目設定から設定できます。",
        "display_setting.department_item_balloon_name": "部署名",
        "display_setting.department_item_create": "新規部署項目追加",
        "display_setting.department_item_setting": "部署項目設定",
        "display_setting.department_item_setting_sub_title": "部署の編集削除ができます",
        "display_setting.dispatch_destination_item_setting": "派遣先項目設定",
        "display_setting.dispatch_destinations": "派遣先",
        "display_setting.dispatch_item_setting": "{modelName}マスター設定",
        "display_setting.dispatch_item_setting_add": "過不足金の新規追加",
        "display_setting.dispatch_item_setting_edit": "過不足金の編集",
        "display_setting.dispatch_item_setting_employment_insurance_calc": "雇用保険算定とする",
        "display_setting.dispatch_item_setting_employment_insurance_calc_base": "雇用保険算定の基礎とする",
        "display_setting.dispatch_item_setting_label_name": "過不足金名称",
        "display_setting.dispatch_item_setting_name": "過不足金",
        "display_setting.dispatch_item_setting_non_taxable": "非課税",
        "display_setting.dispatch_item_setting_not_employment_insurance_calc_base": "雇用保険算定の基礎としない",
        "display_setting.dispatch_item_setting_overcharged_amount": "請求過不足金額",
        "display_setting.dispatch_item_setting_overcharged_tax_select": "請求過不足金課税\/非課税",
        "display_setting.dispatch_item_setting_overcharged_type_select": "種別",
        "display_setting.dispatch_item_setting_overpayment_amount": "支払過不足金額",
        "display_setting.dispatch_item_setting_overpayment_norepeat_date": "計上日",
        "display_setting.dispatch_item_setting_overpayment_tax_select": "支払過不足金課税\/非課税",
        "display_setting.dispatch_item_setting_prepaid": "前払い",
        "display_setting.dispatch_item_setting_refer": "過不足金の参照",
        "display_setting.dispatch_item_setting_sub_title": "{modelName}マスター項目を設定できます",
        "display_setting.dispatch_item_setting_taxable": "課税",
        "display_setting.dispatch_item_setting_type": "種別",
        "display_setting.dispatch_jobs": "派遣求人",
        "display_setting.dispatch_jobs_related_over_short_cash_add": "求人に紐づく過不足金の新規追加",
        "display_setting.dispatch_organization_units": "組織単位",
        "display_setting.dispatch_source_setting": "派遣元項目設定",
        "display_setting.dispatch_source_staffs": "派遣元担当者",
        "display_setting.dispatch_sources": "項目設定",
        "display_setting.dispatch_staffs": "派遣先担当者",
        "display_setting.dispatch_working_places": "就業現場",
        "display_setting.display_list_caution_description": "空欄・空行は詰めて表示されます",
        "display_setting.display_list_content_title": "{primaryModelName}一覧画面に表示する項目の設定",
        "display_setting.fraction_process_item_setting": "端数処理マスター設定",
        "display_setting.fraction_process_item_setting_add": "端数処理の新規追加",
        "display_setting.fraction_process_item_setting_edit": "端数処理の編集",
        "display_setting.fraction_process_item_setting_label_calc_time_unit": "時間計算単位",
        "display_setting.fraction_process_item_setting_label_first_day_of_the_week_type_id": "週規定曜日",
        "display_setting.fraction_process_item_setting_label_insurance_rounding_type_id": "保険端数処理",
        "display_setting.fraction_process_item_setting_label_less_yen_rounding_type_id": "請求\/支払金額端数処理",
        "display_setting.fraction_process_item_setting_label_name": "端数処理名称",
        "display_setting.fraction_process_item_setting_label_rounding_unit_type_id": "丸め処理単位",
        "display_setting.fraction_process_item_setting_label_tax_rounding_type_id": "消費税端数処理",
        "display_setting.fraction_process_item_setting_label_time_rounding_type_id": "請求\/支払時間端数処理",
        "display_setting.fraction_process_item_setting_sub_title": "端数処理マスター項目を設定できます",
        "display_setting.free_items_group_can_not_delete_message": "{referenceCount}件の項目に設定されているため削除できません",
        "display_setting.free_items_group_edit_alert_1": "※注意 登録されている選択肢の削除が含まれています。",
        "display_setting.free_items_group_edit_alert_2": "すでに登録済みデータの当該選択肢データも削除される事を理解の上、保存してください。",
        "display_setting.free_items_group_item_balloon_name": "選択肢グループ名",
        "display_setting.free_items_group_item_create": "新規選択肢を追加",
        "display_setting.free_items_group_item_name_placeholder": "選択肢グループ名を入力してください",
        "display_setting.free_items_group_item_setting": "選択肢項目設定",
        "display_setting.free_items_group_item_setting_add_item": "選択肢の登録・編集",
        "display_setting.free_items_group_item_setting_select": "選択肢グループの設定",
        "display_setting.free_items_group_item_setting_sub_title": "選択肢項目を設定できます。",
        "display_setting.half_holiday_allocation_hour": "半休充当時間",
        "display_setting.invoice_fraction_process_item_setting_label_less_yen_rounding_type_id": "請求金額端数処理",
        "display_setting.invoice_fraction_process_item_setting_label_time_rounding_type_id": "請求時間端数処理",
        "display_setting.item_setting": "項目設定",
        "display_setting.item_setting_add_choice": "+ 選択肢を追加",
        "display_setting.item_setting_add_choice_textarea": "+ 選択肢の一括追加",
        "display_setting.item_setting_add_item": "+自由項目を追加",
        "display_setting.item_setting_add_search_item": "+検索項目を追加",
        "display_setting.item_setting_alias": "項目識別子",
        "display_setting.item_setting_category_name_item_name": "カテゴリー名・項目名",
        "display_setting.item_setting_category_name_title": "カテゴリー名",
        "display_setting.item_setting_character_limit_inconsistency": "最小文字数は最大文字数よりも少ない数値を入力してください。",
        "display_setting.item_setting_character_limit_least": "最小",
        "display_setting.item_setting_character_limit_letters": "文字",
        "display_setting.item_setting_character_limit_maximum": "最大",
        "display_setting.item_setting_character_limit_title": "文字数制限",
        "display_setting.item_setting_character_limit_title.form": "文字数",
        "display_setting.item_setting_character_limit_unspecified": "指定なし",
        "display_setting.item_setting_checkbox": "チェックボックス",
        "display_setting.item_setting_choices_cannot_show": "この項目は選択肢を登録・編集できません",
        "display_setting.item_setting_choices_placeholder": "選べる選択肢を入力してください",
        "display_setting.item_setting_common_label": "人材\/会社\/求人 共通項目",
        "display_setting.item_setting_data": "集計に表示",
        "display_setting.item_setting_data_tooltip": "詳細・一覧画面の集計欄に表示されるようになります",
        "display_setting.item_setting_date": "日付選択",
        "display_setting.item_setting_date_choices": "年月日",
        "display_setting.item_setting_date_choices_title": "選択可能範囲",
        "display_setting.item_setting_digit": "桁",
        "display_setting.item_setting_digit_limit_inconsistency": "最小桁数は最大桁数よりも少ない数値を入力してください。",
        "display_setting.item_setting_digit_limit_title": "範囲",
        "display_setting.item_setting_display": "表示",
        "display_setting.item_setting_display_after_decimal_point": "小数点以下表示",
        "display_setting.item_setting_display_after_decimal_point_calc": "小数点以下の桁数",
        "display_setting.item_setting_display_description": "この項目は表示を切り替えることはできません",
        "display_setting.item_setting_display_disabled_required_setting": "この項目はシステム固定のため切り替えることはできません",
        "display_setting.item_setting_emphasis_item_description": "登録・編集・詳細の画面で、この項目名を強調します。",
        "display_setting.item_setting_emphasis_item_title": "強調表示",
        "display_setting.item_setting_enter_required_item_description": "登録・編集時に、この項目を必須項目にします。",
        "display_setting.item_setting_enter_required_item_title": "必須項目",
        "display_setting.item_setting_formula": "計算式",
        "display_setting.item_setting_formula_edit": "計算式の登録・編集",
        "display_setting.item_setting_formula_edit_placeholder": "計算式を入力してください",
        "display_setting.item_setting_hide": "非表示",
        "display_setting.item_setting_initial_display": "初期表示",
        "display_setting.item_setting_initial_group": "選択肢グループ",
        "display_setting.item_setting_initial_mode": "初期値モード",
        "display_setting.item_setting_initial_mode_fixed": "固定データ",
        "display_setting.item_setting_initial_mode_resource": "関連リソースデータ参照",
        "display_setting.item_setting_insert_below": "の下に挿入",
        "display_setting.item_setting_insert_on": "の上に挿入",
        "display_setting.item_setting_insert_point": "挿入箇所",
        "display_setting.item_setting_item_input_category_display_name": "入力形式",
        "display_setting.item_setting_item_name_placeholder": "項目名を入力してください",
        "display_setting.item_setting_item_name_title": "項目名",
        "display_setting.item_setting_limit_unavailable": "「,」や「.」は使用できません。",
        "display_setting.item_setting_master_edit": "選択肢の登録・編集",
        "display_setting.item_setting_month_year_choices": "年月",
        "display_setting.item_setting_move": "移動",
        "display_setting.item_setting_no_delete_candidate_job_step_states": "この項目はすでに使用されているため、削除できません",
        "display_setting.item_setting_no_delete_category": "項目のあるカテゴリは削除できません",
        "display_setting.item_setting_no_delete_child_category": "このカテゴリーは削除できません",
        "display_setting.item_setting_no_delete_column": "この項目は削除できません",
        "display_setting.item_setting_no_delete_department": "この部署項目は削除できません",
        "display_setting.item_setting_no_delete_items": "この項目はすでに使用されているため、削除できません",
        "display_setting.item_setting_no_delete_step_states": "この項目はすでに使用されているため、削除できません",
        "display_setting.item_setting_no_draggable": "この項目はカテゴリー内でのみ移動できます",
        "display_setting.item_setting_no_draggable_in_category": "このカテゴリーは並び替えできません",
        "display_setting.item_setting_no_edit_category": "このカテゴリーは編集できません",
        "display_setting.item_setting_no_edit_delete": "このカテゴリー項目は追加・削除できません",
        "display_setting.item_setting_no_editable": "このカテゴリーは編集できません",
        "display_setting.item_setting_no_editable_column": "この項目は編集できません",
        "display_setting.item_setting_no_formula": "計算式は未入力です",
        "display_setting.item_setting_no_item_name": "検索項目名を入力してください",
        "display_setting.item_setting_no_search_properties": "検索する項目を選択してください",
        "display_setting.item_setting_number_lines": "表示行数",
        "display_setting.item_setting_number_lines_placeholder": "行数を入力してください",
        "display_setting.item_setting_operation": "操作",
        "display_setting.item_setting_property_category_place_holder": "カテゴリー名を入力してください",
        "display_setting.item_setting_pull_down": "プルダウン",
        "display_setting.item_setting_radio": "ラジオボタン",
        "display_setting.item_setting_recommended_mail_output_description": "推薦や案件紹介メールを送る際、この項目をメール本文に記載した状態にします。",
        "display_setting.item_setting_recommended_mail_output_title": "メール出力",
        "display_setting.item_setting_reference": "参照先",
        "display_setting.item_setting_sales": "売上に表示",
        "display_setting.item_setting_sales_tooltip": "未登録売上画面に表示されるようになります",
        "display_setting.item_setting_select": "+ クリックで選択肢を追加します",
        "display_setting.item_setting_tab_move_title": "タブの移動",
        "display_setting.item_setting_tab_name_title": "タブ名",
        "display_setting.item_setting_text_free": "テキストボックス (自由)",
        "display_setting.item_setting_text_number": "テキストボックス (数値)",
        "display_setting.item_setting_text_url": "テキストボックス (URL)",
        "display_setting.item_setting_textarea": "テキストエリア",
        "display_setting.item_setting_textarea_placeholder": "改行ごとに選択肢を一括追加できます\r\n入力例）\r\n選択肢1\r\n選択肢2",
        "display_setting.item_setting_time_choices": "年月日 時分",
        "display_setting.item_setting_unit_placeholder": "単位を入力してください",
        "display_setting.item_setting_unit_title": "単位",
        "display_setting.item_setting_unregistered": "未登録",
        "display_setting.job_item_setting": "求人項目設定",
        "display_setting.jobs": "紹介求人",
        "display_setting.option": "選択肢",
        "display_setting.option_division": "選択肢区分",
        "display_setting.option_setting_add_item": "選択肢を追加",
        "display_setting.paid_leaves_item_setting": "有給休暇マスター設定",
        "display_setting.paid_leaves_item_setting_after_month": "ヶ月後",
        "display_setting.paid_leaves_item_setting_after_year_first_time": "初回から1年後",
        "display_setting.paid_leaves_item_setting_first_grant": "有給休暇の初回付与",
        "display_setting.paid_leaves_item_setting_fixed_date": "日付固定",
        "display_setting.paid_leaves_item_setting_from_joining": "入社日から",
        "display_setting.paid_leaves_item_setting_granted_days": "有給休暇付与日数",
        "display_setting.paid_leaves_item_setting_second_grant": "有給休暇2回目付与",
        "display_setting.paid_leaves_item_setting_sub_title": "有給休暇マスタ項目を設定できます",
        "display_setting.paid_leaves_item_setting_year_working_days": "年間労働日数",
        "display_setting.payment_date_settings_item_setting": "支払マスター設定",
        "display_setting.payment_date_settings_item_setting_sub_title": "支払マスタ項目を設定できます",
        "display_setting.payment_fraction_process_item_setting_label_less_yen_rounding_type_id": "支払金額端数処理",
        "display_setting.payment_fraction_process_item_setting_label_time_rounding_type_id": "支払時間端数処理",
        "display_setting.price_information_item_setting": "料金情報マスタ設定",
        "display_setting.price_information_item_setting_absence_deduction": "欠勤控除",
        "display_setting.price_information_item_setting_add": "料金情報の新規追加",
        "display_setting.price_information_item_setting_basic_price": "基本単価",
        "display_setting.price_information_item_setting_calling": "料金情報マスタ呼び出し",
        "display_setting.price_information_item_setting_early_work_correspondence": "早出への対応",
        "display_setting.price_information_item_setting_early_work_denied": "早出を認めない",
        "display_setting.price_information_item_setting_edit": "料金情報の編集",
        "display_setting.price_information_item_setting_label_name": "料金情報名称",
        "display_setting.price_information_item_setting_legal_holiday_price": "法定休日出勤単価",
        "display_setting.price_information_item_setting_legal_overtime_price": "法定内残業単価",
        "display_setting.price_information_item_setting_master_name": "料金情報マスタ名称",
        "display_setting.price_information_item_setting_midnight_premium_allowance": "深夜割増手当",
        "display_setting.price_information_item_setting_non_legal_overtime_price": "法定外残業単価",
        "display_setting.price_information_item_setting_non_legal_overtime_price_forty_five": "法定外残業45h\/月超単価",
        "display_setting.price_information_item_setting_non_legal_overtime_price_sixty": "法定外残業60h\/月超単価",
        "display_setting.price_information_item_setting_refer": "料金情報の参照",
        "display_setting.price_information_item_setting_scheduled_holiday_price": "所定休日出勤単価",
        "display_setting.price_information_item_setting_shortage_deduction": "所定勤務時間不足控除",
        "display_setting.price_information_item_setting_staff_payment_term": "スタッフ支払サイト",
        "display_setting.price_information_item_setting_sub_title": "料金情報マスタ項目を設定できます",
        "display_setting.price_information_item_setting_weekly_overtime_price": "週規定労働時間超単価",
        "display_setting.price_information_item_setting_weekly_working_hours_standard": "週規定労働時間基準(時間)",
        "display_setting.primary_model_item_setting": "{primaryModelName}項目設定",
        "display_setting.primary_model_item_setting.result_column": "{primaryModelName}検索結果項目設定",
        "display_setting.primary_model_item_setting_add_category": "新規カテゴリーを追加",
        "display_setting.primary_model_item_setting_explain": "{primaryModelName}情報に表示する項目を設定できます",
        "display_setting.primary_model_item_setting_sort_title": "{primaryModelName}詳細・編集・登録画面に表示する項目の設定と並び替え",
        "display_setting.primary_model_search_item_setting_sort_title": "{primaryModelName}検索画面に表示する検索項目の設定と並び替え",
        "display_setting.primary_model_sublists_item_setting_sort_title": "{primaryModelName}に表示するサブリストの設定と並び替え",
        "display_setting.progress_item_add_next_select": "+ 選択可能な進捗を追加する",
        "display_setting.progress_item_conditional_job": "求人の紐付き",
        "display_setting.progress_item_conditional_job_description": "求人の紐付きを「あり」にすると進捗を進める人材に求人会社や求人番号、面接担当者を割り当てることができます。",
        "display_setting.progress_item_create": "新規進捗項目追加",
        "display_setting.progress_item_edit": "進捗の編集",
        "display_setting.progress_item_name": "進捗名",
        "display_setting.progress_item_name_error_required": "進捗名は必須です。",
        "display_setting.progress_item_name_error_same": "すでに使用されている進捗名です。",
        "display_setting.progress_item_next_select": "次に選べる進捗",
        "display_setting.progress_item_no_next_progress": "次に選べる進捗はありません。",
        "display_setting.progress_item_place": "表示場所",
        "display_setting.progress_item_place_tooltip": "プルダウンを表示させる場所を選択してください",
        "display_setting.progress_item_setting": "進捗項目設定",
        "display_setting.progress_item_setting_sub_title": "進捗の選択項目の追加と編集ができます",
        "display_setting.rounding_item_setting": "端数処理マスタ設定",
        "display_setting.rounding_item_setting_add": "端数処理の新規追加",
        "display_setting.rounding_item_setting_calling": "端数処理マスタ呼び出し",
        "display_setting.rounding_item_setting_edit": "端数処理の編集",
        "display_setting.rounding_item_setting_label_name": "端数処理名称",
        "display_setting.rounding_item_setting_master_name": "端数処理マスタ名称",
        "display_setting.rounding_item_setting_refer": "端数処理の参照",
        "display_setting.rounding_item_setting_sub_title": "端数処理マスタ項目を設定できます",
        "display_setting.rounding_item_setting_tax_rounding": "消費税端数処理",
        "display_setting.rounding_item_setting_time_unit": "時間計算単位",
        "display_setting.row_delete": "行を削除",
        "display_setting.sales_setting": "売上\/返金項目設定",
        "display_setting.schedule_item_balloon_room_name": "部屋名",
        "display_setting.schedule_item_create": "新規部屋項目追加",
        "display_setting.schedule_item_setting": "スケジュール項目設定",
        "display_setting.schedule_item_setting_sub_title": "利用できる部屋の編集削除ができます",
        "display_setting.search_item_setting_add": "検索する項目を追加",
        "display_setting.search_item_setting_item_name_title": "検索する項目",
        "display_setting.staffs": "会社担当者",
        "display_setting.step_create_item_create": "新規対応項目追加",
        "display_setting.step_resources_item_setting": "対応表示項目設定",
        "display_setting.step_states_item_name": "対応名",
        "display_setting.step_states_item_setting": "対応項目設定",
        "display_setting.step_states_item_setting_sub_title": "対応の選択項目の追加と編集ができます",
        "display_setting.sublist": "サブリスト",
        "display_setting.sublists_item": "サブリスト項目",
        "display_setting.sublists_item_setting": "{tableName}サブリスト項目設定",
        "display_setting.sublists_item_setting_sub_title": "詳細画面に表示する{tableName}のサブリスト項目を設定できます",
        "display_setting.tab_detail_edit_register": "詳細・編集・登録画面",
        "display_setting.tab_search_results": "一覧画面",
        "display_setting.tab_search_setting": "検索画面",
        "display_setting.title.candidates_step_states": "人材対応",
        "display_setting.title.jobs_step_states": "会社対応",
        "display_setting.travel_expense_item_setting_actual_costs": "実費",
        "display_setting.travel_expense_item_setting_add": "交通費の新規追加",
        "display_setting.travel_expense_item_setting_edit": "交通費の編集",
        "display_setting.travel_expense_item_setting_label_name": "交通費名称",
        "display_setting.travel_expense_item_setting_limit_or_payment": "上限または支給額",
        "display_setting.travel_expense_item_setting_no_payment": "支給なし",
        "display_setting.travel_expense_item_setting_uniform": "一律",
        "display_setting.under_row_add": "行を下に追加",
        "display_setting.wage_item_master_calling": "料金情報マスタ呼び出し",
        "display_setting.wage_item_setting": "料金情報マスター設定",
        "display_setting.wage_item_setting_add": "料金情報の新規追加",
        "display_setting.wage_item_setting_edit": "料金情報の編集",
        "display_setting.wage_item_setting_label_basic_unit_wage": "基本単価",
        "display_setting.wage_item_setting_label_cannot_early_attendance": "早出への対応",
        "display_setting.wage_item_setting_label_cannot_early_attendance.on": "早出を認めない",
        "display_setting.wage_item_setting_label_half_holiday_allocation_hour": "半休充当時間",
        "display_setting.wage_item_setting_label_leave_deduction": "欠勤控除",
        "display_setting.wage_item_setting_label_legal_holiday_unit_wage": "法定休日出勤単価",
        "display_setting.wage_item_setting_label_legal_over_time_unit_wage": "法定内残業単価",
        "display_setting.wage_item_setting_label_name": "料金情報名称",
        "display_setting.wage_item_setting_label_night_extra_unit_wage": "深夜割増手当",
        "display_setting.wage_item_setting_label_non_legal_over_time_month_45_unit_wage": "法定外残業45h\/月超単価",
        "display_setting.wage_item_setting_label_non_legal_over_time_month_60_unit_wage": "法定外残業60h\/月超単価",
        "display_setting.wage_item_setting_label_non_legal_over_time_unit_wage": "法定外残業単価",
        "display_setting.wage_item_setting_label_over_weekly_legal_working_hour_unit_wage": "週規定労働時間超単価",
        "display_setting.wage_item_setting_label_prescribed_holiday_unit_wage": "所定休日出勤単価",
        "display_setting.wage_item_setting_label_prescribed_hour_short_deduction": "所定勤務時間不足控除",
        "display_setting.wage_item_setting_label_prescribed_working_hours": "所定労働時間",
        "display_setting.wage_item_setting_label_wage_type_id": "給与分類",
        "display_setting.wage_item_setting_label_weekly_legal_working_hour": "週規定労働時間基準(時間)",
        "display_setting.wage_item_setting_label_working_days": "勤務日数",
        "display_setting.wage_item_setting_sub_title": "料金情報マスター項目を設定できます",
        "display_setting.working_place_item_add": "就業場所の追加",
        "display_setting.working_place_item_address": "就業現場住所",
        "display_setting.working_place_item_division_name": "就業現場課名",
        "display_setting.working_place_item_edit": "就業場所の編集",
        "display_setting.working_place_item_master_calling": "就業現場マスタ呼び出し",
        "display_setting.working_place_item_master_name": "就業現場マスタ名称",
        "display_setting.working_place_item_name": "就業現場名",
        "display_setting.working_place_item_refer": "就業場所の参照",
        "educations.entrance_date": "入社年月",
        "educations.graduation_date": "卒業年月",
        "educations.presence_period": "在籍期間",
        "educations.school": "学校名",
        "error_message.candidate_job_step_summary.invalid_call": "進捗の集計処理中にエラーが発生しました。",
        "error_message.move_same_position_models": "ポジションが同じ項目を並び替えようとしました。",
        "error_message.not_parameter": "table:%s column:%s を帳票出力できません。",
        "error_message.not_request_parameter": "リクエストパラメータが正しくありません。リクエストパラメータ:%s 値:%s",
        "error_message.paid_leaves_item_setting.initial_paid_leave_activate_month_form.range": "「有給休暇の初回付与」は{min}〜{max}までの値を入力してください",
        "error_message.paid_leaves_item_setting.initial_paid_leave_activate_month_form.required": "「有給休暇の初回付与」に正数を入力してください",
        "error_message.paid_leaves_item_setting.paid_leave_days_form.required": "「有給休暇付与日数」の{yearlyWorkingDayTypeLabel}の{leaveTimesTypeLabel}に正数を入力してください。",
        "error_message.paid_leaves_item_setting.second_paid_leave_granted_form.required": "「有給休暇2回目付与」に日付を入力してください",
        "error_message.report_category_id": "reports.report_category_id:%s は不正です。",
        "error_message.transaction_failed_exception.default": "{method} に失敗しました。",
        "error_message.transaction_failed_exception.delete": "削除に失敗しました。",
        "error_message.transaction_failed_exception.post": "新規登録に失敗しました。",
        "error_message.transaction_failed_exception.put": "更新に失敗しました。",
        "error_message.unexpected_query_value": "想定外の値を抽出しました。model:%s column:%s value:%s",
        "error_message.user_resigned_exception.default": "退職者はログインすることができません。",
        "error_view.exception.id.title": "エラーID",
        "error_view.message": "ご迷惑をお掛けしてしまい、大変申し訳ございません。",
        "error_view.message_not_found": "お探しのページは移動もしくは削除された可能性があります。",
        "error_view.title": "エラーが発生しました",
        "error_view.title_not_found": "ページが見つかりませんでした",
        "error_view.title_session_timeout": "ページの有効期限が切れました",
        "export.error.sheet_name_error": "シート名が不正です。設定をご確認ください。",
        "export.setting": "エクスポート設定",
        "export.setting_add": "エクスポート設定追加",
        "export.setting_candidate_csv": "人材CSV ▼",
        "export.setting_change_after_sub": "例) matchingood",
        "export.setting_change_before_sub": "例) マッチングッド",
        "export.setting_change_bulk_sub": "項目の置換の設定をすることができます。",
        "export.setting_change_button": "置換する",
        "export.setting_change_sub": "出力時に文言を変更できます。",
        "export.setting_company_csv": "会社CSV ▼",
        "export.setting_create": "エクスポート設定追加",
        "export.setting_edit": "エクスポート設定編集",
        "export.setting_encoding": "エンコード",
        "export.setting_example_prefix_first": "(株) +",
        "export.setting_example_prefix_last": "など",
        "export.setting_example_suffix": "+  様 など",
        "export.setting_explain": "エクスポート設定でできること",
        "export.setting_export": "エクスポートする",
        "export.setting_export_after": "出力後",
        "export.setting_export_before": "出力前",
        "export.setting_file_config": "ファイルの設定",
        "export.setting_file_input": "出力時のファイル名を入力して下さい。",
        "export.setting_file_select": "出力ファイル名と、雛形ベースを選択してください。",
        "export.setting_first_line": "見出しのエクスポート",
        "export.setting_first_line_about": "見出しのエクスポートとは？",
        "export.setting_first_line_export": "【エクスポートする】",
        "export.setting_first_line_export_none": "【エクスポートしない】",
        "export.setting_first_line_purpose": "1行目に見出しを表示するには、",
        "export.setting_first_line_purpose_none": "1行目に見出しを表示しないようにするには、",
        "export.setting_input_placeholder": "文言を入力して下さい。",
        "export.setting_job_csv": "求人CSV ▼",
        "export.setting_max": "出力最大文字数",
        "export.setting_not_export": "エクスポートしない",
        "export.setting_prefix_button": "連結する",
        "export.setting_prefix_sub": "文言を前後に入れられます。",
        "export.setting_resume": "会社名(職歴) ▼",
        "export.setting_sasaki": "佐々木 一郎",
        "export.setting_sasaki_all": "佐々木 一郎 様",
        "export.setting_subtext_billing_destinations": "「請求先一覧」のCSV出力ボタンからダウンロードできます",
        "export.setting_subtext_candidate_career_counsellings": "「キャリア相談一覧」のCSV出力ボタンからダウンロードできます",
        "export.setting_subtext_candidate_education_and_trainings": "「教育訓練一覧」のCSV出力ボタンからダウンロードできます",
        "export.setting_subtext_candidate_employment_stability_measures": "「雇用安定措置一覧」のCSV出力ボタンからダウンロードできます",
        "export.setting_subtext_candidate_job_step_resources": "「進捗一覧」のCSV出力ボタンからダウンロードできます",
        "export.setting_subtext_candidate_job_steps": "「進捗一覧」のCSV出力ボタンからダウンロードできます",
        "export.setting_subtext_candidate_steps": "「人材対応一覧」のCSV出力ボタンからダウンロードできます",
        "export.setting_subtext_candidates": "「人材一覧」のCSV出力ボタンからダウンロードできます",
        "export.setting_subtext_companies": "「会社一覧」のCSV出力ボタンからダウンロードできます",
        "export.setting_subtext_company_steps": "「会社対応一覧」のCSV出力ボタンからダウンロードできます",
        "export.setting_subtext_contracts": "「契約一覧」のCSV出力ボタンからダウンロードできます",
        "export.setting_subtext_dispatch_destinations": "「派遣先一覧」のCSV出力ボタンからダウンロードできます",
        "export.setting_subtext_dispatch_jobs": "「派遣求人一覧」のCSV出力ボタンからダウンロードできます",
        "export.setting_subtext_dispatch_organization_units": "「組織単位一覧」のCSV出力ボタンからダウンロードできます",
        "export.setting_subtext_dispatch_staffs": "「派遣先担当者一覧」のCSV出力ボタンからダウンロードできます",
        "export.setting_subtext_dispatch_working_places": "「就業現場一覧」のCSV出力ボタンからダウンロードできます",
        "export.setting_subtext_jobs": "「紹介求人一覧」のCSV出力ボタンからダウンロードできます",
        "export.setting_subtext_progress": "「進捗一覧」のCSV出力ボタンからダウンロードできます",
        "export.setting_subtext_sales": "「売上一覧」のCSV出力ボタンからダウンロードできます",
        "export.setting_subtext_staffs": "「会社担当者一覧」のCSV出力ボタンからダウンロードできます",
        "export.setting_suuki": "鈴木 太郎",
        "export.setting_tanaka": "田中 花子",
        "export.setting_target": "エクスポート対象",
        "export.setting_title_explain": "ここで設定した内容でCSVダウンロードできます",
        "export.setting_type_change": "エクスポート対象を選び直す",
        "failure_view.inquiry": "しばらく経っても復旧されない場合は%1sまたは%2sまでお問い合わせ下さい。",
        "failure_view.inquiry_not_found": "マッチングッドに関するお問い合わせは%1sまたは%2sまでお問い合わせ下さい。",
        "file.preview.button": "プレビュー",
        "file.rename.button": "ファイル名を変更",
        "file.rename.prompt": "新しいファイル名を入力して下さい",
        "file.upload_outsidearea_message": "エリア内にファイルを落としてください。",
        "grant": "Grant",
        "group.notfound": "グループが見つかりませんでした",
        "group.null.company_name": "デモ会社",
        "import.error": "csvもしくはtsvの形式が不正です。",
        "import.error.common.no_setting_required_params": "必須項目が未設定です。",
        "import.error.contract_needs_candidate_company_job": "契約インポートは進捗リソース番号、または人材、派遣求人が必須です。",
        "import.error.file_size": "ファイルのサイズは{sizeMB}以内にしてください。",
        "import.error.invalid_extension": "{extension}ファイルをインポートしてください。",
        "import.error.job_needs_company": "求人インポートは会社名か会社番号が必須です。",
        "import.error.lacking_information": "{row} 行目でエラーが発生いたしました。インポートファイルをご確認ください。",
        "import.error.lacking_information.validation_exception": "{fileRowIndex} 行目でエラーが発生しました。{columnDisplayName} は {errorText}",
        "import.error.no_parent_record_row_column": "{row} 行目、{column} 列の項目に対応するレコードが存在しません。ファイル内容をご確認ください。",
        "import.error.no_settings": "エラーが発生しました。インポート設定をご確認ください。",
        "import.error.no_value": "必須項目がありませんでした。ファイル内容をご確認ください。",
        "import.error.no_value_row_column": "{row} 行目、{column} 列に必須項目がありません。ファイル内容をご確認ください。",
        "import.error.not_exist": "指定された番号は存在しないため上書きインポート出来ません。(番号 {id})",
        "import.error.not_found_outside_period": "契約期間が見つかりませんでした。",
        "import.error.parent_duplication": "{name} が複数存在しているためインポート出来ません。",
        "import.error.row_count": "インポートの件数は{row_count}件以内にしてください。",
        "import.error.staff_needs_company": "会社担当者インポートは会社名か会社番号が必須です。",
        "import.error.timeout": "タイムアウトしました。",
        "import.error.trashed": "指定された番号は削除済みのため上書きインポート出来ません。(番号 {id})",
        "import.file.upload.limit_size": "(1ファイル最大{size}MBまで)",
        "import.link_to_settings": "インポートする媒体がない場合はこちら",
        "import.setting_type_change": "インポート対象を選び直す",
        "importData.cancel": "インポート設定を選び直す",
        "importData.import": "インポート",
        "importData.import_reserve_succeeded": "インポートの予約に成功しました",
        "importData.import_succeeded": "インポートに成功しました",
        "importData.import_upload": "CSVファイルをアップロードしてください。",
        "importData.name": "インポート設定",
        "importData.select": "インポートする媒体を選択し、確定して下さい。",
        "importData.select_file": "ファイルを選択",
        "importResult.end_time": "終了時刻",
        "importResult.error_reason": "失敗理由",
        "importResult.error_reason.download": "エラー詳細CSVをダウンロード({expires_at} まで)",
        "importResult.error_reason.expired": "エラー詳細CSVのダウンロード期限が過ぎました。",
        "importResult.file_name": "ファイル",
        "importResult.number_of_error": "失敗件数",
        "importResult.number_of_success": "成功件数",
        "importResult.number_of_target": "対象数",
        "importResult.row": "{row}行目",
        "importResult.start_time": "開始時刻",
        "importResult.title": "結果",
        "importResult.type": "種別",
        "importSettingDetails.is_not_relation": "マッチングッド項目は必須です。",
        "importSettings.cancel": "解除する",
        "importSettings.change_description": "出力時に文言を変更できます。",
        "importSettings.column": "列",
        "importSettings.column_add": "更に連結する",
        "importSettings.columns_required": "必須項目チェック",
        "importSettings.columns_required.no": "チェックしない",
        "importSettings.columns_required.yes": "チェックする",
        "importSettings.create": "インポート設定追加",
        "importSettings.csv_column": "CSV列",
        "importSettings.csv_detail": "インポート設定でできること",
        "importSettings.csv_explain_first": "CSVの列の内容を繋げてマッチングッド上に反映できます。",
        "importSettings.csv_explain_second": "繋げるだけではなく、前後に改行などの記号や、文言を挿入することもできます。",
        "importSettings.csv_import": "ここで設定した内容でインポートできます",
        "importSettings.edit": "インポート設定編集",
        "importSettings.file_category": "ファイルの種類",
        "importSettings.file_category.csv": "CSV (カンマ区切り) (*.csv)",
        "importSettings.file_category.tsv": "TSV (タブ区切り) (*.txt, *.tsv)",
        "importSettings.file_type": "ファイルの種類",
        "importSettings.first_line": "見出しのインポート",
        "importSettings.first_line_about": "見出しのインポートとは?",
        "importSettings.first_line_import": "【インポートする】",
        "importSettings.first_line_import_none": "【インポートしない】",
        "importSettings.first_line_purpose": "1行目のデータを取り込むため、",
        "importSettings.first_line_purpose_none": "1行目のデータは取り込まないようにするため、",
        "importSettings.first_line_select": "を選択します。",
        "importSettings.first_line_title": "1行目に見出しあり",
        "importSettings.first_line_title_none": "1行目に見出しなし",
        "importSettings.ignore_first_line": "ファイルの1行目",
        "importSettings.ignore_first_line.no": "インポートする",
        "importSettings.ignore_first_line.yes": "インポートしない",
        "importSettings.import": "インポートする",
        "importSettings.import_data": "インポートデータ",
        "importSettings.import_target": "インポート対象",
        "importSettings.list": "インポート設定",
        "importSettings.matching_item": "マッチングッド項目",
        "importSettings.mensetsu_hanako": "面接 花子",
        "importSettings.mensetsu_hanako_all": "面接 花子 23歳",
        "importSettings.mensetsu_hanako_example": "A列+全角+B列+歳",
        "importSettings.minatoku": "東京都港区",
        "importSettings.name": "設定名",
        "importSettings.new_line": "改行",
        "importSettings.not_import": "インポートしない",
        "importSettings.notification_billing_destinations": "請求先のインポートは以下の項目が必須となります。\n・「会社情報 \/ 基本情報 \/ 番号」もしくは「会社情報 \/ 基本情報 \/ 会社名」\n・「請求先 \/ 基本情報 \/ 請求先名称」\n・「請求先 \/ 請求情報 \/ 請求\/締め日」",
        "importSettings.notification_candidate_career_counsellings": "キャリア相談のインポートは以下の項目が必須となります。\n・「人材 \/ 基本情報 \/ 番号」もしくは「人材 \/ 基本情報 \/ 氏名」\n・「キャリア相談 \/ 基本情報 \/ 担当者」\n・「キャリア相談 \/ 基本情報 \/ 実施日時」",
        "importSettings.notification_candidate_education_and_trainings": "教育訓練のインポートは以下の項目が必須となります。\n・「人材 \/ 基本情報 \/ 番号」もしくは「人材 \/ 基本情報 \/ 氏名」\n・「教育訓練 \/ 基本情報 \/ 教育訓練詳細(種類)」\n　教育訓練詳細(種類)には「キャリアアップ」「安全衛生教育」「その他」のいずれかを記載してください。\n・「教育訓練 \/ 基本情報 \/ 教育訓練詳細」\n・「教育訓練 \/ 基本情報 \/ 実施者」\n・「教育訓練 \/ 基本情報 \/ 実施日時」",
        "importSettings.notification_candidate_employment_stability_measures": "雇用安定措置のインポートは以下の項目が必須となります。\n・「人材 \/ 基本情報 \/ 番号」もしくは「人材 \/ 基本情報 \/ 氏名」\n・「雇用安定措置 \/ 基本情報 \/ 担当者」",
        "importSettings.notification_candidate_job_steps": "進捗のインポートは以下の項目が必須となります。\n・「人材 \/ 基本情報 \/ 番号」もしくは「人材 \/ 基本情報 \/ 氏名」\n・「求人 \/ 基本情報 \/ 番号」\n・「進捗 \/ 進捗情報 \/ 最新進捗」",
        "importSettings.notification_candidate_steps": "人材対応のインポートは以下の項目が必須となります。\n・「人材 \/ 基本情報 \/ 番号」もしくは「人材 \/ 基本情報 \/ 氏名」\n・「人材対応 \/ 基本情報 \/ 対応日時」\n・「人材対応 \/ 基本情報 \/ カテゴリー」",
        "importSettings.notification_company_steps": "会社対応のインポートは以下の項目が必須となります。\n・「会社情報 \/ 基本情報 \/ 番号」もしくは「会社情報 \/ 基本情報 \/ 会社名」\n・「会社対応 \/ 基本情報 \/ 対応日時」\n・「会社対応 \/ 基本情報 \/ カテゴリー」",
        "importSettings.notification_contracts": "契約のインポートは以下の項目が必須となります。\n・「進捗 \/ 進捗情報 \/ 進捗リソース番号」もしくは「人材 \/ 基本情報 \/ 番号 または 氏名」と「派遣求人 \/ 基本情報 \/ 番号」\n・「契約 \/ 基本情報 \/ 会社\/請求先」",
        "importSettings.notification_dispatch_destinations": "派遣先のインポートは以下の項目が必須となります。\n・「会社情報 \/ 基本情報 \/ 番号」もしくは「会社情報 \/ 基本情報 \/ 会社名」\n・「派遣先 \/ 基本情報 \/ 派遣先名」",
        "importSettings.notification_dispatch_jobs": "派遣求人のインポートは以下の項目が必須となります。\n・「派遣先 \/ 基本情報 \/ 番号」もしくは「派遣先 \/ 基本情報 \/ 派遣先名」",
        "importSettings.notification_dispatch_organization_units": "組織単位のインポートは以下の項目が必須となります。\n・「派遣先 \/ 基本情報 \/ 番号」もしくは「派遣先 \/ 基本情報 \/ 派遣先名」\n・「派遣先組織単位 \/ 基本情報 \/ 組織単位名」",
        "importSettings.notification_dispatch_source_staffs": "派遣元担当者のインポートは以下の項目が必須となります。\n・「派遣元 \/ 基本情報 \/ 番号」もしくは「派遣元 \/ 基本情報 \/ 事業所名」\n・「派遣元担当者 \/ 基本情報 \/ 担当者名」",
        "importSettings.notification_dispatch_sources": "派遣元のインポートは以下の項目が必須となります。\n・「派遣元 \/ 基本情報 \/ 事業所名」",
        "importSettings.notification_dispatch_staffs": "派遣先担当者のインポートは以下の項目が必須となります。\n・「派遣先 \/ 基本情報 \/ 番号」もしくは「派遣先 \/ 基本情報 \/ 派遣先名」\n・「派遣先担当者 \/ 基本情報 \/ 担当者氏名」",
        "importSettings.notification_dispatch_working_places": "就業現場のインポートは以下の項目が必須となります。\n・「派遣先 \/ 基本情報 \/ 番号」もしくは「派遣先 \/ 基本情報 \/ 派遣先名」\n・「派遣先就業現場 \/ 基本情報 \/ 就業現場名」",
        "importSettings.notification_job": "求人案件のインポートは以下の項目が必須となります。\n・「会社情報 \/ 基本情報 \/ 番号」もしくは「会社情報 \/ 基本情報 \/ 会社名」",
        "importSettings.notification_staffs": "会社担当者のインポートは以下の項目が必須となります。\n・「会社情報 \/ 基本情報 \/ 番号」もしくは「会社情報 \/ 基本情報 \/ 会社名」\n・「会社担当者 \/ 基本情報 \/ 氏名」",
        "importSettings.notification_wages": "請求支払インポートは以下の項目が必須となります\n・「請求\/支払 \/ 請求\/給与分類」\n・「請求\/支払 \/ 請求\/早出を認める」\n・「請求\/支払 \/ 支払\/給与分類」\n・「請求\/支払 \/ 支払\/早出を認める」",
        "importSettings.prefix": "文言の連結",
        "importSettings.prefix_description": "文言を前後に入れられます。",
        "importSettings.prefix_example": "【連結】A列 + 改行 + B列 + 株式会社 + C列",
        "importSettings.property_column": "マッチングッド項目",
        "importSettings.property_table": "インポート対象",
        "importSettings.replacement": "置換",
        "importSettings.replacement.mode": "モード",
        "importSettings.replacement.new_string": "置換後文字列",
        "importSettings.replacement.old_string": "置換前文字列",
        "importSettings.replacement.partial_matching": "部分一致",
        "importSettings.replacement.perfect_matching": "完全一致",
        "importSettings.replacement.position": "番目",
        "importSettings.replacement.priority": "優先順位",
        "importSettings.saiyo_taro": "採用 太郎",
        "importSettings.saiyo_taro_all": "採用 太郎(34)",
        "importSettings.saiyo_taro_example": "A列+(+B列+)",
        "importSettings.setting_name_input": "設定名を入力してください。",
        "importSettings.setting_subtitle": "インポートの雛形を設定してください。",
        "importSettings.specifications": "仕様詳細を見る",
        "importSettings.specifications_anno_domini": "2000-01-01 00:00:00形式(2000\/01\/01 なども使用可能)",
        "importSettings.specifications_any": "任意のデータ",
        "importSettings.specifications_checkbox": "チェックボックス",
        "importSettings.specifications_company_staff": "会社担当者",
        "importSettings.specifications_company_staff_number": "会社担当者氏名",
        "importSettings.specifications_cooperation": "会社名公開\/ホームページ掲載",
        "importSettings.specifications_csv": "取り込み可能なCSVデータ",
        "importSettings.specifications_date": "登録日時\/更新日時",
        "importSettings.specifications_detail": "仕様詳細",
        "importSettings.specifications_figure": "数字 (同じ番号の人材\/会社\/求人が既に存在すれば新しいデータで更新されます。存在しなければ新規登録されます。)",
        "importSettings.specifications_figure_money": "数字(数字の後ろに 万円 などの文字がついてもインポートすることができます。)",
        "importSettings.specifications_gender": "性別",
        "importSettings.specifications_income": "登録時の年収\/希望年収\/転職回数\/希望求人番号\/採用募集人数\/定年\/年齢",
        "importSettings.specifications_jis": "※CSVファイルの文字コードは【Shift_JIS または UTF-8】、改行は【LF または CRLF】です。",
        "importSettings.specifications_login_name": "ログイン名 または 担当者氏名",
        "importSettings.specifications_mail": "一括メール送信",
        "importSettings.specifications_mail_ban": "送信可能 または 送信禁止",
        "importSettings.specifications_male_female": "男性 または 女性",
        "importSettings.specifications_master": "※マスタにないデータは基本追加はされません。(マスタに追加されるのは職種や業種だけです)",
        "importSettings.specifications_matchingood": "マッチングッド項目",
        "importSettings.specifications_multiple": "任意の区切り文字を設定できます。(デフォルトは改行)",
        "importSettings.specifications_number": "番号",
        "importSettings.specifications_otherwise": "その他",
        "importSettings.specifications_presence_absence": "あり または なし",
        "importSettings.specifications_school_update": "※学歴と職歴は上書きインポートできません。",
        "importSettings.specifications_spouse": "配偶者",
        "importSettings.specifications_staff": "担当者",
        "importSettings.split": "分割する",
        "importSettings.split_adress": "〒105-0003 東京都港区西新橋1-13-1",
        "importSettings.split_adress_explain": "上記なら、【港区】だけを反映させたり、【1-13-1】のみを反映させることができます。",
        "importSettings.split_and": "列の",
        "importSettings.split_example": "A列の2番目の内容を反映させる",
        "importSettings.split_example_description": "→A列の2番目の内容を反映させる(区切り文字 半角)と入力",
        "importSettings.split_example_title": "【東京都港区】だけ反映させたい場合",
        "importSettings.split_explain": "項目の一部を切り離せます。",
        "importSettings.split_explain_description": "CSVの列の一部の情報だけを、マッチングッド上に反映できます。",
        "importSettings.split_font": "区切り文字",
        "importSettings.split_number": "番目の内容を反映させる",
        "importSettings.subtext": "ここで設定した内容をマッチングッドに反映できます",
        "importSettings.subtext_billing_destinations": "「請求先インポート」画面からインポートできます",
        "importSettings.subtext_candidate_career_counsellings": "「キャリア相談インポート」画面からインポートできます",
        "importSettings.subtext_candidate_education_and_trainings": "「教育訓練インポート」画面からインポートできます",
        "importSettings.subtext_candidate_employment_stability_measures": "「雇用安定措置インポート」画面からインポートできます",
        "importSettings.subtext_candidate_job_steps": "「進捗インポート」画面からインポートできます",
        "importSettings.subtext_candidate_steps": "「人材対応インポート」画面からインポートできます",
        "importSettings.subtext_candidates": "「人材インポート」画面からインポートできます",
        "importSettings.subtext_companies": "「会社インポート」画面からインポートできます",
        "importSettings.subtext_company_steps": "「会社対応インポート」画面からインポートできます",
        "importSettings.subtext_contracts": "「契約インポート」画面からインポートできます",
        "importSettings.subtext_dispatch_destinations": "「派遣先インポート」画面からインポートできます",
        "importSettings.subtext_dispatch_jobs": "「派遣求人インポート」画面からインポートできます",
        "importSettings.subtext_dispatch_organization_units": "「組織単位インポート」画面からインポートできます",
        "importSettings.subtext_dispatch_source_staffs": "「派遣元担当者インポート」画面からインポートできます",
        "importSettings.subtext_dispatch_sources": "「派遣元インポート」画面からインポートできます",
        "importSettings.subtext_dispatch_staffs": "「派遣先担当者インポート」画面からインポートできます",
        "importSettings.subtext_dispatch_working_places": "「就業現場インポート」画面からインポートできます",
        "importSettings.subtext_jobs": "「紹介求人インポート」画面からインポートできます",
        "importSettings.subtext_sales": "「売上インポート」画面からインポートできます",
        "importSettings.subtext_staffs": "「会社担当者インポート」画面からインポートできます",
        "indexsort.billing_destinations.id_asc": "請求先番号の古い順",
        "indexsort.billing_destinations.id_desc": "請求先番号の新しい順",
        "indexsort.billing_destinations.name_asc": "請求先名の昇順",
        "indexsort.billing_destinations.name_desc": "請求先名の降順",
        "indexsort.candidates.id_asc": "番号の古い順",
        "indexsort.candidates.id_desc": "番号の新しい順",
        "indexsort.common.birth_date_asc": "生年月日の遠い順",
        "indexsort.common.birth_date_desc": "生年月日の近い順",
        "indexsort.common.created_at_asc": "登録の古い順",
        "indexsort.common.created_at_desc": "登録の新しい順",
        "indexsort.common.kana_asc": "フリガナの昇順",
        "indexsort.common.kana_desc": "フリガナの降順",
        "indexsort.common.updated_at_asc": "更新の古い順",
        "indexsort.common.updated_at_desc": "更新の新しい順",
        "indexsort.companies.id_asc": "会社番号の古い順",
        "indexsort.companies.id_desc": "会社番号の新しい順",
        "indexsort.contracts.id_asc": "契約番号の古い順",
        "indexsort.contracts.id_desc": "契約番号の新しい順",
        "indexsort.dispatch_destinations.id_asc": "派遣先番号の古い順",
        "indexsort.dispatch_destinations.id_desc": "派遣先番号の新しい順",
        "indexsort.dispatch_destinations.name_asc": "派遣先名の昇順",
        "indexsort.dispatch_destinations.name_desc": "派遣先名の降順",
        "indexsort.dispatch_jobs.id_asc": "派遣求人番号の古い順",
        "indexsort.dispatch_jobs.id_desc": "派遣求人番号の新しい順",
        "indexsort.dispatch_organization_units.id_asc": "組織単位番号の古い順",
        "indexsort.dispatch_organization_units.id_desc": "組織単位番号の新しい順",
        "indexsort.dispatch_organization_units.name_asc": "組織単位名の昇順",
        "indexsort.dispatch_organization_units.name_desc": "組織単位名の降順",
        "indexsort.dispatch_sources.id_asc": "派遣元番号の古い順",
        "indexsort.dispatch_sources.id_desc": "派遣元番号の新しい順",
        "indexsort.dispatch_sources.name_asc": "派遣元名の昇順",
        "indexsort.dispatch_sources.name_desc": "派遣元名の降順",
        "indexsort.dispatch_staffs.id_asc": "派遣先担当者番号の古い順",
        "indexsort.dispatch_staffs.id_desc": "派遣先担当者番号の新しい順",
        "indexsort.dispatch_staffs.name_asc": "派遣先担当者名の昇順",
        "indexsort.dispatch_staffs.name_desc": "派遣先担当者名の降順",
        "indexsort.dispatch_working_places.id_asc": "就業現場番号の古い順",
        "indexsort.dispatch_working_places.id_desc": "就業現場番号の新しい順",
        "indexsort.dispatch_working_places.name_asc": "就業現場名の昇順",
        "indexsort.dispatch_working_places.name_desc": "就業現場名の降順",
        "indexsort.jobs.id_asc": "求人番号の古い順",
        "indexsort.jobs.id_desc": "求人番号の新しい順",
        "indexsort.staffs.id_asc": "会社担当者番号の古い順",
        "indexsort.staffs.id_desc": "会社担当者番号の新しい順",
        "indexsort.staffs.name_asc": "会社担当者名の昇順",
        "indexsort.staffs.name_desc": "会社担当者名の降順",
        "industries.name": "求人業種",
        "inquiry.mail.subject": "お問い合わせ",
        "is_free_limit.mails.all": "無料プランはメール機能を使用できません。",
        "is_free_limit.mails.receive": "無料プランはメール受信機能を使用できません。",
        "is_free_limit.mails.send_only_recommend": "無料プランは<br>共有求人に対する人材推薦以外の<br>メールは送信できません。",
        "is_free_limit.setting": "無料プランではこちらの設定はできません。",
        "job.update_user_placeholder": "自社求人担当者 ▼",
        "jobs.access": "アクセス",
        "jobs.add_company": "会社を新規登録する",
        "jobs.age_limit": "定年",
        "jobs.background": "募集背景",
        "jobs.business_hours": "勤務時間",
        "jobs.code": "コード",
        "jobs.company_id": "会社番号",
        "jobs.contract": "契約",
        "jobs.create_staff": "会社担当者を新規作成",
        "jobs.data": "集計",
        "jobs.deleted.title": "(削除済み案件)",
        "jobs.department": "配属部署",
        "jobs.download_report": "求人票・帳票を出力",
        "jobs.edit_staff": "会社担当者を編集",
        "jobs.employment_category_id": "雇用形態",
        "jobs.employment_category_id_select": "雇用形態を選択 ▼",
        "jobs.employment_term": "雇用期間",
        "jobs.employment_term_select": "雇用期間を選択 ▼",
        "jobs.fee_memo": "その他給与",
        "jobs.file": "求人票",
        "jobs.holiday": "休日休暇",
        "jobs.hope_num": "採用募集人数",
        "jobs.id": "求人番号",
        "jobs.import.title": "インポート(紹介求人)",
        "jobs.index": "紹介求人一覧",
        "jobs.index_no_users": "紹介求人一覧(自社担当者未設定)",
        "jobs.industry_id": "業種",
        "jobs.industry_id_select": "業種を選択 ▼",
        "jobs.interview_count": "面接回数",
        "jobs.interview_process": "選考プロセス補足",
        "jobs.is_company_name_public": "会社名公開フラグ（ホームページ連携時）",
        "jobs.is_trial": "試用期間",
        "jobs.is_web": "ホームページ掲載",
        "jobs.job_list": "紹介求人一覧",
        "jobs.job_state_id": "ステータス",
        "jobs.list_back": "紹介求人一覧に戻る",
        "jobs.list_staff_unset": "担当者未設定の紹介求人",
        "jobs.list_this_page": "このページ内の紹介求人",
        "jobs.matching.candidates.link": "希望条件に合う人材を探す",
        "jobs.matching.candidates.title": "希望条件に合う人材を探す",
        "jobs.matching.candidates.title_explain": "人材を探して、紹介や推薦ができます",
        "jobs.matching.explain": "人材を探して、紹介や推薦ができます",
        "jobs.matching.map.explain": "地図から人材を探してマッチングができます。",
        "jobs.matching.map.link": "地図から人材を探す",
        "jobs.max_age": "年齢(X歳以下)",
        "jobs.max_yearly_salary": "年収(X万以下)",
        "jobs.memo": "メモ",
        "jobs.min_age": "年齢(X歳以上)",
        "jobs.min_yearly_salary": "年収(X万以上)",
        "jobs.must_skill": "必須スキル",
        "jobs.no_assign_user": "自社紹介求人担当者未設定の紹介求人",
        "jobs.no_data": "紹介求人の情報はありません",
        "jobs.no_data_all": "求人の情報はありません",
        "jobs.no_job": "紹介求人情報は登録されていません",
        "jobs.no_staff": "会社担当者の登録がまだありません。",
        "jobs.none": "紹介求人の登録がまだありません。",
        "jobs.none_staff": "会社担当者未設定",
        "jobs.none_staff_tel": "会社担当電話未設定",
        "jobs.occupation_id": "職種",
        "jobs.occupation_id_select": "職種を選択 ▼",
        "jobs.open_own_job_list": "自社紹介求人一覧",
        "jobs.open_share_job_list": "共有求人一覧",
        "jobs.photo": "画像",
        "jobs.photo_alternative_text": "紹介求人の画像",
        "jobs.photo_change": "登録されている画像を上書きします。よろしいですか？",
        "jobs.place": "勤務地",
        "jobs.post": "役職",
        "jobs.prefecture_id": "都道府県",
        "jobs.profile": "紹介求人詳細",
        "jobs.progress": "進捗",
        "jobs.qualification": "資格",
        "jobs.reason": "年齢制限の理由",
        "jobs.role_detail": "仕事内容",
        "jobs.roudoukyoku_category_id": "労働局分類",
        "jobs.search_matching": "希望条件に合う人材を探す",
        "jobs.select_company": "紹介求人情報の会社名を検索 ▼",
        "jobs.share.index": "共有求人一覧",
        "jobs.share.index.sub_title": "共有された求人が一覧で見れます",
        "jobs.share.list_back": "共有求人一覧に戻る",
        "jobs.share.none": "共有されている求人はまだありません。",
        "jobs.staff": "会社担当者",
        "jobs.staff_id": "会社担当者名",
        "jobs.title": "案件見出し",
        "jobs.title_create": "紹介求人案件新規登録",
        "jobs.title_edit": "紹介求人案件編集",
        "jobs.title_empty": "見出し未登録",
        "jobs.title_empty_with_id": "見出し未登録（番号：{id}）",
        "jobs.title_index": "紹介求人案件検索結果",
        "jobs.title_search": "紹介求人案件検索",
        "jobs.transfer": "転勤",
        "jobs.update_user_placeholder": "自社求人担当者 ▼",
        "jobs.user": "自社紹介求人担当者",
        "jobs.user_change": "自社紹介求人担当者を変更",
        "jobs.user_department": "自社紹介求人担当者\/部署",
        "jobs.want_skill": "歓迎スキル",
        "jobs.welfare": "福利厚生",
        "landing_page_banner_alt": "プレミアムプランの詳細はこちら",
        "legal_document.introduction_business_report": "事業報告書",
        "legal_document.introduction_management_report": "管理簿",
        "legal_document.output.business_report": "旧フォーマット▼",
        "legal_document.output.business_report_button": "{year}年度",
        "legal_document.output.business_report_explain": "求人と人材に紐づくものを対象に集計します。",
        "legal_document.output.manage_candidate_information_report": "人材",
        "legal_document.output.manage_candidate_information_report_explain": "人材に紐づくものを対象に出力します。",
        "legal_document.output.manage_fee_information_report": "手数料",
        "legal_document.output.manage_fee_information_report_explain": "会社情報に紐づくものを対象に集計します。",
        "legal_document.output.manage_job_information_report": "求人",
        "legal_document.output.manage_job_information_report_explain": "求人情報に紐づくものを対象に出力します。",
        "legal_document.title": "法定帳票出力",
        "legal_document.title_explain": "労働局に提出する事業報告書などをエクセルやCSV形式で出力ができます",
        "line_option.candidate.href.name": "人材詳細へ",
        "line_option.header.icon": "LINE",
        "line_option.invitation.button": "LINE招待",
        "line_option.modal.title": "招待メール送信",
        "line_option.notification.title": "LINEお知らせ",
        "line_option.notifications.make_all_as_read": "すべてのLINEお知らせを既読にする",
        "line_option.notifications.not_notifications": "LINEお知らせはございません",
        "line_option.notifications.open_talk.index": "トーク画面を開く",
        "line_option.reinvitation.button": "LINE再招待",
        "line_option.talk.button": "LINEトーク",
        "list.csv_placeholder": "このアカウントはダウンロードが許可されていません",
        "list.description_candidates": "一括メール送信・自社人材担当者変更なども行えます",
        "list.description_companies": "一括メール送信・自社会社担当者変更なども行えます",
        "list.description_job": "求人票のダウンロード・自社求人担当者変更なども行えます",
        "login_histories": "ログイン履歴管理",
        "login_histories.continuous_failure_times": "連続失敗回数",
        "login_histories.description": "ログイン履歴が確認できます。",
        "login_histories.failure": "失敗",
        "login_histories.ip_address": "IP",
        "login_histories.is_login_succeeded": "成否",
        "login_histories.lock_limit_time": "ロック制限時間",
        "login_histories.login_id": "ログインID",
        "login_histories.login_time": "ログイン時刻",
        "login_histories.no": "No",
        "login_histories.no_data": "履歴が登録されていません。",
        "login_histories.success": "成功",
        "mailTemplates.add": "テンプレートを追加する",
        "mailTemplates.basic_information_title": "基本情報",
        "mailTemplates.body": "本文",
        "mailTemplates.category": "カテゴリー",
        "mailTemplates.contents": "内容",
        "mailTemplates.is_shared": "社内共有",
        "mailTemplates.name": "テンプレート名",
        "mailTemplates.subject": "件名",
        "mailTemplates.uncategorized": "未分類",
        "mails.all": "すべて",
        "mails.attachments_file": "添付ファイル",
        "mails.bulk.career": "職歴",
        "mails.bulk.choise": "送信先の種類をお選び下さい",
        "mails.bulk.duplicate": "重複",
        "mails.bulk.duplicate_cases": "アドレス重複",
        "mails.bulk.emails_list": "一括メール送信先一覧",
        "mails.bulk.empty": "未入力",
        "mails.bulk.empty_cases": "アドレス未入力",
        "mails.bulk.error": "エラー",
        "mails.bulk.for_baseCompanies": "会社宛",
        "mails.bulk.for_billing_destinations": "請求先宛",
        "mails.bulk.for_candidates": "人材宛",
        "mails.bulk.for_companies": "会社担当者宛",
        "mails.bulk.for_company": "会社宛",
        "mails.bulk.for_dispatch_destinations": "派遣先宛",
        "mails.bulk.for_dispatch_organization_units": "組織単位宛",
        "mails.bulk.for_dispatch_staffs": "派遣先担当者宛",
        "mails.bulk.for_dispatch_working_places": "就業現場宛",
        "mails.bulk.for_staff": "会社担当者宛",
        "mails.bulk.impossible_cases": "送信禁止",
        "mails.bulk.invalid": "形式不正",
        "mails.bulk.invalid_cases": "アドレス形式不正",
        "mails.bulk.is_possible_bulk_mail": "送信可否",
        "mails.bulk.is_possible_bulk_mail_ng": "送信禁止",
        "mails.bulk.is_possible_bulk_mail_ok": "送信可能",
        "mails.bulk.not_address": "アドレスが未入力です",
        "mails.bulk.not_select_recipients": "送信対象を選択してください",
        "mails.bulk.review_recipients": "送信先確認",
        "mails.bulk.step1_billing_destinations": "送信予定の請求先を確認",
        "mails.bulk.step1_candidates": "送信予定の人材を確認",
        "mails.bulk.step1_companies": "送信予定の会社を確認",
        "mails.bulk.step1_dispatch_destinations": "送信予定の派遣先を確認",
        "mails.bulk.step1_dispatch_organization_units": "送信予定の組織単位を確認",
        "mails.bulk.step1_dispatch_staffs": "送信予定の派遣先担当者を確認",
        "mails.bulk.step1_dispatch_working_places": "送信予定の就業現場を確認",
        "mails.bulk.step1_staffs": "送信予定の会社担当者を確認",
        "mails.bulk.step2": "メールを作成",
        "mails.bulk.step2_button": "一括メールを作成する",
        "mails.bulk.unit_name": "件",
        "mails.button.recommend_candidates_to_company": "企業に推薦する",
        "mails.button.recommend_candidates_to_company_short": "企業に推薦",
        "mails.button.send_job_descriptions_to_candidate": "求人を紹介する",
        "mails.button.send_job_descriptions_to_candidate_short": "求人を紹介",
        "mails.cancel": "キャンセル",
        "mails.cancel_designate_spam": "迷惑メール指定を解除",
        "mails.decide": "決定する",
        "mails.designate_spam": "迷惑メールに指定",
        "mails.distribute": "メールの振り分け",
        "mails.editor.place_holder": "本文を入力してください",
        "mails.history.target_display.BILLING_DESTINATION": "請求先",
        "mails.history.target_display.CANDIDATE": "人材",
        "mails.history.target_display.COMPANY": "会社",
        "mails.history.target_display.DISPATCH_DESTINATION": "派遣先",
        "mails.history.target_display.DISPATCH_ORGANIZATION_UNIT": "組織単位",
        "mails.history.target_display.DISPATCH_STAFF": "派遣先担当者",
        "mails.history.target_display.DISPATCH_WORKING_PLACE": "就業現場",
        "mails.history.target_display.OTHER": "未登録アドレス",
        "mails.history.target_display.STAFF": "会社担当者",
        "mails.history.target_display.USER": "自社社員",
        "mails.history_none": "メール履歴がありません",
        "mails.index.mark_read": "開封済みにする",
        "mails.move_to_trash": "ゴミ箱に入れる",
        "mails.none": "メールはありません。",
        "mails.not_response": "レスなし",
        "mails.opened_not_reply": "開封済み 未返信",
        "mails.page_back": "元の画面に戻る",
        "mails.popup.billing_destination.receive": "請求先から",
        "mails.popup.billing_destination.send": "請求先へ",
        "mails.popup.candidate.receive": "人材から",
        "mails.popup.candidate.send": "人材へ",
        "mails.popup.company.receive": "会社から",
        "mails.popup.company.send": "会社へ",
        "mails.popup.dispatch_destination.receive": "派遣先から",
        "mails.popup.dispatch_destination.send": "派遣先へ",
        "mails.popup.dispatch_organization_unit.receive": "組織単位から",
        "mails.popup.dispatch_organization_unit.send": "組織単位へ",
        "mails.popup.dispatch_staff.receive": "派遣先担当者から",
        "mails.popup.dispatch_staff.send": "派遣先担当者へ",
        "mails.popup.dispatch_working_place.receive": "就業現場から",
        "mails.popup.dispatch_working_place.send": "就業現場へ",
        "mails.popup.mail_update": "メール受信",
        "mails.popup.spam.receive": "迷惑メールから",
        "mails.popup.spam.send": "迷惑メールへ",
        "mails.popup.staff.receive": "会社担当者から",
        "mails.popup.staff.send": "会社担当者へ",
        "mails.popup.unregistered.receive": "未登録アドレスから",
        "mails.popup.unregistered.send": "未登録アドレスへ",
        "mails.popup.user.receive": "自社社員から",
        "mails.popup.user.send": "自社社員へ",
        "mails.receive.error_message": "受信が失敗しました。",
        "mails.receive.finish_message": "受信が完了しました。",
        "mails.receive_tray": "受信トレイ",
        "mails.search_placeholder": "メールを検索",
        "mails.send": "メールする",
        "mails.send.add_attached_file": "添付したファイル",
        "mails.send.add_attachment_file": "ファイルを添付",
        "mails.send.add_attachment_file_job_share": "履歴書等のファイルを添付(必須)",
        "mails.send.add_bcc": "Bccを追加",
        "mails.send.add_cc": "Ccを追加",
        "mails.send.add_to": "宛先を追加",
        "mails.send.add_zip": "添付ファイルをzipファイルにまとめる",
        "mails.send.all_mailtemplates_category": "全てのカテゴリー",
        "mails.send.assist_insert": "項目の差し込み",
        "mails.send.attach_directly": "直接ファイルを添付",
        "mails.send.attach_system_file": "システム内のファイルを添付",
        "mails.send.attachment_file": "添付ファイル",
        "mails.send.bcc": "Bcc",
        "mails.send.bcc_placeholder": "Bccを選択してください ▼",
        "mails.send.before_drag_and_drop": "または  このエリアに",
        "mails.send.break": "このメールを破棄する",
        "mails.send.bulk_end_toast": "一括メール送信完了しました。",
        "mails.send.bulk_start_toast": "一括メール送信開始しました。",
        "mails.send.cc": "Cc",
        "mails.send.cc_placeholder": "Ccを選択してください ▼",
        "mails.send.change_zip_info_link": "zipファイル名とパスワードを変更",
        "mails.send.change_zip_info_title": "zipファイル名 \/ パスワードの変更",
        "mails.send.confirm": "送信確認",
        "mails.send.confirmmail": "確認する",
        "mails.send.create_title": "メール作成",
        "mails.send.direct_input": "アドレスを入力",
        "mails.send.display_cc_and_bcc": "CC\/BCC表示",
        "mails.send.display_to_and_from": "宛先 \/ 送信元を表示",
        "mails.send.drag_and_drop": "ドラッグ&ドロップ",
        "mails.send.email_kind_agent": "人材会社社員",
        "mails.send.email_kind_candidate_office": "人材 \/ 会社",
        "mails.send.email_kind_candidate_pc": "人材 \/ PC",
        "mails.send.email_kind_candidate_portable": "人材 \/ 携帯",
        "mails.send.email_kind_staff": "会社担当者",
        "mails.send.email_kind_user": "自社社員",
        "mails.send.error_toast": "送信失敗しました。",
        "mails.send.file_unit_name": "ファイル",
        "mails.send.finish_message": "送信が完了しました。",
        "mails.send.finish_toast": "送信しました。",
        "mails.send.from": "送信元",
        "mails.send.from_placeholder": "送信元を選択してください ▼",
        "mails.send.is_confirmed": "送信時に確認画面を表示する",
        "mails.send.is_sending": "送信中",
        "mails.send.mail_templates_first_insert": "本文の先頭に挿入",
        "mails.send.mail_templates_insert": "テンプレートの挿入",
        "mails.send.mail_templates_last_insert": "本文の最後に挿入",
        "mails.send.mail_templates_settings": "メールテンプレート設定",
        "mails.send.matchingood_files_select_placeholder": "システム内のファイルを選択して添付",
        "mails.send.next_password_input_message": "続けてパスワードメールを入力して下さい。",
        "mails.send.next_password_message": "続けてパスワードメールを送信して下さい。",
        "mails.send.no_add_attached_file": "添付したファイルはありません",
        "mails.send.no_send_setting": "アカウント設定画面より、smtpを設定してください。",
        "mails.send.no_zip_title": "添付ファイル",
        "mails.send.not_finish_message": "まだ送信が完了していません。",
        "mails.send.passwordmail_body": "添付ファイルのパスワードは {password} に設定されております。<br\/> ※システム処理の関係上、パスワード通知メールが先に受信されることがございます。<br\/> ご了承の程よろしくお願いいたします。",
        "mails.send.passwordmail_create_title": "パスワードメール作成",
        "mails.send.passwordmail_subejct": "添付ファイルを開封するパスワードが記載されています",
        "mails.send.people_unit_name": "名",
        "mails.send.sendmail": "送信する",
        "mails.send.signature_setting": "署名設定",
        "mails.send.subject": "件名",
        "mails.send.subject_placeholder": "件名を入力してください",
        "mails.send.subject_use_template_title": "テンプレートの件名を使用する",
        "mails.send.template_category_placeholder": "テンプレートカテゴリー",
        "mails.send.template_insert": "テンプレートの挿入",
        "mails.send.template_placeholder": "テンプレートを選択",
        "mails.send.to": "宛先",
        "mails.send.to_placeholder": "宛先を選択してください ▼",
        "mails.send.zip_name": "ファイル名",
        "mails.send.zip_name_placeholder": "ファイル名を入力してください",
        "mails.send.zip_password": "パスワード",
        "mails.send.zip_password_placeholder": "パスワードを入力してください",
        "mails.send_none": "メール未設定",
        "mails.send_tray": "送信トレイ",
        "mails.trash": "ゴミ箱",
        "mails.un_opened": "未開封",
        "mails.unwanted": "迷惑メール",
        "maintenance_view.message1": "ご迷惑をお掛けしてしまい、大変申し訳ございません。",
        "maintenance_view.message2": "メンテナンス終了までもう少々お待ち下さい。",
        "maintenance_view.title": "ただ今メンテナンス中です",
        "master_settings.title": "マスター設定",
        "matching_setting": "マッチング設定",
        "matching_setting.add": "マッチング設定追加",
        "matching_setting.call": "マッチング設定を呼び出す",
        "matching_setting.edit": "マッチング設定編集",
        "matching_setting.explain": "ここで設定した内容を各マッチング検索画面で呼び出す事ができます。",
        "matching_setting.label.search_mode.name": "条件指定",
        "matching_setting.title_candidates_dispatch_jobs_search": "人材マッチング（派遣求人検索）",
        "matching_setting.title_candidates_jobs_search": "人材マッチング（紹介求人検索）",
        "matching_setting.title_dispatch_jobs_candidates_search": "派遣求人マッチング（人材検索）",
        "matching_setting.title_jobs_candidates_search": "紹介求人マッチング（人材検索）",
        "media_setting.cannot_delete_setting": "この設定は削除できません。",
        "media_setting.csv_column_explain": "例) A",
        "media_setting.default_setting": "デフォルトの設定は編集できません。\n複製してから編集してください。",
        "media_setting.deleted_setting": "削除済みの設定は編集できません。\n復元してから編集してください。",
        "media_setting.list_between": "+ クリックで行を追加します",
        "media_setting.spilt_default": "※分割文字を指定しない場合は、改行で分割されます",
        "media_setting.spilt_example_comma": "カンマ区切り",
        "media_setting.spilt_example_comma_text": "東京, 千葉, 神奈川, 山梨, 埼玉",
        "media_setting.spilt_example_setting_none": "設定なし",
        "media_setting.spilt_example_setting_none_text": "東京千葉神奈川山梨埼玉",
        "media_setting.spilt_example_slash": "スラッシュ区切り",
        "media_setting.spilt_example_slash_text": "東京 \/ 千葉 \/ 神奈川 \/ 山梨 \/ 埼玉",
        "media_setting.spilt_example_title": "選択肢の間を何で区切るか設定できます",
        "media_setting.spilt_punctuation_text": "例) , \/ ・ など",
        "media_setting_replace_batch.attention": "保存されると、既に設定済の内容は上書きされます。",
        "media_setting_replace_batch.drag_drop": "このエリアにドラック&ドロップ",
        "media_setting_replace_batch.file_select": "ファイルを選択",
        "media_setting_replace_batch.or": "または",
        "media_setting_replace_batch.setting": "置換の一括設定",
        "media_setting_replace_batch.setting_csv_base": "一括設定用のCSVの雛形",
        "media_setting_replace_batch.setting_flow": "置換の一括設定の流れ",
        "media_setting_replace_batch.step1": "をダウンロードして、設定したい内容をCSVファイル内に記載する。",
        "media_setting_replace_batch.step1_title": "雛形をダウンロード",
        "media_setting_replace_batch.step2": "STEP1で用意したCSVを、ファイルアップロードエリアにアップロードする。",
        "media_setting_replace_batch.step2_title": "ファイルをアップロード",
        "media_setting_replace_batch.step3": "保存するボタンを押すと、設定が反映されます。",
        "media_setting_replace_batch.step3_title": "保存する",
        "media_setting_replace_batch.upload": "アップロードする",
        "memo.confirm_reset_form": "編集中の対応を破棄してよろしいでしょうか?",
        "memo.history": "対応履歴",
        "memo.history.category": "カテゴリー",
        "memo.history.category_company": "会社担当",
        "memo.history.correspondence_user": "対応者",
        "memo.history.create_user": "登録者",
        "memo.history.datetime": "対応日時",
        "memo.history.memo": "対応内容",
        "memo.history.notification.users": "通知先",
        "memo.placeholder": "対応の内容をご記入下さい",
        "memo.placeholder.category": "カテゴリーを選択して下さい ▼",
        "memo.placeholder.correspondence_user": "対応者を選択して下さい ▼",
        "memo.placeholder.create_user": "登録者を選択して下さい ▼",
        "memo.placeholder.memo": "対応の内容をご記入下さい",
        "memo.placeholder.staff": "会社担当を選択して下さい ▼",
        "memo.placeholder.users": "通知する自社担当者を選択して下さい ▼",
        "memo.please_choose_category": "カテゴリーを選択してください。",
        "menu.create.candidate": "人材新規登録",
        "menu.create.company": "会社新規登録",
        "menu.create.dispatch_job": "派遣求人新規登録",
        "menu.create.job": "紹介求人新規登録",
        "menu.freeword.candidate": "人材",
        "menu.freeword.company": "会社",
        "menu.freeword.dispatch_job": "派遣求人",
        "menu.freeword.job": "紹介求人",
        "messages.attendances.bulk_export": "選択したCSVを出力してよろしいですか？",
        "messages.change_status_to_paid": "ステータスを入金済に変更してもよろしいでしょうか？",
        "messages.change_status_to_paid_for_invoice": "ステータスを入金済みに変更してもよろしいでしょうか？",
        "messages.change_status_to_payment_paid": "ステータスを支払済みに変更してもよろしいでしょうか？",
        "messages.change_status_to_payment_unpaid": "ステータスを未払いに変更してもよろしいでしょうか？",
        "messages.change_status_to_unpaid": "ステータスを請求済未入金に変更してもよろしいでしょうか？",
        "messages.confirm_clear": "本当にクリアしますか?",
        "messages.default.setting": "デフォルト検索設定を設定します。よろしいですか？",
        "messages.default.setting.success": "デフォルト検索設定を設定しました。",
        "messages.delete": "本当に削除しますか?",
        "messages.delete.sale_refund": "返金情報を削除してよろしいでしょうか？",
        "messages.delete.schedule.multipleUsers": "このスケジュールを削除します。他の参加者のスケジュールも削除されますがよろしいですか？",
        "messages.delete.schedule.singleUser": "このスケジュールを削除します。よろしいですか？",
        "messages.delete.step": "この対応を削除します。よろしいですか？",
        "messages.delete.task": "このタスクを削除します。よろしいですか？",
        "messages.delete_failed": "削除に失敗しました",
        "messages.deleted": "削除しました",
        "messages.error": "エラーが発生しました。しばらく経ってからもう一度お試しください。",
        "messages.error.duplicate_matching_setting_detail": "検索項目が重複しています",
        "messages.error.search_failed": "検索に失敗しました。「{resourceName}」の検索項目に「{name}」項目を設定して、再度実行してください。",
        "messages.error_force_delete_all": "完全削除に失敗しました。再読み込み後にもう一度お試しください。",
        "messages.force_delete": "データを完全に削除してもよろしいでしょうか？",
        "messages.mail_force_delete": "メールを完全に削除してもよろしいでしょうか？",
        "messages.move_to_trash": "削除してもよろしいでしょうか？",
        "messages.move_to_trash_billing_destinations": "{selectedCount}件の派遣先データを削除してもよろしいでしょうか？選択した請求先が多数の場合には時間がかかりますのでご注意ください。",
        "messages.move_to_trash_candidate_career_counsellings": "{selectedCount}件のキャリア相談データを削除してもよろしいでしょうか？選択したキャリア相談が多数の場合には時間がかかりますのでご注意ください。",
        "messages.move_to_trash_candidate_education_and_trainings": "{selectedCount}件の教育訓練データを削除してもよろしいでしょうか？選択した教育訓練が多数の場合には時間がかかりますのでご注意ください。",
        "messages.move_to_trash_candidate_employment_stability_measures": "{selectedCount}件の雇用安定措置データを削除してもよろしいでしょうか？選択した雇用安定措置が多数の場合には時間がかかりますのでご注意ください。",
        "messages.move_to_trash_candidate_job_step_resources": "{selectedCount}件の進捗データを削除してもよろしいでしょうか？選択した進捗が多数の場合には時間がかかりますのでご注意ください。",
        "messages.move_to_trash_candidate_steps": "{selectedCount}件の人材対応データを削除してもよろしいでしょうか？選択した人材対応が多数の場合には時間がかかりますのでご注意ください。",
        "messages.move_to_trash_candidates": "{selectedCount}件の人材データを削除してもよろしいでしょうか？選択した人材が多数の場合には時間がかかりますのでご注意ください。",
        "messages.move_to_trash_companies": "{selectedCount}件の会社データを削除してもよろしいでしょうか？選択した会社が多数の場合には時間がかかりますのでご注意ください。",
        "messages.move_to_trash_company_steps": "{selectedCount}件の会社対応データを削除してもよろしいでしょうか？選択した会社対応が多数の場合には時間がかかりますのでご注意ください。",
        "messages.move_to_trash_conflict_date_managements": "{selectedCount}件の抵触日データを削除してもよろしいでしょうか？選択した抵触日が多数の場合には時間がかかりますのでご注意ください。",
        "messages.move_to_trash_contracts": "{selectedCount}件の契約データを削除してもよろしいでしょうか？選択した契約が多数の場合には時間がかかりますのでご注意ください。",
        "messages.move_to_trash_dispatch_destinations": "{selectedCount}件の派遣先データを削除してもよろしいでしょうか？選択した派遣先が多数の場合には時間がかかりますのでご注意ください。",
        "messages.move_to_trash_dispatch_jobs": "{selectedCount}件の求人データを削除してもよろしいでしょうか？選択した派遣求人が多数の場合には時間がかかりますのでご注意ください。",
        "messages.move_to_trash_dispatch_organization_units": "{selectedCount}件の組織単位データを削除してもよろしいでしょうか？選択した組織単位が多数の場合には時間がかかりますのでご注意ください。",
        "messages.move_to_trash_dispatch_sources": "{selectedCount}件の派遣元データを削除してもよろしいでしょうか？選択した派遣元が多数の場合には時間がかかりますのでご注意ください。",
        "messages.move_to_trash_dispatch_staffs": "{selectedCount}件の派遣先担当者データを削除してもよろしいでしょうか？選択した派遣先担当者が多数の場合には時間がかかりますのでご注意ください。",
        "messages.move_to_trash_dispatch_working_places": "{selectedCount}件の就業現場データを削除してもよろしいでしょうか？選択した就業現場が多数の場合には時間がかかりますのでご注意ください。",
        "messages.move_to_trash_invoice_closed_invoices": "{selectedCount}件の請求\/請求締めデータを削除してもよろしいでしょうか？選択した請求\/請求締めが多数の場合には時間がかかりますのでご注意ください。",
        "messages.move_to_trash_jobs": "{selectedCount}件の求人データを削除してもよろしいでしょうか？選択した紹介求人が多数の場合には時間がかかりますのでご注意ください。",
        "messages.move_to_trash_payment_closed_payments": "{selectedCount}件の支払\/支払締めデータを削除してもよろしいでしょうか？選択した支払\/支払締めが多数の場合には時間がかかりますのでご注意ください。",
        "messages.move_to_trash_sales": "{selectedCount}件の売上データを削除してもよろしいでしょうか？売上した求人が多数の場合には時間がかかりますのでご注意ください。",
        "messages.move_to_trash_staffs": "{selectedCount}件の会社担当者データを削除してもよろしいでしょうか？選択した会社担当者が多数の場合には時間がかかりますのでご注意ください。",
        "messages.no": "しない",
        "messages.nodata": "データが登録されておりません",
        "messages.please_select": "選択してください",
        "messages.remove_all_alerts": "すべてのアラートを既読にしますか？",
        "messages.remove_all_notifications": "すべてのお知らせを既読にしますか？",
        "messages.remove_export_settings": "エクスポート対象を選び直すと未保存の設定内容が破棄されますが、よろしいですか？",
        "messages.remove_import_settings": "インポート対象を選び直すと未保存の設定内容が破棄されますが、よろしいですか？",
        "messages.remove_matching_setting_detail": "この設定を削除します。よろしいですか？",
        "messages.remove_matching_settings": "設定種別を選び直すと未保存の設定内容が破棄されますが、よろしいですか？",
        "messages.restore": "復元してもよろしいでしょうか？",
        "messages.restore_all_billing_destinations": "{selectedCount}件の請求先データを復元してもよろしいでしょうか？選択した請求先が多数の場合には時間がかかりますのでご注意ください。（関連する{parents}が削除されている場合には、復元はされません。）",
        "messages.restore_all_candidate_career_counsellings": "{selectedCount}件のキャリア相談データを復元してもよろしいでしょうか？選択したキャリア相談が多数の場合には時間がかかりますのでご注意ください。",
        "messages.restore_all_candidate_education_and_trainings": "{selectedCount}件の教育訓練データを復元してもよろしいでしょうか？選択した教育訓練が多数の場合には時間がかかりますのでご注意ください。",
        "messages.restore_all_candidate_employment_stability_measures": "{selectedCount}件の雇用安定措置データを復元してもよろしいでしょうか？選択した雇用安定措置が多数の場合には時間がかかりますのでご注意ください。",
        "messages.restore_all_candidates": "{selectedCount}件の人材データを復元してもよろしいでしょうか？選択した人材が多数の場合には時間がかかりますのでご注意ください。",
        "messages.restore_all_companies": "{selectedCount}件の会社データを復元してもよろしいでしょうか？選択した会社が多数の場合には時間がかかりますのでご注意ください。",
        "messages.restore_all_contracts": "{selectedCount}件の契約データを復元してもよろしいでしょうか？選択した契約が多数の場合には時間がかかりますのでご注意ください。（関連する{parents}が削除されている場合には、復元はされません。）",
        "messages.restore_all_dispatch_destinations": "{selectedCount}件の派遣先データを復元してもよろしいでしょうか？選択した派遣先が多数の場合には時間がかかりますのでご注意ください。（関連する{parents}が削除されている場合には、復元はされません。）",
        "messages.restore_all_dispatch_jobs": "{selectedCount}件の派遣求人データを復元してもよろしいでしょうか？選択した派遣求人が多数の場合には時間がかかりますのでご注意ください。（関連する{parents}が削除されている場合には、復元はされません。）",
        "messages.restore_all_dispatch_organization_units": "{selectedCount}件の組織単位データを復元してもよろしいでしょうか？選択した組織単位が多数の場合には時間がかかりますのでご注意ください。（関連する{parents}が削除されている場合には、復元はされません。）",
        "messages.restore_all_dispatch_source_staffs": "{selectedCount}件の派遣元担当者データを復元してもよろしいでしょうか？選択した派遣元担当者が多数の場合には時間がかかりますのでご注意ください。（関連する{parents}が削除されている場合には、復元はされません。）",
        "messages.restore_all_dispatch_sources": "{selectedCount}件の派遣元データを復元してもよろしいでしょうか？選択した派遣元が多数の場合には時間がかかりますのでご注意ください。",
        "messages.restore_all_dispatch_staffs": "{selectedCount}件の派遣先担当者データを復元してもよろしいでしょうか？選択した派遣先担当者が多数の場合には時間がかかりますのでご注意ください。（関連する{parents}が削除されている場合には、復元はされません。）",
        "messages.restore_all_dispatch_working_places": "{selectedCount}件の就業現場データを復元してもよろしいでしょうか？選択した就業現場が多数の場合には時間がかかりますのでご注意ください。（関連する{parents}が削除されている場合には、復元はされません。）",
        "messages.restore_all_invoice_closed_invoices": "{selectedCount}件の請求\/請求締めデータを復元してもよろしいでしょうか？選択した請求\/請求締めが多数の場合には時間がかかりますのでご注意ください。",
        "messages.restore_all_jobs": "{selectedCount}件の紹介求人データを復元してもよろしいでしょうか？選択した紹介求人が多数の場合には時間がかかりますのでご注意ください。（関連する{parents}が削除されている場合には、復元はされません。）",
        "messages.restore_all_payment_closed_payments": "{selectedCount}件の支払\/支払締めデータを復元してもよろしいでしょうか？選択した支払\/支払締めが多数の場合には時間がかかりますのでご注意ください。",
        "messages.restore_all_staffs": "{selectedCount}件の会社担当者データを復元してもよろしいでしょうか？選択した会社担当者が多数の場合には時間がかかりますのでご注意ください。（関連する{parents}が削除されている場合には、復元はされません。）",
        "messages.restored": "復元しました",
        "messages.saved": "保存が完了しました。",
        "messages.saving": "保存しています・・・",
        "messages.state_to_none": "ステータスを未選択にします。",
        "messages.user_create": "アカウントを追加すると、月額料金が変更になります。アカウントを追加しますか？",
        "messages.yes": "する",
        "ms_report_api.exception.unique_sheet_name": "シート名はユニークでなければなりません。",
        "myric_mypage.cancel": "マイページ解除",
        "myric_mypage.mail.subject": "マイページ登録のご案内",
        "myric_mypage.mail.unregistered": "人材のメールアドレスが未登録です",
        "myric_mypage.publish": "マイページ発行",
        "myric_mypage.setting.invitation.url": "招待URL",
        "notificationCategories.addCandidateJobStep": "進捗更新",
        "notificationCategories.addCandidateStep": "人材対応更新",
        "notificationCategories.addCompanyStep": "会社対応更新",
        "notificationCategories.addSchedule": "スケジュール追加",
        "notificationCategories.addTask": "タスク追加",
        "notificationCategories.assignCandidate": "人材のアサイン",
        "notificationCategories.assignCompany": "会社のアサイン",
        "notificationCategories.assignJob": "求人のアサイン",
        "notificationCategories.birthday": "誕生日",
        "notificationCategories.candidateBulkMailStart": "一括メール送信開始",
        "notificationCategories.dueDateTask": "期限間近のタスク",
        "notifications.index.sub_title": "新しく追加されたデータや、アラートなどをお知らせします",
        "notifications.link_duplication": "重複を見る",
        "notifications.link_index": "一覧を見る",
        "notifications.make_all_as_read": "すべてのお知らせを既読にする",
        "notifications.make_as_read": "既読にする",
        "notifications.make_as_unread": "未読にする",
        "notifications.message.add_schedule": "新しいスケジュールが追加されました。",
        "notifications.message.add_task": "新しいタスクが追加されました。",
        "notifications.message.bulkMailEnd": "メールの一括送信が完了しました。",
        "notifications.message.bulkMailFail": "メールの一括送信が失敗しました。",
        "notifications.message.bulkMailStart": "メールの一括送信が開始されました。",
        "notifications.message.fileGenerationFailed": "「{name}」の生成に失敗しました。時間を置いて再度お試しください。",
        "notifications.message.importResource": "{startAt}に開始した{resourceName}のインポートが完了しました。",
        "notifications.message.importResourceResult": "成功件数: {successCount}件 失敗件数: {errorCount}件",
        "notifications.message.mailAddressFailed": "メールアドレスに , ; : < > は使用できません。",
        "notifications.message.oauth2TokenExpired": "OAuth2が無効なためメールの送信または受信に失敗しました。OAuth2設定管理再確認後、{name}のアカウント編集画面から再度認証してください。",
        "notifications.message.oauth2TokenExpiredForRealtime": "OAuth2が無効なためメールの送信または受信に失敗しました。OAuth2設定管理再確認後、アカウント編集画面から再度認証してください。",
        "notifications.not_notifications": "お知らせはございません",
        "notifications.open_notifications.index": "お知らせ画面を開く",
        "notifications.read_control": "既読\/未読",
        "notifications.recommend": "が推薦されました。",
        "notifications.share.label_mg": "にMG経由で",
        "notifications.slack.apiv2.request_logs.billing_cutoff.from": "集計期間の開始",
        "notifications.slack.apiv2.request_logs.billing_cutoff.to": "集計期間の終了",
        "notifications.slack.apiv2.request_logs.company_name": "会社名",
        "notifications.slack.apiv2.request_logs.count.all_client": "APIv2利用量（合算）",
        "notifications.slack.apiv2.request_logs.count.group_by_client": "APIv2利用量（クライアント別）",
        "notifications.slack.apiv2.request_logs.count.group_by_client.individual": "クライアントID",
        "notifications.slack.apiv2.request_logs.count.unit": "件",
        "notifications.slack.apiv2.request_logs.reported_at": "集計の実行日時",
        "notifications.slack.apiv2.request_logs.subdomain": "サブドメイン",
        "numeric_keypad.display": "テンキーを表示",
        "occupations.name": "求人職種",
        "page_title.actual_amount_over_shorts.import": "過不足金インポート",
        "page_title.alerts": "アラート設定",
        "page_title.alerts.index": "アラート",
        "page_title.api_setting.create": "APIクライアント追加",
        "page_title.api_setting.edit": "APIクライアント編集",
        "page_title.api_setting.index": "API設定",
        "page_title.auth.login": "ログイン",
        "page_title.auth.passwords.complete": "パスワード再設定完了",
        "page_title.auth.passwords.email": "メールアドレス入力",
        "page_title.auth.passwords.emailSent": "再設定用メール送信完了",
        "page_title.auth.passwords.expired": "パスワード再設定リンク期限切れ",
        "page_title.auth.passwords.reset": "パスワード再設定",
        "page_title.billing_destinations.create": "会社\/請求先追加",
        "page_title.billing_destinations.edit": "%1$sの請求先編集",
        "page_title.billing_destinations.import": "請求先インポート",
        "page_title.billing_destinations.index": "請求先一覧",
        "page_title.billing_destinations.show": "%1$sの請求先詳細",
        "page_title.candidate_career_counsellings.create": "%1$sさんのキャリア相談を登録",
        "page_title.candidate_career_counsellings.edit": "%1$sさんのキャリアを相談を編集",
        "page_title.candidate_career_counsellings.import": "キャリア相談インポート",
        "page_title.candidate_career_counsellings.index": "キャリア相談一覧",
        "page_title.candidate_career_counsellings.show": "%1$sさんのキャリア相談詳細",
        "page_title.candidate_education_and_trainings.create": "%1$sさんの教育訓練を登録",
        "page_title.candidate_education_and_trainings.edit": "%1$sさんの教育訓練を編集",
        "page_title.candidate_education_and_trainings.import": "教育訓練インポート",
        "page_title.candidate_education_and_trainings.index": "教育訓練一覧",
        "page_title.candidate_education_and_trainings.show": "%1$sさんの教育訓練詳細",
        "page_title.candidate_employment_placement_dispatches.create": "%1$sさんの紹介予定派遣を登録",
        "page_title.candidate_employment_placement_dispatches.edit": "%1$sさんの紹介予定派遣を編集",
        "page_title.candidate_employment_placement_dispatches.index": "紹介予定派遣一覧",
        "page_title.candidate_employment_placement_dispatches.show": "%1$sさんの紹介予定派遣詳細",
        "page_title.candidate_employment_stability_measures.create": "%1$sさんの雇用安定措置を登録",
        "page_title.candidate_employment_stability_measures.edit": "%1$sさんの雇用安定措置を編集",
        "page_title.candidate_employment_stability_measures.import": "雇用安定措置インポート",
        "page_title.candidate_employment_stability_measures.index": "雇用安定措置一覧",
        "page_title.candidate_employment_stability_measures.show": "%1$sの雇用安定措置詳細",
        "page_title.candidate_job_step_resources.index": "進捗一覧",
        "page_title.candidate_job_steps.import": "進捗インポート",
        "page_title.candidate_job_steps.index": "進捗一覧",
        "page_title.candidate_step_resources.index": "人材対応一覧",
        "page_title.candidate_steps.import": "人材対応インポート",
        "page_title.candidate_steps.index": "人材対応一覧",
        "page_title.candidates.create": "人材登録",
        "page_title.candidates.edit": "%1$sさんの人材編集",
        "page_title.candidates.import": "人材インポート",
        "page_title.candidates.index": "人材一覧",
        "page_title.candidates.index_no_users": "人材一覧(自社担当者未設定)",
        "page_title.candidates.matching": "人材マッチング",
        "page_title.candidates.show": "%1$sさんの人材詳細",
        "page_title.companies.create": "会社登録",
        "page_title.companies.edit": "%1$sの会社編集",
        "page_title.companies.import": "会社インポート",
        "page_title.companies.index": "会社一覧",
        "page_title.companies.show": "%1$sの会社詳細",
        "page_title.company_step_resources.index": "会社対応一覧",
        "page_title.company_steps.import": "会社対応インポート",
        "page_title.company_steps.index": "会社対応一覧",
        "page_title.config.index": "自社情報設定",
        "page_title.conflict_date_defaults.create": "%1$sさんの抵触日を登録",
        "page_title.conflict_date_defaults.edit": "%1$sさんの抵触日を編集",
        "page_title.conflict_date_managements.index": "抵触日一覧",
        "page_title.contract_memos.create": "契約メモ登録",
        "page_title.contract_memos.edit": "契約メモ編集",
        "page_title.contract_memos.show": "契約メモ詳細",
        "page_title.contracts.create": "契約登録",
        "page_title.contracts.edit": "契約番号%1$d(%2$s)の契約編集",
        "page_title.contracts.import": "契約インポート",
        "page_title.contracts.index": "契約一覧",
        "page_title.contracts.show": "契約番号%1$d(%2$s)の契約詳細",
        "page_title.dashboard_candidates": "ダッシュボード(人材)",
        "page_title.dashboard_jobs": "ダッシュボード(求人)",
        "page_title.data.index": "集計",
        "page_title.data.reports": "法定帳票出力",
        "page_title.dispatch_destinations.create": "派遣先登録",
        "page_title.dispatch_destinations.edit": "%1$sの派遣先編集",
        "page_title.dispatch_destinations.import": "派遣先インポート",
        "page_title.dispatch_destinations.index": "派遣先一覧",
        "page_title.dispatch_destinations.show": "%1$sの派遣先詳細",
        "page_title.dispatch_jobs.create": "派遣求人登録",
        "page_title.dispatch_jobs.edit": "求人番号%1$d(%2$s)の派遣求人編集",
        "page_title.dispatch_jobs.import": "派遣求人インポート",
        "page_title.dispatch_jobs.index": "派遣求人一覧",
        "page_title.dispatch_jobs.matching": "派遣求人マッチング",
        "page_title.dispatch_jobs.show": "求人番号%1$d(%2$s)の派遣求人詳細",
        "page_title.dispatch_organization_units.create": "組織単位登録",
        "page_title.dispatch_organization_units.edit": "%1$sの組織単位編集",
        "page_title.dispatch_organization_units.import": "組織単位インポート",
        "page_title.dispatch_organization_units.index": "組織単位一覧",
        "page_title.dispatch_organization_units.show": "%1$sの組織単位詳細",
        "page_title.dispatch_source_career_staffs.create": "キャリア相談担当者登録",
        "page_title.dispatch_source_career_staffs.edit": "%1$sのキャリア相談担当者編集",
        "page_title.dispatch_source_career_staffs.show": "%1$sのキャリア相談担当者詳細",
        "page_title.dispatch_source_education_training_careers.create": "教育訓練マスター登録：キャリアアップ",
        "page_title.dispatch_source_education_training_careers.edit": "%1$sの教育訓練マスター編集：キャリアアップ",
        "page_title.dispatch_source_education_training_careers.show": "%1$sの教育訓練マスター詳細：キャリアアップ",
        "page_title.dispatch_source_education_training_others.create": "教育訓練マスター登録：その他",
        "page_title.dispatch_source_education_training_others.edit": "%1$sの教育訓練マスター編集：その他",
        "page_title.dispatch_source_education_training_others.show": "%1$sの教育訓練マスター詳細：その他",
        "page_title.dispatch_source_education_training_safeties.create": "教育訓練マスター登録：安全衛生教育",
        "page_title.dispatch_source_education_training_safeties.edit": "%1$sの教育訓練マスター編集：安全衛生教育",
        "page_title.dispatch_source_education_training_safeties.show": "%1$sの教育訓練マスター詳細：安全衛生教育",
        "page_title.dispatch_source_staffs.create": "派遣元担当者登録",
        "page_title.dispatch_source_staffs.edit": "%1$sの派遣元担当者編集",
        "page_title.dispatch_source_staffs.import": "派遣元担当者インポート",
        "page_title.dispatch_source_staffs.index": "派遣元担当者一覧",
        "page_title.dispatch_source_staffs.show": "%1$sの派遣元担当者詳細",
        "page_title.dispatch_sources.create": "派遣元登録",
        "page_title.dispatch_sources.edit": "%1$sの派遣元者編集",
        "page_title.dispatch_sources.import": "派遣元インポート",
        "page_title.dispatch_sources.index": "派遣元設定",
        "page_title.dispatch_sources.show": "%1$sの派遣元詳細",
        "page_title.dispatch_staffs.create": "派遣先担当者登録",
        "page_title.dispatch_staffs.edit": "%1$sの派遣先担当者編集",
        "page_title.dispatch_staffs.import": "派遣先担当者インポート",
        "page_title.dispatch_staffs.index": "派遣先担当者一覧",
        "page_title.dispatch_staffs.show": "%1$sの派遣先担当者詳細",
        "page_title.dispatch_working_places.create": "就業現場登録",
        "page_title.dispatch_working_places.edit": "%1$sの就業現場編集",
        "page_title.dispatch_working_places.import": "就業現場インポート",
        "page_title.dispatch_working_places.index": "就業現場一覧",
        "page_title.dispatch_working_places.show": "%1$sの就業現場詳細",
        "page_title.display_setting.dashboard_item_setting": "表示項目設定(ダッシュボード項目)",
        "page_title.display_setting.department_item_setting": "マスター設定(部署項目)",
        "page_title.display_setting.dispatch_item_setting": "派遣業務設定({modelName}マスター設定)",
        "page_title.display_setting.free_items_group_item_setting": "マスター設定(選択肢マスター設定)",
        "page_title.display_setting.primary_model_item_setting": "表示項目設定({primaryModelName}項目)",
        "page_title.display_setting.progress_item_setting": "マスター設定(進捗項目)",
        "page_title.display_setting.schedule_item_setting": "マスター設定(スケジュール項目)",
        "page_title.display_setting.step_state_item_setting": "マスター設定(対応項目)",
        "page_title.error": "エラーが発生しました",
        "page_title.export_setting": "エクスポート設定",
        "page_title.export_setting.create": "エクスポート設定追加",
        "page_title.export_setting.edit": "エクスポート設定編集",
        "page_title.import_setting": "インポート設定",
        "page_title.import_setting.create": "インポート設定追加",
        "page_title.import_setting.edit": "インポート設定編集",
        "page_title.jobs.create": "紹介求人登録",
        "page_title.jobs.edit": "求人番号%1$d(%2$s)の紹介求人編集",
        "page_title.jobs.import": "紹介求人インポート",
        "page_title.jobs.index": "紹介求人一覧",
        "page_title.jobs.index_no_users": "紹介求人一覧(自社担当者未設定)",
        "page_title.jobs.index_share": "共有求人一覧",
        "page_title.jobs.matching": "紹介求人マッチング",
        "page_title.jobs.show": "求人番号%1$d(%2$s)の紹介求人詳細",
        "page_title.login_histories.index": "ログイン履歴管理",
        "page_title.mailTemplates.create": "メールテンプレート追加",
        "page_title.mailTemplates.edit": "「{title}」のメールテンプレート編集",
        "page_title.mailTemplates.index": "メールテンプレート一覧",
        "page_title.maintenance": "メンテナンス中です",
        "page_title.matching_setting": "マッチング設定",
        "page_title.myric_mypage_setting.index": "マイリクマイページ",
        "page_title.not_found": "ページが見つかりませんでした",
        "page_title.notifications.index": "お知らせ",
        "page_title.password_management_settings": "パスワード管理設定",
        "page_title.progress.index": "進捗一覧",
        "page_title.release_notes.index": "新機能",
        "page_title.reports.create": "帳票設定登録",
        "page_title.reports.edit": "帳票設定編集",
        "page_title.reports.index": "帳票設定",
        "page_title.roles.create": "権限マスター登録",
        "page_title.roles.edit": "権限マスター編集",
        "page_title.roles.index": "権限マスター設定",
        "page_title.roles.not_authorized": "権限が設定されていません",
        "page_title.sales.create": "売上\/返金登録",
        "page_title.sales.edit": "売上\/返金編集",
        "page_title.sales.import": "売上インポート",
        "page_title.sales.index": "売上\/返金一覧",
        "page_title.sales.refund_create": "返金入力",
        "page_title.schedule_adjustment": "面接日程調整",
        "page_title.session_timeout": "ページの有効期限が切れました",
        "page_title.setting.alert": "アラート設定",
        "page_title.setting.index": "各種設定",
        "page_title.staffs.create": "会社担当者登録",
        "page_title.staffs.edit": "%1$sさんの会社担当者編集",
        "page_title.staffs.import": "会社担当者インポート",
        "page_title.staffs.index": "会社担当者一覧",
        "page_title.staffs.show": "%1$sさんの会社担当者詳細",
        "page_title.unregistered.index": "未登録売上一覧",
        "page_title.users.create": "アカウント追加",
        "page_title.users.edit": "{name}さんのアカウント編集",
        "page_title.users.index": "アカウント情報",
        "password.forbidden.contents_text_1": "有効期限が切れているか、無効となっております。（URLの有効期限は{minutes}分間です）",
        "password.forbidden.contents_text_2": "メール送信画面からもう一度パスワード再設定メールを送信してください。",
        "password.forbidden.send_mail": "再設定メールを送信する",
        "password.forbidden.title": "パスワード再設定：無効なURLです",
        "password.mail_send.contents_text_1": "宛にパスワード再設定メールを送信しました。",
        "password.mail_send.contents_text_2": "メールに記載されているURLから「パスワード再設定」にアクセスしてください。",
        "password.mail_send.contents_text_3": "※メールにてご案内するURLの有効期限は{minutes}分間です。",
        "password.mail_send.current_password": "現在のパスワード",
        "password.mail_send.description_1": "ご登録いただいているメールアドレスにパスワード再設定用URLを送信します。",
        "password.mail_send.description_2": "メールアドレスをお忘れの場合は、お手数ですが管理者にお問い合わせください。",
        "password.mail_send.description_3": "ご自身のアカウントにてメール送信設定が行われていない場合、ご案内メールが送信されません。",
        "password.mail_send.description_4": "こちらの場合についてもお手数ですが管理者にお問い合わせください。",
        "password.mail_send.email": "メールアドレス",
        "password.mail_send.error": "パスワード再設定メールの送信に失敗しました。",
        "password.mail_send.title.password_reset": "パスワード再設定",
        "password.mail_send.title.send_email": "パスワード再設定メールを送信しました",
        "password.reset.current_password": "現在のパスワード",
        "password.reset.description.expired": "パスワードの有効期限が切れています。新しいパスワードを設定してください。",
        "password.reset.description.first_login": "はじめてのログイン時にはパスワードの設定が必要となります。",
        "password.reset.error": "パスワードの設定に失敗しました。",
        "password.reset.mail.subject": "パスワード再設定",
        "password.reset.new_password": "新しいパスワード",
        "password.reset.new_password_confirmation": "新しいパスワード（確認）",
        "password.reset.set": "設定する",
        "password.reset.success": "パスワードを設定しました。",
        "password.reset.title.expired": "パスワード有効期限切れ",
        "password.reset.title.first_login": "初回ログインパスワード設定",
        "password.set.completed": "パスワードを再設定しました",
        "password.set.contents_text": "続けてログインするには、下の「ログイン画面へ」ボタンをクリックしてください。",
        "password.set.move_login": "ログイン画面へ",
        "password_management_settings": "パスワード管理設定",
        "password_management_settings.account_lock_setting": "アカウントロック設定",
        "password_management_settings.account_lock_setting.elapsed_time_until_release": "分間経過後にロックを解除",
        "password_management_settings.account_lock_setting.enabled": "ロックを有効化",
        "password_management_settings.account_lock_setting.login_failure_times": "回のログイン失敗でロックする",
        "password_management_settings.description": "パスワードポリシー、パスワード有効期限、パスワード履歴、アカウントロックの設定・管理が行えます。",
        "password_management_settings.password_expiration_date_setting": "パスワード有効期限設定",
        "password_management_settings.password_expiration_date_setting.enabled": "有効",
        "password_management_settings.password_expiration_date_setting.password_enabled_days": "有効期限日数",
        "password_management_settings.password_history_setting": "パスワード履歴管理",
        "password_management_settings.password_history_setting.disabled": "過去パスワードを使用不可とする",
        "password_management_settings.password_history_setting.past_password_reuse_unavailable_times": "代前までのPWを使用不可とする",
        "password_management_settings.password_policy_setting": "パスワードポリシーの設定",
        "password_management_settings.password_policy_setting.enabled": "パスワードポリシー有効化",
        "password_management_settings.password_policy_setting.is_initial_password_change_required.uppercase": "初期パスワード変更を必須とする",
        "password_management_settings.password_policy_setting.password_character_type": "必須文字種別の設定",
        "password_management_settings.password_policy_setting.password_character_type.lowercase": "英小文字",
        "password_management_settings.password_policy_setting.password_character_type.number": "数字",
        "password_management_settings.password_policy_setting.password_character_type.symbol": "記号",
        "password_management_settings.password_policy_setting.password_character_type.uppercase": "英大文字",
        "password_management_settings.password_policy_setting.password_length": "必須文字数",
        "permission": "Permission",
        "progress.candidate": "人材名を入力し候補から選択 ▼",
        "progress.candidate_correspondence_user": "自社人材対応者を選択して下さい▼",
        "progress.company": "会社名を入力し候補から選択 ▼",
        "progress.create_user": "登録者を選択して下さい▼",
        "progress.delete_all_this_progress": "この進捗をすべて削除する",
        "progress.delete_only_last_progress": "最新進捗のみを削除する",
        "progress.index.title": "進捗一覧",
        "progress.index.title_explain": "進捗の件数や詳細を検索できます",
        "progress.interviewer": "面接担当者を入力して下さい",
        "progress.interviewer_name": "面接担当者名",
        "progress.job": "求人見出しを入力し候補から選択 ▼",
        "progress.job_correspondence_user": "自社求人対応者を選択して下さい▼",
        "progress.select_step": "ステップを選択して下さい ▼",
        "progress.step_detail": "進捗内容を入力して下さい",
        "promotion_messages.free_recruit_to_product_upgrade": "マッチングッドのプレミアムプランをご存知ですか？\nプレミアムプランに切り替えることで、採用業務に必要な機能をプラスすることができます！",
        "release_notes.manual_click_here": "マニュアルはこちら",
        "release_notes.released": "をリリースしました。",
        "release_notes.title": "新機能",
        "release_notes.title_explain": "新機能のリリース情報を掲載していきます。現在、改装中です。",
        "report.exception.do_not_have_file": "ファイルが設定されていません。",
        "report.export_recommendation_report": "推薦状の出力",
        "report.file.export.auto": "出力",
        "report.file.export.pdf": "PDF出力",
        "report.file.upload.excel_extension": "対応拡張子はxls,xlsx,xlsmです。",
        "reports.basic_contract": "人材紹介基本契約書",
        "reports.business_report": "事業報告書",
        "reports.business_report.sheet_name_1": "様式第８号（第１面）",
        "reports.business_report.sheet_name_2": "様式第８号（第２面）",
        "reports.candidate_management_report": "求職管理簿",
        "reports.career_sheet": "キャリアシート",
        "reports.commission_management_report": "手数料管理簿",
        "reports.company_information": "企業情報",
        "reports.create_title": "帳票設定追加",
        "reports.details": "明細",
        "reports.edit_title": "帳票設定編集",
        "reports.greater_than_max_file_size": "100MB以内のファイルをアップロードしてください。",
        "reports.invoice": "請求書",
        "reports.invoice_staff_detail": "スタッフ明細",
        "reports.job_information": "求人情報",
        "reports.job_management_report": "求人管理簿",
        "reports.job_vote": "求人票",
        "reports.mismatch_excel_extension": "Excel形式のファイルをアップロードしてください。",
        "reports.radio_title_career": "職歴の出力順:",
        "reports.radio_title_educations": "学歴の出力順:",
        "reports.recommendation": "推薦状",
        "reports.resume": "JIS履歴書",
        "reports.resume_left": "左",
        "reports.resume_right": "右",
        "reports.select_file": "雛形ファイルを選択してください ▼",
        "reports.sheet_title.id_prefix.candidate": "人材番号",
        "reports.sheet_title.id_prefix.company": "会社番号",
        "reports.sheet_title.id_prefix.job": "求人番号",
        "reports.sheet_title.id_prefix.sale": "売上番号",
        "reports.template": "テンプレート",
        "reports.title": "帳票設定",
        "reports.title_explain": "帳票設定の編集や削除ができます",
        "reports_setting.add_mapping": "+設定項目を追加する",
        "reports_setting.add_reports": "帳票を新規追加",
        "reports_setting.cell_number_placeholder": "例)A3",
        "reports_setting.default_attendance_report": "デフォルトの請求\/支払帳票は削除\/複製できません。",
        "reports_setting.default_report": "デフォルトの帳票は編集できません。\n複製してから編集してください。",
        "reports_setting.deleted_report": "削除済みの帳票は編集できません。\n復元してから編集してください。",
        "reports_setting.error_cell_duplication": "シート内でセルアドレスが重複しています。",
        "reports_setting.error_cell_wrong": "セルアドレスの値が不正です。",
        "reports_setting.error_enter_cell": "セルアドレスを入力してください。",
        "reports_setting.error_not_selected_sheet": "帳票設定をするシートを選択してください。",
        "reports_setting.error_property_not_selected": "項目を選択してください",
        "reports_setting.error_reports_type": "帳票の種類を選択してください。",
        "reports_setting.error_upload_reports_template": "雛形となるファイルをアップロードしてください。",
        "reports_setting.explain_figure": "※図形の使用はできません。",
        "reports_setting.explain_school_career": "※学歴・職歴は、年度が新しいものから番号が振られます。",
        "reports_setting.file_name": "ファイル名(ドラッグ&ドロップで並び替え可能)",
        "reports_setting.reports_type": "帳票の種類",
        "reports_setting.reports_type_placeholder": "帳票の種類を選択してください▼",
        "reports_setting.reports_type_reselect": "帳票の種類を選び直す",
        "reports_setting.section_candidate_posting": "キャンディデイト票",
        "reports_setting.section_invoice": "請求書",
        "reports_setting.section_job_vote": "求人票",
        "reports_setting.sheet_name": "シート名",
        "reports_setting.spilt_placeholder": "例) 1",
        "reports_setting.this_sheet_setting": "帳票設定をするシート",
        "reports_setting.this_sheet_setting_placeholder": "帳票設定をするシートを選択してください▼",
        "reports_setting.title": "帳票設定",
        "reports_setting.title_explain": "帳票の設定ができます",
        "reports_setting.to_output": "に出力",
        "reports_setting.upload_reports_template": "雛形ファイルのアップロード",
        "resource_input.help_message.active.dispatch_organization_unit_id": "契約時の人材毎の抵触日が設定されていないため、自動入力は行われていません。",
        "resource_input.help_message.fixed.contracted_conflict_date": "抵触日サブリストで設定がある場合は自動的に日付が入ります。",
        "resource_input.help_message.fixed.detail_margin_ratio_publication": "※その他の方法での情報提供での有無が「有」の時に入力できます。",
        "resource_input.help_message.fixed.employment_agencies_license_code": "※民営職業紹介事業との兼業が「有」の場合に入力できます。",
        "resource_input.help_message.fixed.execution_piecework_contract": "※請負事業の実施が「有」の時に選択できます。",
        "resource_input.help_message.fixed.group_company_names": "<グループ企業の会社名 ：○○>という表記で備考に記載されます",
        "resource_input.help_message.fixed.has_knowledge": "※職務区分が「キャリアコンサルタント」の時は選択できません。",
        "resource_input.help_message.fixed.has_work_experience": "※職務区分が「キャリアコンサルタント」の時は選択できません。",
        "resource_input.help_message.fixed.performed_classification_type_id": "※実施日時を入力すると選択可能になります。",
        "resources.name_empty": "リソース名未登録",
        "resources.name_empty_with_id": "リソース名未登録（番号：{id}）",
        "resources.select_company": "{resource}の会社名を検索 ▼",
        "resources.select_dispatch_destination": "{resource}の派遣先を選択 ▼",
        "result_columns.records_too_few": "最低4件の項目を設定してください。",
        "resume.analysis.empty": "ファイルの内容が読み取れませんでした",
        "resume.analysis.female": "女性",
        "resume.analysis.label.entered_at.careers": "入社年月",
        "resume.analysis.label.entered_at.educations": "入学年月",
        "resume.analysis.label.exited_at.careers": "退社年月",
        "resume.analysis.label.exited_at.educations": "卒業年月",
        "resume.analysis.label.name.careers": "会社名",
        "resume.analysis.label.name.educations": "学校名",
        "resume.analysis.label.table_name.careers": "職歴",
        "resume.analysis.label.table_name.educations": "学歴",
        "resume.analysis.male": "男性",
        "resume.analysis_data": "履歴書・職務経歴書のデータ",
        "resume.analysis_data_button": "読み取り",
        "resume.analysis_data_explain": "ファイルの読み取りとは？",
        "resume.analysis_data_explain_tooltip": "履歴書・職務経歴書の内容を読み取り、マッチングッドのデータに登録できます。",
        "resume.analysis_data_reflection": "↓こちら側に入力のあるデータを登録します。",
        "resume.analysis_data_reflection_all": "チェック済データをまとめて反映",
        "resume.analysis_input": "反映",
        "resume.analysis_register": "登録予定のデータ",
        "resume.analysis_register_button": "プロフィールに登録",
        "resume.analysis_register_diasble": "登録予定のデータの内容を変更して下さい。",
        "resume.analysis_reset": "元のデータに戻す",
        "resume.analysis_title": "様の履歴書・職務経歴書のデータをプロフィールに登録",
        "resume.analysis_title_sub": "登録したいデータを右側の履歴書・職務経歴書のデータから反映させ、プロフィールに登録ボタンを押して下さい。",
        "resume.analysis_undo": "元のデータに戻す",
        "return.candidate_detail": "人材詳細に戻る",
        "return.candidates_detail": "人材詳細に戻る",
        "return.dispatch_job_detail": "派遣求人詳細に戻る",
        "return.dispatch_jobs_detail": "派遣求人詳細に戻る",
        "return.job_detail": "紹介求人詳細に戻る",
        "return.jobs_detail": "紹介求人詳細に戻る",
        "revisions.title": "更新履歴",
        "revisions.title_basic": "更新履歴（基本情報）",
        "revisions.title_free_item": "更新履歴（自由項目）",
        "roles.add_roles": "権限マスターを新規登録",
        "roles.basic_information_title": "基本情報",
        "roles.control": "操作",
        "roles.display_name": "権限マスター名称",
        "roles.full_access": "フルアクセス",
        "roles.items": "項目",
        "roles.not_authorized_message": "貴社内の管理者権限をお持ちの方にご確認ください。",
        "roles.partial_access": "一部アクセス",
        "roles.permitted_route_name": "許可項目",
        "roles.permitted_route_name.billing_destinations": "請求先",
        "roles.permitted_route_name.candidate_job_steps": "進捗",
        "roles.permitted_route_name.candidate_steps": "人材対応",
        "roles.permitted_route_name.candidates": "人材",
        "roles.permitted_route_name.companies": "会社",
        "roles.permitted_route_name.company_steps": "会社対応",
        "roles.permitted_route_name.contracts": "契約",
        "roles.permitted_route_name.dashboards": "ダッシュボード",
        "roles.permitted_route_name.data": "データ集計",
        "roles.permitted_route_name.data_reports": "法定帳票出力",
        "roles.permitted_route_name.dispatch_destinations": "派遣先",
        "roles.permitted_route_name.dispatch_jobs": "派遣求人",
        "roles.permitted_route_name.dispatch_organization_units": "派遣先組織単位",
        "roles.permitted_route_name.dispatch_staffs": "派遣先担当者",
        "roles.permitted_route_name.dispatch_working_places": "派遣先就業現場",
        "roles.permitted_route_name.jobs": "紹介求人",
        "roles.permitted_route_name.sales": "売上\/返金",
        "roles.permitted_route_name.staffs": "会社担当者",
        "roles.permitted_route_title": "データアクセスの権限",
        "roles.permitted_routes": "許可項目",
        "roles.permitted_tooltip": "許可項目とは？",
        "roles.permitted_tooltip_description": "対象項目に対して、以下の動作を許可します。",
        "roles.permitted_tooltip_table_row_content_csv": "CSVをダウンロードができます。",
        "roles.permitted_tooltip_table_row_content_delete_first_line": "削除の実行をすることができます。",
        "roles.permitted_tooltip_table_row_content_delete_second_line": "完全削除はアカウント管理者のみ可能です。",
        "roles.permitted_tooltip_table_row_item_csv": "CSV出力",
        "roles.permitted_tooltip_table_row_item_delete": "削除",
        "roles.permitted_tooltip_table_title_content": "許可される内容",
        "roles.permitted_tooltip_table_title_item": "許可項目",
        "roles.roles_all_select": "すべてを選択",
        "roles.roles_name": "権限名",
        "roles.setting": "各種設定",
        "roles.title": "権限マスター設定",
        "roles.title_explain": "権限マスターを追加、編集できます",
        "rooms.confirm.delete": "スケジュール項目を削除します。よろしいですか",
        "rooms.confirm_time_link": "参加者と部屋の空き時間を確認する",
        "rooms.create_success": "スケジュール項目を作成いたしました",
        "rooms.delete_success": "スケジュール項目を削除いたしました",
        "rooms.label": "部屋",
        "rooms.list": "▼空いている部屋",
        "rooms.not_availble": "すでに別の予定で使用されているため選択できません",
        "rooms.select": "利用する部屋を選択してください",
        "rooms.update_success": "スケジュール項目を更新いたしました",
        "route": "Route",
        "sales.add_installment_sales": "分割売上追加",
        "sales.add_sales": "新規売上追加",
        "sales.annual_income": "年収",
        "sales.basic_information_title": "基本情報",
        "sales.calculated_sales": "売上高",
        "sales.cancel_payment": "入金取消",
        "sales.cancel_refund": "返金取消",
        "sales.candidate_name": "人材名",
        "sales.change_history": "変更履歴",
        "sales.change_search_conditions": "検索条件を変更する",
        "sales.change_status": "ステータスを変更",
        "sales.checking_account": "当座",
        "sales.code": "コード",
        "sales.company_name": "入社会社",
        "sales.confirmation_payment": "入金確認",
        "sales.control": "操作",
        "sales.create_date": "売上情報登録日",
        "sales.day": "日",
        "sales.download_csv": "CSV出力",
        "sales.download_invoice": "請求書出力",
        "sales.download_refund_confirmation": "返金確認書出力",
        "sales.entrance_date": "入社日",
        "sales.excluding_tax_refund": "返金額(税抜)",
        "sales.excluding_tax_sales": "売上高(税抜)",
        "sales.fee_information_title": "料金情報",
        "sales.financial_institution_information": "金融機関情報",
        "sales.flat_fee": "定額手数料",
        "sales.id": "売上番号",
        "sales.import.title": "インポート(売上)",
        "sales.index.sub_title": "売上の検索、請求書出力ができます",
        "sales.information": "売上情報",
        "sales.memo": "メモ",
        "sales.none": "売上の登録がありません。",
        "sales.norefund": "返金なし",
        "sales.not_change_history": "変更履歴はありません",
        "sales.not_memo": "メモはありません",
        "sales.other_information": "その他",
        "sales.page_title_create": "売上\/返金登録",
        "sales.page_title_edit": "売上\/返金編集",
        "sales.payable_to_account_holder": "支払先口座名義",
        "sales.payable_to_account_number": "支払先口座番号",
        "sales.payable_to_branch_office": "支払先支店名",
        "sales.payable_to_financial_institution": "支払先金融機関名",
        "sales.payment": "入金額",
        "sales.payment_date": "入金日",
        "sales.payment_request_date": "支払依頼日",
        "sales.payment_schedule": "入金予定日",
        "sales.rates": "料率",
        "sales.refund": "返金",
        "sales.refund_all": "全体",
        "sales.refund_bank_account_category_id": "口座種別",
        "sales.refund_bank_branch": "支店名",
        "sales.refund_conditions": "返金条件",
        "sales.refund_date": "返金日",
        "sales.refund_edit": "返金入力",
        "sales.refund_fee": "固定返金額",
        "sales.refund_information": "返金情報",
        "sales.refund_method": "返金方法",
        "sales.refund_rate": "返金割合",
        "sales.refund_reason": "返金理由",
        "sales.refund_title": "返金額",
        "sales.refund_total": "返金額合計",
        "sales.refundable": "返金あり",
        "sales.register_sales": "売上に計上する",
        "sales.remarks_title": "備考",
        "sales.research_category": "調査方法",
        "sales.researched_at": "調査日",
        "sales.retired_information": "退職情報",
        "sales.retirement_confirmation_date": "退職確認日",
        "sales.retirement_confirmation_method": "退職確認方法",
        "sales.retirement_date": "退職日",
        "sales.round": "四捨五入",
        "sales.round_down": "切り捨て",
        "sales.round_down_ones_place": "一の位を切り捨て",
        "sales.round_down_tens_place": "十の位を切り捨て",
        "sales.round_up": "切り上げ",
        "sales.round_up_on_six": "五捨六入",
        "sales.rounding": "端数処理",
        "sales.sales_index_display": "売上一覧を表示する",
        "sales.sales_tax_refund": "返金額(税込)",
        "sales.savings_account": "普通",
        "sales.search": "検索結果を表示する",
        "sales.search_select_date": "日にちを指定",
        "sales.selected": "このページ内の売上{count}件が選択されています",
        "sales.selected_unregistered_sales_count": "このページ内の未登録売上{count}件が選択されています",
        "sales.sort_title": "並び替え",
        "sales.status": "ステータス",
        "sales.status_joined": "入社",
        "sales.status_registered": "売上計上",
        "sales.sub_title_create": "売上\/返金の登録ができます",
        "sales.sub_title_edit": "売上\/返金の編集ができます",
        "sales.sub_title_refund": "返金情報の入力ができます",
        "sales.sub_title_refund_edit": "返金情報の編集ができます",
        "sales.tax_included": "税込み",
        "sales.tax_included_sales": "売上高(税込)",
        "sales.tax_rate": "消費税率",
        "sales.title_search": "売上検索",
        "sales.total_payment": "入金",
        "sales.total_refund": "返金",
        "sales.total_sales": "売上高",
        "sales.total_sales_title": "合計金額(税込)",
        "sales.total_subtracted_sales": "返金差引売上高",
        "sales.total_unpayment": "未入金",
        "sales.unregistered.none": "未登録の売上はありません。",
        "sales.unregistered_display": "未登録の売上を表示する",
        "sales.unregistered_sub_title": "未登録の売上を計上できます",
        "sales.yen": "円",
        "schedule.calendar_close": "カレンダーを非表示にする",
        "schedule.calendar_open": "カレンダーを表示する",
        "schedule.can_not_editable.candidate_job_step": "面接のスケジュールを編集する際は対応進捗を編集してください。",
        "schedule.candidate_job_step": "面接",
        "schedule.click_register": "クリックで\nスケジュール登録",
        "schedule.create": "スケジュール新規登録",
        "schedule.date_no_input_placeholder": "日にちを指定",
        "schedule.date_no_input_placeholder.date": "日にちを指定",
        "schedule.date_no_input_placeholder.month": "年月を指定",
        "schedule.date_no_input_placeholder.time": "時分を指定",
        "schedule.day": "日",
        "schedule.delete_failed": "削除に失敗しました",
        "schedule.deleted": "削除しました",
        "schedule.empty": "部屋",
        "schedule.error_date_no_input": "開始日を選択してください",
        "schedule.error_time_overlaps": "別の予定と時間が重なっている参加者がいます",
        "schedule.month": "月",
        "schedule.name_of_business_company": "営業先会社名",
        "schedule.name_of_staff_business_company": "営業先担当者名",
        "schedule.not_avaliable_user_message": "この担当者はこの日時に別の予定が入っているため選択できません",
        "schedule.this_month": "今月",
        "schedule.today": "本日",
        "schedule.user": "社内担当者",
        "schedule.user_all_select": "すべてを選択",
        "schedule.user_search": "社員を検索",
        "schedule.visitor": "来客者",
        "schedule.visitor.butting": "直近の人材スケジュールを常に表示する（同社人材バッティング防止）",
        "schedule.visitor.freeCandidate": "来客者自由入力",
        "schedule_adjustment.adjustment_button_title": "面接の日程を調整する",
        "schedule_adjustment.adjustment_button_tooltip": "こちらから面接の日程調整ができます",
        "schedule_adjustment.all_select_clear": "選択を全解除",
        "schedule_adjustment.all_select_clear_dialog": "選択を全て解除してよろしいですか？",
        "schedule_adjustment.company_message": "メッセージ",
        "schedule_adjustment.confirm_message": "確認する",
        "schedule_adjustment.date_connection_start": "調整連絡をする",
        "schedule_adjustment.date_connection_title": "面接日程連絡",
        "schedule_adjustment.message_customary_epithet": "様の面接について、以下日程でご調整頂き、下記URLよりご予約ください。",
        "schedule_adjustment.message_in_url": "ここに日程調整URLが入ります。",
        "schedule_adjustment.reservation_dialog_message": "以下の内容で予約します。よろしいですか？",
        "schedule_adjustment.reservation_different_day": "上記日程以外で再調整を希望する",
        "schedule_adjustment.reservation_list_description": "1時間を超える予約は複数選択してください。",
        "schedule_adjustment.reservation_title_explain": "面接の日程を予約しましょう",
        "schedule_adjustment.select_balloon_title": "日程を調整する進捗",
        "schedule_adjustment.select_dates_title_explain": "面接の候補日を選択し、候補日連絡しましょう",
        "schedule_adjustment.selected_date": "選択した日程：",
        "schedule_adjustment.send_message_placeholder": "先方へのメッセージを入力してください。例)午前中が望ましいです。",
        "schedule_adjustment.send_message_title": "先方へのメッセージ：",
        "schedule_adjustment.send_to": "宛先：",
        "schedule_adjustment.start_adjustment": "調整開始",
        "schedule_adjustment.title": "面接日程調整",
        "schedule_adjustment.user": "参加する自社担当者を選択してください",
        "schedule_category.interview": "面接",
        "search_button.condition": "検索エリアへ移動",
        "search_criterion.date_format": "Y年n月j日",
        "search_criterion.month_format": "Y年n月",
        "search_storage.call_list.data": "追加日時",
        "search_storage.call_list.title": "タイトル",
        "sections.billing_destination.profile.main": "請求先詳細",
        "sections.billing_destination.profile.sub": "請求先詳細の確認ができます",
        "sections.candidate.conflict_date.main": "契約時の人材毎の抵触日",
        "sections.candidate.conflict_date.sub": "人材と組織単位の抵触日を登録・確認できます",
        "sections.candidate.contract.main": "契約",
        "sections.candidate.contract.sub": "この人材に紐づいている契約",
        "sections.candidate.file.main": "履歴書・職務経歴書など",
        "sections.candidate.file.sub": "書類の新規作成や、管理ができます",
        "sections.candidate.profile.main": "プロフィール",
        "sections.candidate.profile.sub": "人材情報の確認ができます",
        "sections.candidate.progress.main": "進捗",
        "sections.candidate.progress.sub": "選考状況や、紹介候補の求人の管理ができます",
        "sections.candidate.step.main": "対応",
        "sections.candidate.step.sub": "対応状況が時間軸で確認できます",
        "sections.common.step.main": "対応",
        "sections.common.step.sub": "対応状況が時間軸で確認できます",
        "sections.company.billing_destination.main": "請求先一覧",
        "sections.company.billing_destination.sub": "請求先一覧",
        "sections.company.branch.main": "会社に紐づく情報",
        "sections.company.branch.sub": "この会社に紐づいている事業所・会社担当・求人情報",
        "sections.company.data.main": "集計",
        "sections.company.data.sub": "この会社の各選考の通過率",
        "sections.company.dispatch_destination.main": "派遣先一覧",
        "sections.company.dispatch_destination.sub": "派遣先一覧",
        "sections.company.dispatch_job.main": "派遣求人情報",
        "sections.company.dispatch_job.sub": "この会社に紐づいている派遣求人情報",
        "sections.company.file.main": "契約書・資料など",
        "sections.company.file.sub": "書類の作成と管理",
        "sections.company.job.main": "紹介求人情報",
        "sections.company.job.sub": "この会社に紐づいている求人情報",
        "sections.company.photo.main": "画像",
        "sections.company.photo.sub": " ",
        "sections.company.profile.main": "会社詳細",
        "sections.company.profile.sub": "会社情報の確認ができます",
        "sections.company.progress.main": "進捗",
        "sections.company.progress.sub": "選考状況や、紹介候補の人材の管理ができます",
        "sections.company.staff.main": "会社担当者",
        "sections.company.staff.sub": "この会社の担当者(メールアドレスからメールを送信できます)",
        "sections.contract.contract_memo.main": "契約メモ",
        "sections.contract.contract_memo.sub": "この契約のメモ情報が確認できます",
        "sections.contract.file.main": "派遣契約\/管理など",
        "sections.contract.file.sub": "書類の新規作成や、管理ができます",
        "sections.contract.profile.main": "契約詳細",
        "sections.contract.profile.sub": "契約詳細の確認ができます",
        "sections.contract_memo.profile.main": "契約メモ",
        "sections.contract_memo.profile.sub": "契約メモ詳細の確認ができます",
        "sections.dispatch_destination.candidate_job_step_resource.main": "進捗",
        "sections.dispatch_destination.candidate_job_step_resource.sub": "この派遣先に紐づいている進捗",
        "sections.dispatch_destination.conflict_date.main": "抵触日",
        "sections.dispatch_destination.conflict_date.sub": "契約の抵触日が確認できます",
        "sections.dispatch_destination.contract.main": "契約",
        "sections.dispatch_destination.contract.sub": "この派遣先に紐づいている契約",
        "sections.dispatch_destination.dispatch_job.main": "派遣求人情報",
        "sections.dispatch_destination.dispatch_job.sub": "この派遣先に紐づいている派遣求人情報",
        "sections.dispatch_destination.dispatch_organization_unit.main": "組織単位",
        "sections.dispatch_destination.dispatch_organization_unit.sub": "この派遣先に紐づいている組織単位",
        "sections.dispatch_destination.dispatch_staff.main": "派遣先担当者",
        "sections.dispatch_destination.dispatch_staff.sub": "この派遣先の担当者",
        "sections.dispatch_destination.dispatch_working_place.main": "就業現場",
        "sections.dispatch_destination.dispatch_working_place.sub": "この派遣先に紐づいている就業現場",
        "sections.dispatch_destination.profile.main": "派遣先詳細",
        "sections.dispatch_destination.profile.sub": "派遣先詳細の確認ができます",
        "sections.dispatch_job.contracts.main": "契約",
        "sections.dispatch_job.contracts.sub": "この派遣求人に紐づく契約",
        "sections.dispatch_job.file.main": "派遣求人票など",
        "sections.dispatch_job.file.sub": "書類の新規作成や、管理ができます",
        "sections.dispatch_job.profile.main": "派遣求人の情報",
        "sections.dispatch_job.profile.sub": "この派遣求人の詳細情報など",
        "sections.dispatch_job.progress.main": "進捗",
        "sections.dispatch_job.progress.sub": "選考状況や、派遣候補の求人の管理ができます",
        "sections.dispatch_organization_units.profile.main": "組織単位詳細",
        "sections.dispatch_organization_units.profile.sub": "組織単位詳細の確認ができます",
        "sections.dispatch_source_staffs.profile.main": "派遣元担当者詳細",
        "sections.dispatch_source_staffs.profile.sub": "派遣元担当者詳細の確認ができます",
        "sections.dispatch_sources.profile.main": "派遣元詳細",
        "sections.dispatch_sources.profile.sub": "派遣元詳細の確認ができます",
        "sections.dispatch_sources.staffs.main": "派遣元担当者",
        "sections.dispatch_sources.staffs.sub": "この派遣元の担当者情報が確認できます",
        "sections.dispatch_staffs.profile.main": "派遣先担当者詳細",
        "sections.dispatch_staffs.profile.sub": "派遣先担当者詳細の確認ができます",
        "sections.dispatch_working_places.profile.main": "就業現場の情報",
        "sections.dispatch_working_places.profile.sub": "就業現場の連絡先など",
        "sections.job.data.main": "集計",
        "sections.job.data.sub": "この紹介求人の各選考の通過率",
        "sections.job.export.main": "CSV出力",
        "sections.job.export.sub": "出力設定媒体と、最終出力日時",
        "sections.job.file.main": "求人票など",
        "sections.job.file.sub": "書類の新規作成や、管理ができます",
        "sections.job.photo.main": "画像",
        "sections.job.photo.sub": "紹介求人画像をアップロードできます",
        "sections.job.profile.main": "紹介求人詳細",
        "sections.job.profile.sub": "紹介求人情報の確認ができます",
        "sections.job.progress.main": "進捗",
        "sections.job.progress.sub": "選考状況や、紹介候補の求人の管理ができます",
        "sections.job.share.profile.main": "共有求人詳細",
        "sections.job.share.profile.sub": "共有求人の取り込み・人材とのマッチングができます。",
        "sections.job.staff.main": "会社担当者",
        "sections.job.staff.sub": "この紹介求人の担当者",
        "sections.staff.profile.main": "会社担当者の情報",
        "sections.staff.profile.sub": "この会社担当者の連絡先や、部署など",
        "setting.alert": "アラート設定",
        "setting.alert_about": "※ダッシュボード・タスク・お知らせ画面に反映されます",
        "setting.alert_from": "より行って下さい",
        "setting.alert_setting_description": "対応や進捗に対するアラートを表示するタイミングや文言を設定できます。",
        "setting.alert_setting_index_title": "アラート設定",
        "setting.api_setting_description": "APIに紐づけられたクライアントの一覧です。",
        "setting.api_setting_index_title": "API設定",
        "setting.config_index_first_description": "自社の情報を登録できます。",
        "setting.config_index_second_description": "請求書を発行する際に、この設定で登録した内容を自動的に出力します。",
        "setting.config_index_title": "自社情報設定",
        "setting.display_setting_description": "ダッシュボードに表示する項目、検索条件や検索結果で表示する項目、進捗の種類の追加、会議などで使用する部屋の登録ができます。",
        "setting.display_setting_dispatch_master_description": "派遣業務で取り扱うマスターの設定・管理が行えます。",
        "setting.display_setting_dispatch_master_title": "派遣業務設定",
        "setting.display_setting_dispatch_source_description": "派遣元、派遣元担当者の設定・管理が行えます。",
        "setting.display_setting_dispatch_source_index_title": "派遣元設定",
        "setting.display_setting_homepage_description": "ホームページ連携の設定・管理が行えます。",
        "setting.display_setting_homepage_index_title": "ホームページ連携設定",
        "setting.display_setting_index_title": "表示項目設定",
        "setting.display_setting_line_description": "LINEの設定が行えます。",
        "setting.display_setting_line_title": "LINE設定",
        "setting.display_setting_master_description": "システム全体で利用されるマスターの設定・管理が行えます。",
        "setting.display_setting_master_title": "マスター設定",
        "setting.display_setting_matching_description": "各マッチング画面で呼び出す検索条件の設定・管理が行えます。",
        "setting.display_setting_matching_title": "マッチング設定",
        "setting.display_setting_mypage_description": "マイページの項目設定や、ユーザー管理が行えます。",
        "setting.display_setting_mypage_title": "マイページ設定",
        "setting.display_setting_myric_mypage_description": "招待メールのURLの管理が行えます。",
        "setting.display_setting_myric_mypage_title": "マイリクマイページ設定",
        "setting.display_setting_rule_master_description": "権限マスターの作成、編集ができます。",
        "setting.display_setting_rule_master_title": "権限マスター設定",
        "setting.display_setting_system_admin_tool_description": "system-admin-tool",
        "setting.display_setting_system_admin_tool_title": "【BL】システム管理画面",
        "setting.error": "予期せぬエラーが発生しました。設定を再度ご確認ください。",
        "setting.error_no_last_progress": "進捗サブリストは最新進捗を含む必要があります。",
        "setting.export_setting.bulk_setting_condition": "完全一致にする場合は「1」と入力してください。\n入れない場合は部分一致になります。",
        "setting.export_setting_description": "マッチングッドからCSVを出力する際の設定ができます。出力項目の順番の変更、出力するテキストの置換や連結ができます。",
        "setting.export_setting_index_title": "エクスポート設定",
        "setting.free_items_group": "選択肢設定",
        "setting.import_setting_first_description": "自作、または他媒体から出力したCSV、TSVファイルを取り込み、マッチングッドの項目と紐づけます。",
        "setting.import_setting_index_title": "インポート設定",
        "setting.reports_index_description": "オリジナルの帳票の作成、編集ができます。求人票や人材票などに対して、マッチングッドの項目と紐づけられます。",
        "setting.reports_index_title": "帳票設定",
        "setting.tab_add_btn": "+タブを追加",
        "setting.tab_add_title": "タブを新規追加",
        "setting.tab_delete": "このタブを削除する",
        "setting.tab_edit_title": "タブを編集",
        "setting.tab_name": "タブ名",
        "setting.title": "各種設定",
        "setting.title_explain": "帳票設定や自社情報設定などの設定ができます",
        "setting.users_index_description": "E-mailアドレスやログインパスワードなど、アカウント情報の変更ができます。",
        "setting.users_index_title": "アカウント情報設定",
        "share.acceptance_contact": "人材会社に合否連絡する",
        "share.acceptance_contact_description": "合格を選択すると書類選考を通過したことになります。",
        "share.acceptance_contact_reason_selection": "選考理由",
        "share.acceptance_contact_selection_result": "選考結果",
        "share.acceptance_contact_title": "に合否連絡します",
        "share.acceptance_re_contact": "人材会社に合否連絡を再送する",
        "share.candidate_file_save_failed": "ファイルの保存に失敗しました。",
        "share.jobs.deleted": "が削除されました。",
        "share.jobs.updated": "が更新されました。",
        "share.mail.subject.candidate_job_steps_continued": "【マッチングッド】推薦した共有求人の進捗が追加されました",
        "share.mail.subject.job_create": "【マッチングッド】求人が共有されました",
        "share.mail.subject.job_delete": "【マッチングッド】共有求人が削除されました",
        "share.mail.subject.job_update": "【マッチングッド】共有求人が更新されました",
        "share.mail.subject.recommend": "【マッチングッド】共有求人に推薦がありました",
        "share.recommend_mail.file_prompt": "履歴書を添付して下さい。",
        "share.recommendation_mail_basic_information_title": "基本情報",
        "share.recommendation_mail_send_create_title": "推薦メール作成",
        "share.recommendation_source_company": "推薦元",
        "share.recommended": "推薦済",
        "share.share_all_company": "全ての人材会社に共有する",
        "share.share_all_contracted_company": "全ての契約済み人材会社を選択する",
        "share.share_cancel": "共有を解除する",
        "share.share_contracted_company": "契約済みの人材会社に共有する",
        "share.share_label_mg": "MG経由",
        "share.share_setting": "共有設定",
        "share.shared_source_company": "共有元",
        "side.actual_amount_over_shorts": "過不足金",
        "side.agencies": "人材会社",
        "side.billing_destinations": "請求先",
        "side.candidate_career_counsellings": "キャリア相談",
        "side.candidate_education_and_trainings": "教育訓練",
        "side.candidate_employment_stability_measures": "雇用安定措置",
        "side.candidate_job_step_resources": "進捗表示",
        "side.candidate_step_resources": "人材対応表示",
        "side.candidate_steps": "対応",
        "side.candidates": "人材",
        "side.companies": "会社",
        "side.company_step_resources": "会社対応表示",
        "side.company_steps": "対応",
        "side.contracts": "契約",
        "side.create": "追加",
        "side.customize": "カスタマイズ",
        "side.dashboard": "ダッシュボード",
        "side.data": "データ",
        "side.data.index": "集計",
        "side.data.reports": "法定帳票出力",
        "side.dispatch_destinations": "派遣先",
        "side.dispatch_jobs": "派遣求人",
        "side.dispatch_organization_units": "組織単位",
        "side.dispatch_source_staffs": "派遣元担当者",
        "side.dispatch_sources": "派遣元",
        "side.dispatch_staffs": "派遣先担当者",
        "side.dispatch_working_places": "就業現場",
        "side.import": "インポート",
        "side.index": "一覧",
        "side.jobs": "求人",
        "side.payments": "支払",
        "side.progress": "進捗",
        "side.question": "よくある質問",
        "side.release_notes": "リリース情報",
        "side.sales": "売上\/返金",
        "side.staffs": "会社担当者",
        "side.upgrade": "製品のアップグレード",
        "side.upgrade_description": "有料版にアップグレードすると豊富な機能を利用することができます。",
        "side.upgrade_options": "オプション一覧",
        "staffs.bulk_mail": "一括送信",
        "staffs.company_name": "会社名",
        "staffs.department": "部署",
        "staffs.email": "Email",
        "staffs.export": "会社担当者一覧出力",
        "staffs.id": "番号",
        "staffs.import.title": "インポート(会社担当者)",
        "staffs.is_possible_bulk_mail": "一括メール送信可否",
        "staffs.list_back": "会社担当者一覧に戻る",
        "staffs.name": "氏名",
        "staffs.no_staff": "会社担当者は登録されていません",
        "staffs.portable_tel": "携帯",
        "staffs.post": "役職",
        "staffs.select_company": "担当者の会社名を検索 ▼",
        "staffs.show.staffs": "会社担当者詳細",
        "staffs.staff_list": "会社担当者一覧",
        "staffs.staff_name": "会社担当者名",
        "staffs.steps.no_steps_description": "対応履歴がございません。電話対応等を行ったときには右上のボタンよりメモを残して社内共有しましょう。",
        "staffs.tel": "電話",
        "table.logical_name.account_categories": "口座種別",
        "table.logical_name.agreement_employment_types": "協定対象労働者であるか否かの別",
        "table.logical_name.amount_over_short_types": "過不足金種別",
        "table.logical_name.amount_over_shorts": "過不足金マスター",
        "table.logical_name.attendance_types": "出勤区分",
        "table.logical_name.bill_types": "請求書種別",
        "table.logical_name.billing_destination_states": "請求先ステータス",
        "table.logical_name.boolean_approve_types": "承認可否",
        "table.logical_name.boolean_default_types": "可否",
        "table.logical_name.boolean_existence_types": "有無",
        "table.logical_name.cabinet_order_industry_types": "政令業種",
        "table.logical_name.candidate_job_step_states": "進捗状況",
        "table.logical_name.candidate_states": "人材状況",
        "table.logical_name.candidate_step_states": "対応状況",
        "table.logical_name.circumstances": "現況",
        "table.logical_name.company_states": "会社状況",
        "table.logical_name.company_step_states": "対応状況",
        "table.logical_name.contract_memo_types": "契約メモ種類",
        "table.logical_name.contract_states": "契約状況",
        "table.logical_name.date_only_types": "日種別",
        "table.logical_name.day_of_the_week_types": "曜日種別",
        "table.logical_name.departments": "部署",
        "table.logical_name.dispatch_destination_states": "派遣先ステータス",
        "table.logical_name.dispatch_job_states": "派遣求人ステータス",
        "table.logical_name.dispatch_job_types": "求人種別",
        "table.logical_name.dispatch_organization_unit_states": "組織単位ステータス",
        "table.logical_name.dispatch_source_staff_states": "派遣元担当者ステータス",
        "table.logical_name.dispatch_source_states": "派遣元ステータス",
        "table.logical_name.dispatch_staff_states": "派遣先担当者ステータス",
        "table.logical_name.dispatch_working_place_states": "就業現場ステータス",
        "table.logical_name.employment_categories": "雇用形態",
        "table.logical_name.expense_provision_types": "費用支給種別",
        "table.logical_name.fee_types": "手数料の種類",
        "table.logical_name.file_categories": "ファイル形式",
        "table.logical_name.fraction_processes": "端数処理マスター",
        "table.logical_name.fraction_rounding_types": "端数処理",
        "table.logical_name.industries": "業種",
        "table.logical_name.invoice_closed_invoice_states": "請求ステータス",
        "table.logical_name.is_target_over_age_60_types": "派遣労働者を無期雇用派遣労働者又は60歳以上の者に限定するか否かの別",
        "table.logical_name.job_states": "紹介求人状況",
        "table.logical_name.leave_time_types": "有給付与回数",
        "table.logical_name.locales": "ロケール",
        "table.logical_name.mail_receive_protocols": "メール受信プロトコル",
        "table.logical_name.mail_types": "メールタイプ",
        "table.logical_name.media": "求人媒体",
        "table.logical_name.monthly_types": "月種別",
        "table.logical_name.occupations": "職種",
        "table.logical_name.payment_closed_payment_states": "支払ステータス",
        "table.logical_name.payment_time_types": "支払サイト",
        "table.logical_name.prefectures": "都道府県",
        "table.logical_name.ranks": "ランク",
        "table.logical_name.receive_mail_states": "受信メール状況",
        "table.logical_name.repeat_interval_types": "繰り返す間隔種別",
        "table.logical_name.repeat_monthly_types": "繰り返す月種別",
        "table.logical_name.report_categories": "帳票カテゴリ",
        "table.logical_name.reports": "帳票",
        "table.logical_name.rooms": "部屋",
        "table.logical_name.roudoukyoku_categories": "労働局種別",
        "table.logical_name.rounding_types": "丸め込み種別",
        "table.logical_name.sale_states": "売上状況",
        "table.logical_name.schedule_categories": "スケジュールカテゴリー",
        "table.logical_name.school_categories": "学校区分",
        "table.logical_name.search_modes": "検索種別",
        "table.logical_name.send_mail_states": "送信メール状況",
        "table.logical_name.sexes": "性別",
        "table.logical_name.staff_states": "会社担当者ステータス",
        "table.logical_name.tax_rates": "消費税率",
        "table.logical_name.tax_rounding_types": "消費税端数処理",
        "table.logical_name.taxation_types": "課税種別",
        "table.logical_name.term_limit_types": "期間制限の対象外",
        "table.logical_name.time_rounding_types": "時間端数処理",
        "table.logical_name.timezones": "タイムゾーン",
        "table.logical_name.travel_expenses": "交通費",
        "table.logical_name.user_roles": "ユーザロール",
        "table.logical_name.wage_types": "給与分類",
        "table.logical_name.wages": "料金情報マスター",
        "table.logical_name.week_types": "週種別",
        "table.logical_name.yearly_working_day_types": "年間労働日数",
        "task.all_users": "全ての担当者",
        "task.body_placeholder": "タスクを入力してください",
        "task.completed": "タスクが完了しました",
        "task.create": "新規タスク作成",
        "task.create_success": "タスクの登録が完了しました",
        "task.create_with_this_content": "タスクを作成する",
        "task.delete_success": "タスクの削除が完了しました",
        "task.display_completed": "完了済タスクのみ表示",
        "task.edit_date_time": "予定日時",
        "task.edit_save": "編集を保存する",
        "task.error_body_no_input": "タスクの内容を入力してください",
        "task.error_no_select_name": "担当者を選択してください",
        "task.finished": "完了済み",
        "task.list_title_finished": "完了済みのタスク",
        "task.list_title_future": "今後のタスク",
        "task.list_title_no_date_time": "日付が未設定のタスク",
        "task.list_title_past": "過去のタスク",
        "task.list_title_today": "本日のタスク",
        "task.name": "自社担当者",
        "task.show_my_task": "自分のタスクを表示する",
        "task.unfinished": "未完了",
        "task.update_success": "タスクの編集が完了しました",
        "title.billing_destinations.index": "請求先一覧",
        "title.candidate_career_counsellings.index": "キャリア相談一覧",
        "title.candidate_education_and_trainings.index": "教育訓練一覧",
        "title.candidate_employment_stability_measures.index": "雇用安定措置一覧",
        "title.candidate_job_step_resources.index": "進捗一覧",
        "title.candidate_step_resources.index": "人材対応一覧",
        "title.candidate_steps.index": "人材対応一覧",
        "title.candidates.index": "人材一覧",
        "title.companies.index": "会社一覧",
        "title.company_step_resources.index": "会社対応一覧",
        "title.company_steps.index": "会社対応一覧",
        "title.conflict_date_managements.index": "抵触日一覧",
        "title.contracts.index": "契約一覧",
        "title.dispatch_destinations.index": "派遣先一覧",
        "title.dispatch_jobs.index": "派遣求人一覧",
        "title.dispatch_organization_units.index": "組織単位一覧",
        "title.dispatch_source_staffs.index": "派遣元担当者一覧",
        "title.dispatch_sources.index": "派遣元設定",
        "title.dispatch_staffs.index": "派遣先担当者一覧",
        "title.dispatch_working_places.index": "就業現場一覧",
        "title.jobs.index": "紹介求人一覧",
        "title.sales.index": "売上\/返金一覧",
        "title.staffs.index": "会社担当者一覧",
        "todo.month_1": "入社後1ヶ月要フォロー",
        "todo.month_3": "入社後3ヶ月要フォロー",
        "todo.month_6": "入社後6ヶ月要フォロー",
        "todo.progress": "未対応進捗",
        "todo.progress_description": "未対応の人材一覧です。対応メモを更新すると、一覧に表示されなくなります。",
        "todo.progress_list": "の未対応進捗一覧",
        "todo.select": "選考中要フォロー",
        "user_roles.administrative_privileges": "管理者権限",
        "user_roles.apiv2_privileges": "APIv2操作権限",
        "user_roles.general_privileges": "一般権限",
        "user_roles.system_administrative_privileges": "システム管理者権限",
        "users.account_not_delete": "自分のアカウントを削除することはできません",
        "users.add": "新規アカウントを追加する",
        "users.basic_information_title": "基本情報",
        "users.can_receive_mail_auto": "自動メール受信",
        "users.can_receive_mail_auto_off": "無効",
        "users.can_receive_mail_auto_on": "有効",
        "users.create": "アカウント追加",
        "users.create.sub_title": "アカウントの追加ができます",
        "users.deleted.display_name": "削除済み担当者",
        "users.department_id": "部署",
        "users.display_name": "氏名",
        "users.edit": "アカウント編集",
        "users.edit.sub_title": "メール設定やパスワード変更もできます",
        "users.email": "E-mailアドレス",
        "users.enabled": "就業状況",
        "users.enabled_not_change": "自分の就業状況を退職にすることはできません",
        "users.incumbent": "在職",
        "users.index.sub_title": "アカウント情報の追加や編集ができます",
        "users.index.title": "アカウント情報",
        "users.locale_id": "言語",
        "users.mail_explain_login": "※ログイン時及び、送信時のアドレスとして使用されます",
        "users.mail_explain_setting": "※MatchinGood上でメールの送受信をするためには、",
        "users.mail_explain_setting_last": "を行って下さい",
        "users.mail_oauth2": "認証",
        "users.mail_oauth2.authenticate": "こちらから認証を行ってください。",
        "users.mail_oauth2.failed": "認証コードが間違っています。再度認証に失敗する場合は、OAuth2の設定をご確認ください。",
        "users.mail_oauth2.invalid_token": "トークンが無効なため再認証してください。再度認証に失敗する場合は、OAuth2の設定をご確認ください。",
        "users.mail_oauth2.non_login_user": "ログインアカウントと異なるため認証できません。",
        "users.mail_oauth2.reauthenticate": "再認証を行う。",
        "users.mail_oauth2_client_id": "クライアントID",
        "users.mail_oauth2_client_secret": "クライアントシークレット",
        "users.mail_oauth2_code": "認証コード",
        "users.mail_oauth2_code.note": "※上記の認証コードを編集画面の該当の項目に入力して下さい。",
        "users.mail_oauth2_scope_type": "適用範囲",
        "users.mail_oauth2_tenant_id": "テナントID",
        "users.mail_oauth2_type": "OAuth2を使用",
        "users.mail_receive_protocol_id": "受信プロトコル",
        "users.mail_receive_setting": "受信メール設定",
        "users.mail_send_setting": "送信メール設定",
        "users.mail_setting": "メール設定",
        "users.name": "ログイン名",
        "users.password": "ログインパスワード",
        "users.password_confirm": "ログインパスワード(確認)",
        "users.pop_account": "POPアカウント",
        "users.pop_password": "POPパスワード",
        "users.pop_port": "POPポート番号",
        "users.pop_server": "POPサーバー",
        "users.retirement": "退職",
        "users.role_explain_setting": "※権限の新規追加・編集は、<a href=\"{url}\">権限設定画面<\/a>から行ってください",
        "users.role_id_disabled_screen": "自社情報設定 \/ エクスポート設定 \/ 項目設定 \/ 人材CSV出力 \/ 求人CSV出力 \/ ユーザー一覧表示 \/ ユーザー追加 \/ ユーザー削除",
        "users.role_id_important_point": "※一般権限を選択すると以下の操作ができません。",
        "users.signature": "署名",
        "users.smtp_account": "SMTPアカウント",
        "users.smtp_auth_method": "SMTP認証方式",
        "users.smtp_auth_method_fixed_value": "SMTP_AUTH",
        "users.smtp_encryption": "SMTP暗号化",
        "users.smtp_password": "SMTPパスワード",
        "users.smtp_port": "SMTPポート番号",
        "users.smtp_server": "SMTPサーバー",
        "users.timezone_id": "タイムゾーン",
        "users.title": "担当者",
        "users.title_all": "全ての担当者",
        "users.title_select": "担当者を選択 ▼",
        "users.user_role_id": "権限",
        "validation.accepted": "承認が必要です。",
        "validation.active_url": "無効なURLです。",
        "validation.after": "{date}以降の日付を入力してください。",
        "validation.after_or_equal": "{date}以降の日付を入力してください。",
        "validation.alpha": "英字で入力してください。",
        "validation.alpha_dash": "英数字とハイフンで入力してください。",
        "validation.alpha_num": "英数字で入力してください。",
        "validation.amount_over_short.required_repeat_end_condition": "max_repeat_timesかrepeat_end_dateのどちらかを入力してください。",
        "validation.amount_over_short_day.required": "曜日を1つ以上有効にしてください。",
        "validation.array": "複数選択してください。",
        "validation.before": "{date}以前の日付を入力してください。",
        "validation.before_or_equal": "{date}以下の日付を入力してください。",
        "validation.between.array": "{min}個から{max}個で入力してください。",
        "validation.between.file": "{min} KB以上{max} KB以下のファイルを選択してください",
        "validation.between.hour": "{min}分以上{max}分以下の時間を入力してください",
        "validation.between.numeric": "{min}以上から{max}以下の数字を入力してください。",
        "validation.between.string": "{min}文字から{max}文字で入力してください。",
        "validation.boolean": "不正な値です。",
        "validation.bulk.duplication": "{name}が重複しています。{parameters}",
        "validation.business_report.dispatch_source_id": "人材の派遣元が設定されていません。",
        "validation.candidate_education_and_trainings.contract_no_dispatch_source_id": "指定された契約の派遣元が設定されていません。",
        "validation.candidate_education_and_trainings.no_contract": "指定された人材と実施日時に対応する契約が存在しません。",
        "validation.candidate_education_and_trainings.no_education_training": "指定された教育訓練詳細に対応する教育訓練マスターが存在しません。",
        "validation.candidate_education_and_trainings.required.contract_id": "実施者が「派遣先」の時は該当する契約は必須項目です。",
        "validation.candidate_employment_stability_measures.contract_no_dispatch_source_id": "指定された契約の派遣元が設定されていません。",
        "validation.candidate_employment_stability_measures.no_contract": "指定された人材と実施日時に対応する契約が存在しません。",
        "validation.candidate_employment_stability_measures.required.contract_id": "実施した分類が「第1号」、または「第2号」の時は該当する契約は必須項目です。",
        "validation.candidate_employment_stability_measures.required.performed_classification_type_id": "実施日時を入力した時は実施した分類は必須項目です。",
        "validation.confirmed": "確認用項目と一致しません。",
        "validation.contract.dispatch_source_id": "派遣元が設定されていません。",
        "validation.contract.invalid_dispatch_period": "派遣期間は{days}日より多い必要があります。",
        "validation.custom.attribute-name.rule-name": "custom-message",
        "validation.date": "日付を入力してください。",
        "validation.date_format": "\"{format}\"形式で入力してください。",
        "validation.delete_resource_relation_mapping.alert_cannot_restoring_delete.candidate_job_step_resources": "削除した場合、進捗に関連するデータを復元することができなくなります。",
        "validation.delete_resource_relation_mapping.bulk": "関連する{childResourceDisplayNames}がある場合には、削除はされません。",
        "validation.delete_resource_relation_mapping.bulk.contracts": "勤怠締めされている勤怠がある場合には、削除はされません。",
        "validation.delete_resource_relation_mapping.child_resource_name.billing_destinations": "請求先",
        "validation.delete_resource_relation_mapping.child_resource_name.candidate_career_counsellings": "キャリア相談",
        "validation.delete_resource_relation_mapping.child_resource_name.candidate_education_and_trainings": "教育訓練",
        "validation.delete_resource_relation_mapping.child_resource_name.candidate_employment_placement_dispatches": "紹介予定派遣",
        "validation.delete_resource_relation_mapping.child_resource_name.candidate_employment_stability_measures": "雇用安定措置",
        "validation.delete_resource_relation_mapping.child_resource_name.candidate_job_step_resources": "進捗",
        "validation.delete_resource_relation_mapping.child_resource_name.candidate_steps": "人材対応",
        "validation.delete_resource_relation_mapping.child_resource_name.candidate_users": "自社人材担当者",
        "validation.delete_resource_relation_mapping.child_resource_name.career_counsellings": "キャリア相談",
        "validation.delete_resource_relation_mapping.child_resource_name.company_steps": "会社対応",
        "validation.delete_resource_relation_mapping.child_resource_name.company_users": "自社会社担当者",
        "validation.delete_resource_relation_mapping.child_resource_name.contract_memos": "契約メモ",
        "validation.delete_resource_relation_mapping.child_resource_name.contracts": "契約",
        "validation.delete_resource_relation_mapping.child_resource_name.dispatch_destinations": "派遣先",
        "validation.delete_resource_relation_mapping.child_resource_name.dispatch_job_users": "自社派遣求人担当者",
        "validation.delete_resource_relation_mapping.child_resource_name.dispatch_jobs": "派遣求人",
        "validation.delete_resource_relation_mapping.child_resource_name.dispatch_organization_units": "組織単位",
        "validation.delete_resource_relation_mapping.child_resource_name.dispatch_source_career_staffs": "キャリア相談担当者",
        "validation.delete_resource_relation_mapping.child_resource_name.dispatch_source_education_training_careers": "教育訓練マスター：キャリアアップ",
        "validation.delete_resource_relation_mapping.child_resource_name.dispatch_source_education_training_others": "教育訓練マスター：その他",
        "validation.delete_resource_relation_mapping.child_resource_name.dispatch_source_education_training_safeties": "教育訓練マスター：安全衛生教育",
        "validation.delete_resource_relation_mapping.child_resource_name.dispatch_source_staffs": "派遣元担当者",
        "validation.delete_resource_relation_mapping.child_resource_name.dispatch_staffs": "派遣先担当者",
        "validation.delete_resource_relation_mapping.child_resource_name.dispatch_working_places": "就業現場",
        "validation.delete_resource_relation_mapping.child_resource_name.education_and_trainings": "教育訓練",
        "validation.delete_resource_relation_mapping.child_resource_name.employment_placement_dispatches": "紹介予定派遣",
        "validation.delete_resource_relation_mapping.child_resource_name.employment_stability_measures": "雇用安定措置",
        "validation.delete_resource_relation_mapping.child_resource_name.job_users": "自社紹介求人担当者",
        "validation.delete_resource_relation_mapping.child_resource_name.jobs": "紹介求人",
        "validation.delete_resource_relation_mapping.child_resource_name.line_linked_candidates": "LINE紐づけ",
        "validation.delete_resource_relation_mapping.child_resource_name.sales": "売上",
        "validation.delete_resource_relation_mapping.child_resource_name.staffs": "会社担当者",
        "validation.delete_resource_relation_mapping.child_resource_name.users": "ユーザー",
        "validation.delete_resource_relation_mapping.force": "完全に削除した場合、関連するデータを復元することができなくなります。",
        "validation.delete_resource_relation_mapping.individual": "関連するデータがあるため削除できません。",
        "validation.delete_resource_relation_mapping.individual.contracts": "勤怠締めされている勤怠があるため削除できません。",
        "validation.delete_resource_relation_mapping.warning.contracts": "勤怠が登録されています。本当に削除しますか？",
        "validation.different": "{other}と同じです。",
        "validation.digits": "{digits}桁で入力してください。",
        "validation.digits_between": "{min}桁から{max}桁で入力してください。",
        "validation.email": "無効なメールアドレスです。",
        "validation.exists": "無効な値です。",
        "validation.filled": "必須項目です。",
        "validation.image": "画像を入力してください。",
        "validation.in": "無効な値です。",
        "validation.integer": "整数を入力してください。",
        "validation.ip": "無効なIPアドレスです。",
        "validation.max.array": "{max}個以下で入力してください。",
        "validation.max.file": "{max} KB以下のファイルを選択してください。",
        "validation.max.hour": "{max}時間以下で入力してください。",
        "validation.max.numeric": "{max}以下の数字を入力してください。",
        "validation.max.string": "{max}文字以下で入力してください。",
        "validation.mimes": "{values}ファイルを選択してください。",
        "validation.min.array": "{min}個以上を入力してください。",
        "validation.min.file": "{min} KB以上のファイルを選択してください。.",
        "validation.min.numeric": "{min}以上の数字を入力してください。",
        "validation.min.string": "{min}文字以上で入力してください。",
        "validation.not_in": "無効な値です。",
        "validation.not_space": "空白は入力できません。",
        "validation.numeric": "数字を入力してください。",
        "validation.read_only_occurance_date": "勤怠締めされている日付は変更できません。",
        "validation.regex": "書式が正しくありません。",
        "validation.required": "必須項目です。",
        "validation.required_if": "{other}が{value}の場合、必須となります。",
        "validation.required_with": "{values}を入力された場合、必須となります。",
        "validation.required_with_all": "{values}のすべてを入力された場合、必須となります。",
        "validation.required_without": "{values}を入力されない場合、必須となります。",
        "validation.required_without_all": "{values}のすべてを入力されない場合、必須となります。",
        "validation.resource_model_not_found": "idが{id}の{name}が見つかりません。",
        "validation.restore_resource_relation_mapping.individual": "関連するデータが削除されているため復元できません。",
        "validation.same": "{other}と一致しません。",
        "validation.size.array": "最大{size}個以下で入力してください。",
        "validation.size.file": "{size} KB以下のファイルを選択してください。.",
        "validation.size.numeric": "{size}以下の数字を入力してください。",
        "validation.size.string": "{size}文字以下で入力してください。",
        "validation.string": "文字列で入力してください。",
        "validation.timezone": "タイムゾーンが不正です。",
        "validation.unique": "既に存在する{attribute}です。",
        "validation.url": "無効なURLです。"
    },
    "ja_recruit": {
        "auth.login": "ログイン(採用管理版)",
        "breadcrumbs.candidates.create": "応募者登録",
        "breadcrumbs.candidates.duplicate": "重複応募者",
        "breadcrumbs.candidates.edit": "応募者編集",
        "breadcrumbs.candidates.import": "応募者インポート",
        "breadcrumbs.candidates.index": "応募者一覧",
        "breadcrumbs.candidates.indexTrashed": "応募者一覧(ゴミ箱)",
        "breadcrumbs.candidates.matching": "応募者マッチング",
        "breadcrumbs.candidates.show": "応募者詳細",
        "breadcrumbs.candidates.showMerge": "応募者データ統合",
        "breadcrumbs.candidates.showTrashed": "応募者詳細",
        "breadcrumbs.dashboard_candidates": "ダッシュボード(応募者)",
        "candidate_job_steps": "応募者求人の進捗",
        "candidate_job_steps.candidate_id": "応募者",
        "candidate_job_steps.find_candidate": "この求人に合う応募者を探す",
        "candidate_job_steps.find_job": "この応募者に合う求人を探す",
        "candidate_steps": "応募者の進捗",
        "candidate_steps.candidate_id": "応募者ID",
        "candidate_steps.candidate_step_state_id": "応募者ステータス",
        "candidate_steps.mail_id": "メールID（応募者ステータスがメールの場合）",
        "candidates.deleted.name": "(削除済み応募者)",
        "candidates.image_change": "応募者画像の変更",
        "candidates.import.title": "インポート(応募者)",
        "candidates.list_back": "応募者一覧に戻る",
        "candidates.merge.duplicate_id": "応募者番号",
        "candidates.none": "応募者の登録がまだありません。",
        "candidates.photo_alternative_text": "応募者の写真",
        "candidates.start_matching_job_with_candidate": "希望条件に合う応募者を探す",
        "candidates.title_create": "応募者新規登録",
        "candidates.title_edit": "応募者編集",
        "candidates.title_index": "応募者検索結果",
        "candidates.title_search": "応募者検索",
        "common.candidates": "応募者",
        "common.candidates_name": "応募者",
        "common.duplicate_button": "重複している応募者データがあります！",
        "common.no_assign_user.candidate": "担当者未設定の応募者のみ表示",
        "companies.start_matching_candidate_with_job": "希望条件に合う応募者を探す",
        "dashboard.candidate_user": "応募者担当",
        "dashboard.none.add_candidate": "応募者を新規追加",
        "dashboard.none.candidate_step": "応募者の登録がまだありません。",
        "dashboard.popup.candidate_name": "応募者",
        "dashboard.popup.find_job": "この応募者に合う求人を探す",
        "dashboard.search_placeholder": "応募者名、会社名、求人番号など",
        "dashboard.title.candidates": "応募者進捗",
        "export.setting_candidate_csv": "応募者CSV ▼",
        "export.setting_example_suffix": "+  様 など",
        "export.setting_subtext_candidate": "「応募者一覧」のCSV出力ボタンからダウンロードできます。",
        "mails.bulk.step1_candidates": "送信予定の応募者を確認",
        "mails.bulk.step1_staffs": "送信予定の人材会社担当者を確認",
        "mails.popup.candidate.receive": "応募者から",
        "mails.popup.candidate.send": "応募者へ",
        "mails.send.email_kind_candidate_office": "応募者 \/ 会社",
        "mails.send.email_kind_candidate_pc": "応募者 \/ PC",
        "mails.send.email_kind_candidate_portable": "応募者 \/ 携帯",
        "menu.create.candidate": "応募者新規登録",
        "menu.freeword.candidate": "応募者",
        "notificationCategories.addCandidateStep": "応募者対応更新",
        "notificationCategories.assignCandidate": "応募者のアサイン",
        "page_title.candidates.create": "応募者登録",
        "page_title.candidates.edit": "%1$sさんの応募者編集",
        "page_title.candidates.import": "応募者インポート",
        "page_title.candidates.index": "応募者一覧",
        "page_title.candidates.matching": "応募者マッチング",
        "page_title.candidates.show": "%1$sさんの応募者詳細",
        "page_title.dashboard_candidates": "ダッシュボード(応募者)",
        "progress.candidate": "応募者を選択して下さい",
        "progress.interviewer_name": "面接担当者",
        "reports.basic_contract": "応募者紹介基本契約書",
        "reports.sheet_title.id_prefix.candidate": "応募者番号",
        "sales.candidate_name": "応募者名",
        "sales.candidate_staff": "応募者担当者",
        "schedule.visitor.butting": "直近の応募者スケジュールを常に表示する（同社応募者バッティング防止）",
        "sections.company.progress.sub": "選考状況や、紹介候補の応募者の管理ができます",
        "side.candidates": "応募者",
        "staffs.company_name": "人材会社名",
        "users.role_id_disabled_screen": "自社情報設定 \/ CSV出力設定 \/ 項目設定 \/ 応募者CSV出力 \/ 求人CSV出力 \/ ユーザー一覧表示 \/ ユーザー追加 \/ ユーザー削除"
    },
    "chs": {
        "common.email": "电子邮件",
        "common.logout": "注销",
        "common.manipulation": "操作",
        "user_roles.administrative_privileges": "管理员权限",
        "user_roles.general_privileges": "一般授权",
        "users.display_name": "全名",
        "users.edit": "该负责人设置",
        "users.email": "电子邮件",
        "users.locale_id": "语言",
        "users.name": "登录名",
        "users.password": "密码",
        "users.password_confirm": "密码确认",
        "users.timezone_id": "时区",
        "users.title": "该负责人",
        "users.user_role_id": "权威"
    }
}
